// #region import
import { useRef, useState, useEffect, useContext, useLayoutEffect, useCallback, SetStateAction } from "react";
//import * as jQuery from 'jquery'; 
import { FocusTrap } from 'focus-trap-react';
import jsPDF from 'jspdf'
import { preloadFontsForMessages, isChinese, isKorean, isArabic } from "../../utils/fontLoader";
import { clearSessionToken, getB2CClaims, getAccessToken } from "../../utils/token";
import { hasAssignedProgram } from "../../utils/externalProgram";

// import { initTranslate } from "../../google-translate/translate";
import { CommandBarButton, IconButton, Dialog, DialogType, Stack, StackItem, Spinner, SpinnerSize } from "@fluentui/react";
 
import { ShieldLockRegular, ErrorCircleRegular, ChevronLeft12Filled, ChevronDown16Filled, CopyRegular, Person16Filled } from "@fluentui/react-icons";
import MediaQuery from "react-responsive";
import { SessionStorage } from "./SessionStorage";
import ReactMarkdown from "react-markdown";
import remarkGfm from 'remark-gfm'
import rehypeRaw from "rehype-raw";
import supersub from 'remark-supersub'
import { v4 as uuidv4 } from 'uuid';
import { setIconOptions } from '@fluentui/react/lib/Styling';
import styles from "./Chat.module.css";
import { isEmpty, isUndefined } from "lodash-es"; 
import { OverflowDrawer } from "../../assets/OverflowDrawer";
// import CopyIcon from "../../assets/copyResp.svg"
import WidgetIcon from "../../assets/widget.png"
import { NewWindowIcon } from "../../assets/newWindow";
import { OpenDocIcon } from "../../assets/openDoc";
import WorldIcon  from "../../assets/Worldgr"
import { CloseIcon } from "../../assets/closeIcon"
import { FeedbackIcon } from "../../assets/feedbackIcon"
import { DownloadIcon } from "../../assets/downloadIcon"
import { ClearIcon } from "../../assets/clearIcon"
import { SubmitRequestIcon } from "../../assets/SubmitRequest"
import { closeIconCitation } from "../../assets/closeIconCitation"
import { downArrowIcon } from "../../assets/DownArrowIcon"
import { upArrowIcon } from "../../assets/UpArrowIcon"
import { Visibility } from "../../assets/visibility";
import { VisibilityOff } from "../../assets/visibility_off";
import { chevronRightIcon } from "../../assets/chevronRightIcon"
import { ExpandIcon } from "../../assets/expand"
import { MinimizeIcon } from "../../assets/minimize"
import { RestoreDown } from "../../assets/restoreDown";
import { Search } from "../../assets/Search";
import SlidingPane from "react-sliding-pane";
import "../../customcss/custom-react-sliding-pane.css";
import "../../customcss/custom-google-translate.css";
import { Popover } from 'react-tiny-popover'
import DOMPurify from 'dompurify';
import { XSSAllowTags } from "../../constants/sanitizeAllowables"; 
  
import LightModeIcon from "../../assets/lightMode";
import DarkModeIcon from "../../assets/darkMode";
import KnowledgeIcon from "../../assets/KnowledgeIcon"
import ReleaseNotesIcon from "../../assets/ReleaseNotesIcon"
import ReturnToAdminIcon from "../../assets/ReturnToAdminIcon"
import PBIIcon from "../../assets/PBI"
import { PowerBIOverlay } from "../../components/PowerBIOverlay/PowerBIOverlay";
import { usePowerBIEmbed } from "../../hooks/usePowerBIEmbed";
import { SignIn } from "../../assets/SignIn";
import {
    FeedbackEnum, ChatMessage, FeedbackMessage, ConversationRequest, FeedbackRequest, Citation,
    ToolMessageContent, ChatResponse, getUserInfo, Conversation, historyGenerate, feedbackGenerate, historyUpdate,
    historyLogError, historyClear, ChatHistoryLoadingState, CosmosDBStatus, ErrorMessage, messageStatus, requestTTS, signOnValidate, validateIVRCredentials, getIVRInformationTemplate, FrontendSettings, refreshfrontendSettings, ExecResults, AzureSqlServerExecResults, ChatAppResponse, ResponseChoice, ResponseContext, pii_redaction, summaryGenerate, ExpandedSections, fetchCSSConfig, getBlobList
} from "../../api";
import { Answer } from "../../components/Answer";
import { QuestionInput } from "../../components/QuestionInput";
import { Feedback } from "../../components/Feedback";
import { GoogleTranslate, TranslationStrings, getTranslatedText } from "../../components/GoogleTranslate";
import { ChatHistoryPanel } from "../../components/ChatHistory/ChatHistoryPanel";
import { AppStateContext } from "../../state/AppProvider";
import { useBoolean } from "@fluentui/react-hooks";
import classnames from 'classnames'; 
import { DropDown } from "../../components/DropDown";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { nord } from 'react-syntax-highlighter/dist/esm/styles/prism'
import stringSimilarity from 'string-similarity';
import Loading from "../../components/common/Loading";
import Verified from "../../components/common/Verified";
import CaseDropdown from "../../components/Profile/CaseDropdown";
import ProfilePanel from "../../components/Profile/ProfilePanel";
import ProfileRemoveConfirmDialogs, { RemoveCaseConfirm, RemoveProgramConfirm } from "../../components/Profile/ProfileRemoveConfirmDialogs";
import KnowledgeDropdown, { KnowledgeDropdownRef } from "../../components/DropDown/KnowledgeDropdown";
import { ScrollToTop } from "../../assets/ScrollToTop";
import SkipTo from '../../components/SkipTo/SkipTo';
import SlidingBox from "../../components/SlidingBox/SlidingBox";
import debounce from 'debounce';
import { useB2CAuth } from "../../hooks/useB2CAuth";
import { B2CAuthGate } from "../../components/B2CAuthGate/B2CAuthGate";

// #endregion

// #region const

let chatUUID = '';
let promptTokenCount = 0;
let id = '';
let date: Date= new Date();
let dt1 = date.toLocaleTimeString([], {hour: 'numeric', minute: '2-digit', hour12: true}) ;
let dt2 = dt1;
const sessionStorage = new SessionStorage();
let headerClass = classnames(styles.headerTitle, "notranslate");
let headerDDClass = classnames(styles.headerDD, "notranslate");
let copyRight = classnames(styles.copyRight,"notranslate")
let modalProfileCopyright = classnames(styles.modalProfileCopyright,"notranslate")
let closeX = classnames(styles.spActionTitle, "notranslate")
let closeXOther = classnames(styles.spActionTitleOther, "notranslate")
let closeXModalProfile = classnames(styles.modalProfileClose, "notranslate")
let closeXModalProfileTranslatable = classnames(styles.modalProfileClose) // Without notranslate for knowledge base close
let closeXCitation = classnames(styles.spActionTitleCitation, "notranslate")
let closeXLangModal = classnames(styles.langModalX, "notranslate")
 
// #endregion

// #region Chat
const Chat = () => {
    // #region chat const
    const [isStopped, setIsStopped] = useState<boolean>(false);
    const hasStoppedGenerating = useRef(false);
    const [partiallyRenderedText, setPartiallyRenderedText] = useState("");
    const [isCautionModalPanelOpen, setIsCautionModalPanelOpen] = useState<boolean>(false);
    const [isPrivacyPolicyModalPanelOpen, setIsPrivacyPolicyModalPanelOpen] = useState<boolean>(false);
    const [showWidget, setShowWidget] = useState<boolean>(false);
    const [showTelephonyWidget, setShowTelephonyWidget] = useState<boolean>(false);
    const [showCopilotWidget, setShowCopilotWidget] = useState<boolean>(false);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const [isUserTermsModalPanelOpen, setIsUserTermsModalPanelOpen] = useState<boolean>(false);
    const [isMyInformationPanelOpen, setIsMyInformationPanelOpen] = useState<boolean>(false);
    const [isDarkMode, setIsDarkMode] = useState<boolean>(false);
    const isDarkModeRef = useRef(isDarkMode);
    const lastQuestionRef = useRef<string>("");
    const appStateContext = useContext(AppStateContext)
    const AUTH_ENABLED = appStateContext?.state.frontendSettings?.auth_enabled === "true" ;
    var branding = appStateContext?.state.frontendSettings?.branding;
    var settings = appStateContext?.state.frontendSettings;
    const hasInternalPrograms = appStateContext?.state.frontendSettings?.has_internal_programs === true;
    const { msalInstance, b2cAuthResponse } = appStateContext?.state || {};
   
    const chatMessageStreamEnd = useRef<HTMLDivElement | null>(null);
    const chatStreamContainerRef = useRef<HTMLDivElement | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDone, setIsDone] = useState<boolean>(true);
    const [showLoadingMessage, setShowLoadingMessage] = useState<boolean>(false);
    const [activeCitation, setActiveCitation] = useState<Citation>();
    const [isCitationPanelOpen, setIsCitationPanelOpen] = useState<boolean>(false);
    const citation_inputfield_character_limit = branding?.citation_inputfield_character_limit && branding.citation_inputfield_character_limit.trim() !== '' ? parseInt(branding?.citation_inputfield_character_limit) : undefined;
    const abortFuncs = useRef([] as AbortController[]);
    const [showAuthMessage, setShowAuthMessage] = useState<boolean>(false);
    const [messages, setMessages] = useState<ChatMessage[]>([])
    const [processMessages, setProcessMessages] = useState<messageStatus>(messageStatus.NotRunning);
    const [clearingChat, setClearingChat] = useState<boolean>(false);
    const [hideErrorDialog, { toggle: toggleErrorDialog }] = useBoolean(true);
    const [showPgmMessage, setShowPgmMessage] = useState<boolean>(false);
   
    const [errorMsg, setErrorMsg] = useState<ErrorMessage | null>() 
    const [isIntentsPanelOpen, setIsIntentsPanelOpen] = useState<boolean>(false)
    const [execResults, setExecResults] = useState<ExecResults[]>([])
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [isFAQPaneOpen, setIsFAQPaneOpen] = useState(false);
    const [isProfilePaneOpen, setIsProfilePaneOpen] = useState(false);
    const [isAdminOverlayOpen, setIsAdminOverlayOpen] = useState<boolean>(false);
    const [hasOpenedAdmin, setHasOpenedAdmin] = useState<boolean>(false);
    const [adminIframeLoaded, setAdminIframeLoaded] = useState<boolean>(false);
    const openAdminOverlay = () => { setIsAdminOverlayOpen(true); setHasOpenedAdmin(true); };
    const handleAdminIconClick = () => {
        if (window.self !== window.top) {
            // Inside Admin's overlay — tell Admin to close PriyaMain overlay
            window.parent.postMessage({ type: "ADMIN_CLOSE_PRIYA" }, "*");
        } else if (isAdminOverlayOpen) {
            setIsAdminOverlayOpen(false);
        } else {
            openAdminOverlay();
        }
    };
    const [isNewConv, setIsNewConv] = useState(true);
    const [text1, setText1] = useState<string>("");
    const [text2, setText2] = useState<string>("");
    const [text3, setText3] = useState<string>("");
    const [text4, setText4] = useState<string>("");
    const [text5, setText5] = useState<string>("");
    const [text5Error, setText5Error] = useState<string>("");
    
    const [showDropDown, setShowDropDown] = useState<boolean>(false);
    const [selectPgm, setSelectPgm] = useState<string>("");
    const [selectPgmCode, setSelectPgmCode] = useState<string>("");
    const [selectPrevPgm, setSelectPrevPgm] = useState<string>("");
    const [selectPrevPgmCode, setSelectPrevPgmCode] = useState<string>("");
    const [configCode, setConfigCode] = useState<string>("");
    const [prevConfigCode, setPrevConfigCode] = useState<string>("");

    const powerBI = usePowerBIEmbed(configCode);

    const [showTranslate, setShowTranslate] = useState<boolean>(false);
    const [answers, setAnswers] = useState<[user: string, response: ChatAppResponse][]>([]);   
    const [speechUrls, setSpeechUrls] = useState<(string | null)[]>([]);
    const fList = branding?.faqList ? branding?.faqList : [{ "question": "", "answer": "", "requiresAuth": "N", "authType": "", "authFields": "", "subSectionId": "" }];
    const sList = branding?.subsectionsList ? branding?.subsectionsList : [{"id": "", "isActive": "", "programCode": "", "subSection": "", "subSectionOrder": "",}];
    const [expandedSections, setExpandedSections] = useState<ExpandedSections>({});
    const [expandedProfileSections, setExpandedProfileSections] = useState<ExpandedSections>({});
    const pList = branding?.pgmList?.length ? branding?.pgmList : ["<>"];
    const showFollowupQuestions = branding?.followup_questions_enabled === "Y" ? true : false;
    const [showAuthDialogMessage, setShowAuthDialogMessage] = useState<boolean>(false);
    const [authFields, setauthFields] = useState<string>("");
    const [authFieldsVal, setauthFieldsVal] = useState<{ [key: string]: string }>({});
    const [caseInputFieldsVal, setCaseInputFieldsVal] = useState<string>("");
    const [casesVal, setCasesVal] = useState<string>("");
    const [caseNumbersAndNamesVal, setCaseNumbersAndNamesVal] = useState<string>("");
    const [memberFirstNames, setMemberFirstNames] = useState({});
    const [profilePaneData, setProfilePaneData] = useState<any>({});
    const isProfileDataLoaded = () => profilePaneData && Object.keys(profilePaneData).length > 0;
    const [selectedProfileSection, setSelectedProfileSection] = useState<string | null>(null);
    const [activeCase, setActiveCase] = useState<string>("");
    const [selectedDropdownCase, setSelectedDropdownCase] = useState(activeCase);
    const [authTypeV, setauthType] = useState<string>("");
    const [questionV, setQuestionV] = useState<string>(""); 
    const [isFaqV, setIsFAQV] = useState<string>("");
    const authTypeVRef = useRef(authTypeV);
    const [isSSNVisible, setIsSSNVisible] = useState<boolean>(false);
    const [isDOBVisible, setIsDOBVisible] = useState<boolean>(false);

    // Per-program feature flag for showing the profile panel
    const enableProfilePanel = branding?.show_profile_panel === "Y";

    const [isCancelled, setIsCancelled] = useState(false);
    const [isAudio, setIsAudio] = useState(false);
    const [ThankYouMessagePayload, setThankYouMessagePayload] = useState<string>("");    
    const [showThankYouMessage, setShowThankYouMessage] = useState(false);

    const [popUpBlocker, setPopUpBlocker] = useState<boolean>(false);
    const [configLanguages, setConfigLanguages] = useState<string>("");

    const [isInIframe, setIsInIframe] = useState<boolean>(false); 
    const [iframeStyles, setIframeStyles] = useState<React.CSSProperties>({});
    const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
    const isContentInsideIframeWindow = window.self !== window.top;

    const [transcript, setTranscript] = useState<string>("");
    const [showLiveChat, setshowLiveChat] = useState<boolean>(false);
    const transcriptRef = useRef(transcript);
    const showLiveChatRef = useRef(showLiveChat);

    const authFieldsValRef = useRef<{ [key: string]: string }>({});
    const updateAuthFieldsVal = useCallback((updater: SetStateAction<{ [key: string]: string }>) => {
      const currentAuthFieldsVal = authFieldsValRef.current;
      const nextAuthFieldsVal = typeof updater === "function" ? updater(currentAuthFieldsVal) : updater;

      authFieldsValRef.current = nextAuthFieldsVal;
      setauthFieldsVal(nextAuthFieldsVal);
    }, []);
    const [isSignOnInProgress, setIsSignOnInProgress] = useState(false);
   
    const [isSignInPopoverOpen, setIsSignInPopoverOpen] = useState(false);
    const [caseSelectDialogOpen, setCaseSelectDialogOpen] = useState(false);
    const [addCaseDialogOpen, setAddCaseDialogOpen] = useState(false);
    const [removeProgramConfirm, setRemoveProgramConfirm] = useState<RemoveProgramConfirm>(null);
    const [removeCaseConfirm, setRemoveCaseConfirm] = useState<RemoveCaseConfirm>(null);
    const [addCaseDialogSource, setAddCaseDialogSource] = useState<"profile" | "auth">("profile");
    const [convidRef, setConvidRef] = useState<string>("");
    const convidRefVal = useRef(convidRef);
    
    const [showLiveFlow, setshowLiveFlow] = useState<boolean>(false);
    const showLiveFlowRef = useRef(showLiveFlow);
    const [startCopilotFlow, setstartCopilotFlow] = useState<string>("");
    const [copilotFlowContext1, setCopilotFlowContext1] = useState<string>("");
    const startCopilotFlowRef = useRef(startCopilotFlow);
    const copilotFlowContext1Ref = useRef(copilotFlowContext1);
    const [copilotFormData, setCopilotFormData] = useState<any>({});
    const ivrAuthEnabled = fList.some(faq => faq.requiresAuth === "Y" && faq.authType === "msivr");
    const ivrAuthFields = fList.find(faq => faq.requiresAuth === "Y" && faq.authType === "msivr")?.authFields;
    const caseDbAuthType = fList.find(faq => faq.requiresAuth === "Y" && faq.authType === "profilecasedb")?.authType ?? "";

    const [knowledgeBaseOpen, setKnowledgeBaseOpen] = useState<boolean>(false);
    const [selectedDocument, setSelectedDocument] = useState<string>("");
    const [selectedDocumentLink, setSelectedDocumentLink] = useState<string>("");
    const knowledgeDropdownRef = useRef<KnowledgeDropdownRef>(null);
    const [kbDocUrls, setKbDocUrls] = useState<Map<string, string>>(new Map());
    const [releaseNotesOpen, setReleaseNotesOpen] = useState<boolean>(false);

    const [showPageLoading, setShowPageLoading] = useState(false);

    const agentName = branding?.agent_name ? branding?.agent_name : "";

    const b2cClaims = getB2CClaims(b2cAuthResponse);
    const {
        handleB2CSignIn,
        handleIframeSignIn,
        handleB2CSignOut,
        handleInternalProgramAssignment,
        handleExternalProgramAssignment,
        handleExternalProgramRemoval,
        handleCaseRemoval,
        handleB2CProfileEdit,
    } = useB2CAuth({ setPopUpBlocker });

    const readPendingAuthRequest = (): {
      question: string;
      isFaq: string;
      answer: string;
      requiresAuth: string;
      authType: string;
      authFields: string;
    } | null => {
      const storedPendingAuthRequest = window.sessionStorage.getItem('pendingAuthFAQ');
      if (!storedPendingAuthRequest) {
        return null;
      }

      try {
        const parsedRequest = JSON.parse(storedPendingAuthRequest) as Partial<{
          question: string;
          isFaq: string;
          answer: string;
          requiresAuth: string;
          authType: string;
          authFields: string;
        }> & {
          updatedAuthType?: string;
        };

        return {
          question: parsedRequest.question ?? "",
          isFaq: parsedRequest.isFaq ?? "N",
          answer: parsedRequest.answer ?? "",
          requiresAuth: parsedRequest.requiresAuth ?? "N",
          authType: parsedRequest.authType ?? parsedRequest.updatedAuthType ?? "",
          authFields: parsedRequest.authFields ?? "",
        };
      } catch (error) {
        console.error("Failed to parse pending auth request:", error);
        window.sessionStorage.removeItem('pendingAuthFAQ');
        return null;
      }
    };

    const writePendingAuthRequest = (pendingAuthRequest: {
      question: string;
      isFaq: string;
      answer: string;
      requiresAuth: string;
      authType: string;
      authFields: string;
    }) => {
      window.sessionStorage.setItem('pendingAuthFAQ', JSON.stringify(pendingAuthRequest));
    };

    const resumePendingAuthRequest = (caseNumber?: string) => {
      const pendingAuthRequest = readPendingAuthRequest();
      const question = pendingAuthRequest?.question || questionV || "";
      const isFaq = pendingAuthRequest?.isFaq || (questionV ? isFaqV : "N");
      if (!question) {
        return false;
      }

      // A B2C redirect reloads the app and wipes state/refs, so restore authType/authFields from the stored request.
      if (pendingAuthRequest) {
        authTypeVRef.current = pendingAuthRequest.authType || authTypeVRef.current;
        setauthType(pendingAuthRequest.authType || authTypeV);
        setauthFields(pendingAuthRequest.authFields || authFields);
        setQuestionV(question);
        setIsFAQV(isFaq);
      }

      const conversationId = appStateContext?.state.currentChat?.id ? appStateContext.state.currentChat.id : undefined;
      window.sessionStorage.removeItem('pendingAuthFAQ');
      makeApiRequest(question, isFaq, "Y", conversationId, caseNumber);
      window.sessionStorage.setItem("firstAuthQuestion", "true");
      return true;
    };

    useEffect(() => {
        const handleMessage = (e: MessageEvent) => {
            if (e.data?.type === "PRIYA_CLOSE_ADMIN") setIsAdminOverlayOpen(false);
            if (e.data?.type === "ADMIN_APP_READY") setAdminIframeLoaded(true);
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);

    // Signal Admin to dismiss its cover spinner once PriyaMain's branding has loaded.
    // Fires only when embedded inside Admin's overlay (source=admin in URL).
    // onLoad in Admin fires for browser error pages too, so Admin relies on this
    // postMessage instead — if it never arrives, Admin's timeout triggers the fallback URL.
    const priyaMainReadySentRef = useRef(false);
    useEffect(() => {
        const isEmbedded = (() => {
            try { return window.self !== window.top; } catch { return true; }
        })() && new URLSearchParams(window.location.search).get("source") === "admin";
        if (branding && isEmbedded && !priyaMainReadySentRef.current) {
            priyaMainReadySentRef.current = true;
            window.parent.postMessage({ type: "PRIYA_MAIN_READY" }, "*");
        }
    }, [branding]);

    useEffect(() => {
      if (b2cAuthResponse && branding?.show_signin === "Y" && enableProfilePanel) {
          const oid = b2cClaims?.oid ?? "";
          if (oid) {
              updateAuthFieldsVal(prev => ({
                  ...prev,
                  oid
              }));
          }
      }
    }, [b2cAuthResponse, branding?.show_signin, enableProfilePanel, b2cClaims?.oid, updateAuthFieldsVal]);

    useEffect(() => {
      const userSignedInWithB2C = (b2cAuthResponse && branding?.show_signin === "Y" && enableProfilePanel)
      const authData = async () => {
        if (userSignedInWithB2C && authFieldsVal.oid) {
          // User is signed in with B2C - proceed with validation & retrieving case & template information
            makeApiRequestB2CAuthValidate();
        }
      };
      authData();
    }, [b2cAuthResponse, branding?.show_signin, enableProfilePanel, authFieldsVal.oid]);

     useEffect(() => {
      // Wait for B2C auth to settle before initializing Google Translate to avoid duplicate dropdowns.
      // When the profile panel is enabled, also wait for its data to load so Google Translate's initial
      // page pass includes the panel (otherwise it can mount after the pass and open untranslated). A
      // timeout releases the gate if the profile data never loads, so translation is never permanently blocked.
      if (!b2cReady) return;
      if (!enableProfilePanel || isProfileDataLoaded()) {
        setConfigLanguages(branding?.languages || "");
        return;
      }
      const fallback = setTimeout(() => setConfigLanguages(branding?.languages || ""), 5000);
      return () => clearTimeout(fallback);
    }, [branding?.languages, branding?.YW_USE_AZURE_B2C, appStateContext?.state.b2cInternalCheckComplete, branding?.show_profile_panel, profilePaneData]);

    useEffect(() => {
      isDarkModeRef.current = isDarkMode;
    }, [isDarkMode]);

    const triggerPhrases = branding?.copilot_trigger_phrases ? branding?.copilot_trigger_phrases : [];

    const submitRequest = triggerPhrases.find((entry) => 
      entry.flow_trigger?.some((phrase: string) => phrase.toLowerCase().includes('submit request'))
    );

    const submitRequestTriggerPhrase = submitRequest ? submitRequest.flow_trigger.find((phrase: string) => phrase.toLowerCase().includes('submit request')) : null;

    const handleChatClick = (button: String) => {
        //setshowLiveChat(true);
        if (button === "submitrequest" && submitRequestTriggerPhrase){
          makeApiRequestAfterClear(submitRequestTriggerPhrase, "N", "N");
        } else if (button === "agent"){
          makeApiRequestAfterClear("agent", "N", "N")
        }
    };  

    useEffect(() => {
        const handleEsc = (event: KeyboardEvent) => {
            if (event.key === "Escape"){
              setIsCitationPanelOpen(false);
              setIsIntentsPanelOpen(false);
              setIsSignInPopoverOpen(false);
              //setOpenSignOutDialog(false);
              setIsPopoverOpen(false);
              setIsProfilePaneOpen(false);
              setCaseSelectDialogOpen(false);
              setAddCaseDialogOpen(false);
              setPopUpBlocker(false);

              if (showTranslate){
                handleTranslateDialogClose();
              }
              else if (isFAQPaneOpen){
                setIsFAQPaneOpen(false);
              }
            }
        };
        window.addEventListener('keydown', handleEsc);
        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, [isCitationPanelOpen, isIntentsPanelOpen, isSignInPopoverOpen, isPopoverOpen, showTranslate, isFAQPaneOpen, isProfilePaneOpen, caseSelectDialogOpen, isMyInformationPanelOpen]);

  // When a program is selected from the program dropdown, focus the question input
  useEffect(() => {
    if (selectPgmCode && !selectPgmCode.toLowerCase().includes("selectpgm")) {
      setTimeout(() => {
        document.getElementById("question-input-textarea")?.focus();
      }, 200);
    }
  }, [selectPgmCode]);

  // Load the Knowledge Base blob list so citation urls can be resolved by filename.
  // Keyed on `settings` so this runs after a program switch finishes refreshing the env
  useEffect(() => {
    const pgmCode = window.sessionStorage.getItem('selectedProgramCode') || selectPgmCode;
    if (!pgmCode || pgmCode.toLowerCase().includes("selectpgm")) return;
    if (branding?.hide_citations_kb_button === "true") return;
    let cancelled = false;
    const fetchDocUrls = async () => {
      try {
        const items = await getBlobList(false, pgmCode, msalInstance, settings);
        if (cancelled) return;
        const urlMap = new Map<string, string>();
        (items || []).forEach(item => {
          const fileName = item.name?.split('/').pop()?.toLowerCase();
          if (fileName && item.url) {
            urlMap.set(fileName, item.url);
          }
        });
        setKbDocUrls(urlMap);
      } catch (err) {
        console.error('Error fetching document list for citations:', err);
      }
    };
    fetchDocUrls();
    return () => { cancelled = true; };
  }, [settings]);

  // Disable all keyboard/pointer interaction in the chat input area while on the program selection screen or during page loading
  useEffect(() => {
    const el = document.getElementById('chat-input-area');
    if (!el) return;
    const shouldBeInert = selectPgmCode.toLowerCase().includes("selectpgm") || showPageLoading;
    if (shouldBeInert) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
      if (selectPgmCode) {
        setTimeout(() => {
          document.getElementById("question-input-textarea")?.focus();
        }, 0);
      }
    }
  }, [selectPgmCode, showPageLoading]);

  useEffect(() => {
    if (window.matchMedia('(max-width: 991px)').matches) {
      // On mobile screens, re‑dispatch the Google Translate dropdown’s
      // change event so that our dynamically‑updated 'My Profile' Sliding Pane
      // gets translated.
      const googleTranslateCombo = document.querySelector<HTMLSelectElement>('.goog-te-combo');
      if (googleTranslateCombo && googleTranslateCombo.value && googleTranslateCombo.value !== 'en' && googleTranslateCombo.value !== '') {
        googleTranslateCombo.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }, [selectedProfileSection]);

    useEffect(() => {
        convidRefVal.current = convidRef;
    }, [convidRef]);

    useEffect(() => {
        transcriptRef.current = transcript;
    }, [transcript]);

    useEffect(() => {
        startCopilotFlowRef.current = startCopilotFlow;
    }, [startCopilotFlow]);

     useEffect(() => {
       copilotFlowContext1Ref.current = copilotFlowContext1;
    }, [copilotFlowContext1]);

    useEffect(() => {
        authFieldsValRef.current = authFieldsVal;
        //console.log("authFieldsValRef.current", authFieldsValRef.current);
    }, [authFieldsVal]);
    

    useEffect(() => {
        showLiveChatRef.current = showLiveChat;
    }, [showLiveChat]);

    useEffect(() => {
        if (showLiveChatRef.current) {
         
            const button = document.getElementById("loadAgent") as HTMLButtonElement;
            if (button) {
                //console.log("clicking button");
                button.click();
            }
        }
    }, [showLiveChat]);

     useEffect(() => {
        showLiveFlowRef.current = showLiveFlow;
    }, [showLiveFlow]);

    useEffect(() => {
        if (showLiveFlowRef.current) {
         
            const button = document.getElementById("loadCopilot") as HTMLButtonElement;
            if (button) {
                //console.log("clicking button");
                button.click();
            }
        }
    }, [showLiveFlow]);

    const configCodeRef = useRef(configCode);

    useEffect(() => {
        configCodeRef.current = configCode;
    }, [configCode]);

    // Preload blob cache when configCode is available
    // useEffect(() => {
    //     const preloadBlobCache = async () => {
    //         if (configCode && configCode.trim() !== "") {
    //             try {
    //                 // Call getBlobList to preload the cache for this program
    //                 await getBlobList(false, configCode);
    //                 //console.log(`Blob cache preloaded for program: ${configCode}`);
    //             } catch (error) {
    //                 console.warn(`Failed to preload blob cache for program ${configCode}:`, error);
    //             }
    //         }
    //     };

    //     preloadBlobCache();
    // }, [configCode]);

    useEffect(() => {
        const sendDarkModeMessage = () => {
            const iframe = document.getElementById('telephonyIframe') as HTMLIFrameElement | null;
            const iWindow = iframe?.contentWindow;
            if (iWindow) {
                iWindow.postMessage({ action: 'UPDATE_DARK_MODE', isDarkMode: isDarkMode }, '*');
            }
        };
    
        sendDarkModeMessage();
    }, [isDarkMode]);

    // Copilot Widget 
     useEffect(() => {
        //console.log("*DOM loaded - Copilot Widget");
        //console.log('*configCode', configCode, configCodeRef.current);
        if (branding?.copilot_flowdisplay_inwidget !== "Y") {
            return;
        }
        const copilotAPI = branding?.copilot_flowdisplay_api;
        //const copilotAPI = "http://127.0.0.1:50505";
        const button = document.getElementById("loadCopilot") as HTMLButtonElement;
        const iframe = document.getElementById("copilotIframe") as HTMLIFrameElement;
        
        let iWindow: Window | null = iframe?.contentWindow ?? null;
        
        if (iframe) {
           
            iframe.addEventListener("load", () => {
                //console.log("*iframe loaded - copilot");
                iWindow = (iframe as HTMLIFrameElement).contentWindow;
            });
        }
        // FROM PARENT TO IFRAME
        
        if (button) {
            button.addEventListener("click", () => {
                //console.log("*Button clicked - copilot");
                if (iWindow === null) {
                    //console.log("*iWindow is null - copilot");
                    return;
                } else {
                   
                    if (showLiveFlowRef.current && startCopilotFlowRef.current !== "") {
                        //console.log("I have a show live chat reference")
                        if (copilotAPI) {
                            //console.log("*going to show copilot widget");
                            setShowCopilotWidget(true);
                            setPopUpBlocker(true);
                            //console.log(document.documentElement.lang)
                            //console.log("Sending message" +  "<>" + (branding as any)?.env_common + "<>" + convidRefVal.current);
                            //console.log("Sending this transcript" + transcriptRef.current);
                            //posttext Structure: connection_string<>configCode-User<>env_common<>convid<>pagelanguage<>startFlowName<>context1<>context2<>context3
                            //console.log(startCopilotFlowRef.current , copilotFlowContext1Ref.current);
                            var posttext = (branding as any)?.connection_string + "<>" + configCodeRef.current + "-User"+ "<>" + (branding as any)?.env_common 
                            posttext = posttext + "<>" + convidRefVal.current +"<>" + document.documentElement.lang + "<>" + isDarkModeRef.current + "<>" + startCopilotFlowRef.current +"<>" + copilotFlowContext1Ref.current +"<><>";
                            //console.log("I have a telephony API");
                            iWindow.postMessage(posttext, copilotAPI);
                            
                        }
                    }
                }
            });
        } else {
            console.log("Button not found - copilot");
        }
        // FROM IFRAME TO PARENT
        window.addEventListener("message", async (event) => {
            const data = event.data;
            const isCopilotFlow = typeof data === "string" && data.includes('CopilotFlow');
            const isAgent = typeof data === "string" && data.includes('<AGENT>');
            const isFormData = typeof data === "string" && data.includes('Form Data');
            if (isCopilotFlow) {
                //console.log("*Message received - copilot X"+ event.data + "Y");
                 if (isAgent) { 
                    //console.log("*call to agent from copilot");
                    setshowLiveChat(true);
                         
                    
                }
                //const { data } = event;
            // (document.getElementById("output") as HTMLTextAreaElement).value = JSON.stringify(data, null, 2);
                if (event?.data ==='CopilotFlow - Ended') { 
                    //console.log("*going to hide copilot widget");
                    setShowCopilotWidget(false);
                    setshowLiveFlow(false);
                    if(!showTelephonyWidget){
                      setPopUpBlocker(false);
                    }else{
                      setPopUpBlocker(true);
                    }
                    setTimeout(() => {
                      document.getElementById("question-input-textarea")?.focus();
                    }, 200);
                }

                if (isFormData){
                  try {
                    const jsonStartIndex = event.data.indexOf('Form Data:') + 'Form Data:'.length;
                    const jsonStr = event.data.substring(jsonStartIndex);
                  
                    // Parse the JSON string into an object
                    const formData = JSON.parse(jsonStr);
                    //console.log("Form data received from iframe:", formData);

                    // Filter out keys that include "noStorage"
                    const filteredFormData = Object.fromEntries(
                      Object.entries(formData).filter(([key]) => !key.includes("noStorage"))
                    );

                    // Merge new form data with existing data
                    setCopilotFormData((prevFormData: Record<string, any>) => ({
                      ...prevFormData,
                      ...filteredFormData
                    }));
                  } catch (err) {
                    console.error("Failed to parse form data:", err);
                  }
      
                }
            };
        });

      
        // FROM IFRAME TO STATIC
        window.addEventListener("message", (event) => {
          const data = event.data;
          const isCopilotFlow = typeof data === "string" && data.includes('CopilotFlow');
          const isCopilotFlowStatus = typeof data === "object" && data?.action === 'Request_CopilotFlow_Status';
        if (isCopilotFlow) {
            //console.log("*Message received - copilot", event.data);
            if (isCopilotFlowStatus) {
                event.source?.postMessage({
                action: 'Request_CopilotFlow_Status',
                textContent: showLiveFlowRef.current
                }, { targetOrigin: event.origin }); // Pass event.origin as targetOrigin
            }
        };
        });

        
    }, [branding?.copilot_flowdisplay_inwidget, configCode, convidRef, startCopilotFlowRef.current,copilotFlowContext1Ref.current, showTelephonyWidget]);    

    //Telephony Widget
    useEffect(() => {
        //console.log("DOM loaded");
        //console.log('configCode', configCode, configCodeRef.current);
        const telephonyAPI = branding?.telephony_api;
        const button = document.getElementById("loadAgent") as HTMLButtonElement;
        const iframe = document.getElementById("telephonyIframe") as HTMLIFrameElement;
        
        let iWindow: Window | null = iframe?.contentWindow ?? null;
        
        if (iframe) {
           
            iframe.addEventListener("load", () => {
                //console.log("iframe loaded");
                iWindow = (iframe as HTMLIFrameElement).contentWindow;
            });
        }
        // FROM PARENT TO IFRAME
        
        if (button) {
            button.addEventListener("click", async () => {
                //console.log("Button clicked");
                if (iWindow === null) {
                    //console.log("iWindow is null");
                    return;
                } else {
                   
                    if (showLiveChatRef.current) {
                        //console.log("I have a show live chat reference")
                        if (telephonyAPI) {
                            //console.log("going to show telephony widget");
                            setShowTelephonyWidget(true);
                            setPopUpBlocker(true);
                            const currentConvId = convidRefVal.current;
                            //console.log(document.documentElement.lang)
                            //console.log("Sending message" +  "<>" + (branding as any)?.env_common + "<>" + convidRefVal.current);
                            //console.log("**Sending this transcript" + transcriptRef.current);
                            //posttext Structure: transcript<>var1<>var2<>connection_string<>configCode-User<>env_common<>convid
                            //<>true(Download transcript true/false)<>pagelanguage<>pdfBase64
                            const { pdf } = await generateChatPDF();
                            const pdfBase64 = pdf.output('datauristring').split(',')[1];
                            var posttext = transcriptRef.current + "<>" + branding?.telephony_var1 + "<>" + branding?.telephony_var2
                            posttext = posttext + "<>" + (branding as any)?.connection_string + "<>" + configCodeRef.current + "-User"+ "<>" + (branding as any)?.env_common
                            posttext = posttext + "<>" + currentConvId +"<>false<>" + document.documentElement.lang + "<>" + pdfBase64;
                            iWindow.postMessage(posttext, telephonyAPI);
                            
                        }
                    }
                }
            });
        } else {
            console.log("Button not found");
        }
        // FROM IFRAME TO PARENT
        window.addEventListener("message", (event) => {
            //if ((!event.data.includes('CopilotFlow')) &&(event.data.action !== 'Request_Telephony_Status')) {
                //console.log("Message received");
                //const { data } = event;
            // (document.getElementById("output") as HTMLTextAreaElement).value = JSON.stringify(data, null, 2);
                //console.log("going to hide telephony widget");

            const data = event.data;
            const isCopilotFlow = typeof data === "string" && data.includes('CopilotFlow');
            const isTelephonyStatus = typeof data === "object" && data?.action === 'Request_Telephony_Status';

            if (!isCopilotFlow && !isTelephonyStatus) {    
                setShowTelephonyWidget(false);
                setshowLiveChat(false);
                setPopUpBlocker(false);
            };
        });

      
        // FROM IFRAME TO STATIC
        window.addEventListener("message", (event) => {
        if (event.data.action === 'Request_Telephony_Status') {
            event.source?.postMessage({
            action: 'Request_Telephony_Status',
            textContent: showLiveChatRef.current
            }, { targetOrigin: event.origin }); // Pass event.origin as targetOrigin
        }
        });

        
    }, [branding?.telephony_api, configCode, convidRef]);    

    useEffect(() => {
        const initialEnv = window.sessionStorage.getItem("selectedProgramConfig") || document.querySelector('meta[name="env"]')?.getAttribute('content');
        // console.log('initialEnv', initialEnv);
        window.sessionStorage.setItem('iframe_env', initialEnv || "");
        window.sessionStorage.setItem('main_env', initialEnv || "");
        window.sessionStorage.removeItem("profile");
        window.sessionStorage.removeItem("ivrProfile");
    }, []);

    useEffect(() => {
     window.sessionStorage.setItem('isInIframe', isInIframe.toString());
    }, [isInIframe]);

    const onFeedbackGiven = (feedback: string) => {
        //console.log("Feedback received:", feedback);
        setThankYouMessagePayload(feedback);
    };
    
    const onFollowupQuestionClicked = (question: string, requiresAuth: string, requiresAuthType:string) => {
        // console.log("Followup question clicked:", question);
        // console.log("Requires Auth:", requiresAuth);
        // console.log("Requires Auth Type:", requiresAuthType);
        setauthType(requiresAuthType);
        
        makeApiRequestAfterClear(question, "N", requiresAuth === "Y" ? "Y" : "N");
    };

    {/*Observe changes to hidden elements - indicates Google Translation occurred. 
      Update state variables to ensure UI stays consistent with the translated language*/}
    const [feedbackTitle1, setFeedbackTitle1] = useState<string>(getTranslatedText('feedback-title1'));
    const [feedbackTitle2, setFeedbackTitle2] = useState<string>(getTranslatedText('feedback-title2'));

    const updateTranslatedValue = (container: HTMLElement | null, dataKey: string, setter: React.Dispatch<React.SetStateAction<string>>) => {
      if (container) {
          const span = container.querySelector(`[data-key="${dataKey}"]`);
          if (span?.textContent) {
              setter(span.textContent);
          }
      }
    };

    useEffect(() => {
      const translateStringsElement = document.getElementById("translate-strings");

      if (!translateStringsElement) return;

      const configs = [
          { dataKey: "feedback-title1", setter: setFeedbackTitle1 },
          { dataKey: "feedback-title2", setter: setFeedbackTitle2 }
      ];

      // Initialize values
      configs.forEach(({ dataKey, setter }) => {
          updateTranslatedValue(translateStringsElement, dataKey, setter);
      });

      const observer = new MutationObserver(() => {
          configs.forEach(({ dataKey, setter }) => {
              updateTranslatedValue(translateStringsElement, dataKey, setter);
          });
      });

      observer.observe(translateStringsElement, {
          childList: true,
          subtree: true,
          characterData: true
      });

      return () => {
          observer.disconnect();
      };
  }, []);
 

    /*
    useEffect(() => {
        console.log('changed to ' + popUpBlocker + ' showDropDown ' + showDropDown)
        if (branding)
            branding.citation_disabled = 'false'
        console.log('citation' + branding?.citation_disabled)
    }, [popUpBlocker]);
    */


    const b2cEnabled = branding?.YW_USE_AZURE_B2C;
    const b2cReady = !b2cEnabled || appStateContext?.state.b2cInternalCheckComplete;

    if (b2cReady && pList[0] && pList[0] !== "<>") {
        if (selectPgm === "") {
            let r = pList[0].split("<>")
            setSelectPgm(r[0]);
            setSelectPgmCode(r[1]);
            setConfigCode(r[3]);
            window.sessionStorage.setItem('selectedProgramCode', r[1]);
            window.sessionStorage.setItem('selectedProgramConfig', r[3]);
            if (isInIframe) {
                window.sessionStorage.setItem('iframe_env', r[3]);
            } else {
                window.sessionStorage.setItem('main_env', r[3]);
            }
        }
        if (selectPgmCode?.toLowerCase().includes("selectpgm")) {
            headerDDClass = classnames(styles.headerSelectPgmDD, "notranslate");
        } else {
            headerDDClass = classnames(styles.headerDD, "notranslate");
        }
    }
    
 
    
    const pgmSelection = async (pgm: string, idx:number): Promise<void> => {
      let r = pgm.split("<>")
      if (selectPgm === ""){
          setSelectPgm(r[0]);
          setSelectPgmCode(r[1]);
          setConfigCode(r[3]);
      }
      setSelectPrevPgm(selectPgm);
      setSelectPrevPgmCode(selectPgmCode);
      setPrevConfigCode(configCode);
      setConfigCode(r[3]);
      setSelectPgmCode(r[1]);
      setSelectPgm(r[0]);
 
      // Store the selected program config to persist across redirects (ex: MSAL redirect)
      window.sessionStorage.setItem('selectedProgramConfig', r[3]);
      window.sessionStorage.setItem('selectedProgramCode', r[1]);

      // If user is in B2C internal auth 'selecting_program' state, trigger program assignment
      if (appStateContext?.state.b2cInternalAuthState === 'selecting_program' && r[3]) {
        // Immediately show loading spinner
        appStateContext?.dispatch({
          type: 'SET_B2C_INTERNAL_AUTH_STATE',
          payload: 'loading'
        });
        const assignmentSucceeded = await handleInternalProgramAssignment(r[3]);
        if (!assignmentSucceeded) {
          // Revert so user stays on "Select a Program" if assignment failed
          appStateContext?.dispatch({
            type: 'SET_B2C_INTERNAL_AUTH_STATE',
            payload: 'selecting_program'
          });
          window.sessionStorage.setItem('selectedProgramConfig', selectPrevPgmCode || '');
          window.sessionStorage.setItem('selectedProgramCode', '');
          setConfigCode(prevConfigCode);
          setSelectPgmCode(selectPrevPgmCode);
          setSelectPgm(selectPrevPgm);
        }
        setPopUpBlocker(false);
        setShowPageLoading(false);
        return;
      }


      const claimOid = b2cClaims?.oid;
      const effectiveOid = authFieldsValRef.current?.oid || claimOid;
      let assignedExternalProgram = false;
      const isExternalOnlyB2C =
        appStateContext?.state.b2cInternalAuthState === 'not_applicable' &&
        !hasInternalPrograms &&
        !!b2cAuthResponse &&
        !!effectiveOid &&
        !!r[1];
      const needsExternalAssignment =
        isExternalOnlyB2C && !hasAssignedProgram(profilePaneData, r[1]);
      if (needsExternalAssignment) {
        const result = await handleExternalProgramAssignment(r[1], authFieldsValRef.current);
        if (!result.success) {
          setPopUpBlocker(false);
          setShowPageLoading(false);
          return;
        }
        assignedExternalProgram = true;
      }

      // if (idx>0){
      //     setShowPgmMessage(true);
      // }
    
      if (idx>0 &&  r[3] === ""){
          setStopMsgPlaying(true);
          handlePgmDialogOpen();
         
      } 
      else {
        //console.log("redirect to " + r[2])
        //console.log("config " + r[3])
        //window.location.href = r[2];
        //let response = refreshEnv(r[3]) 
        
        if (!assignedExternalProgram || !readPendingAuthRequest()) {
          newChatMisc();
        }
        setProfilePaneData({});
        //console.log("refreshing env")
        let b:FrontendSettings
        //var iframe = document.getElementsByClassName('goog-te-banner-frame')[0];
        //VIpgJd - ZVi9od - LgbsSe
        var iframe = (document?.getElementsByClassName('VIpgJd-ZVi9od-ORHb-OEVmcd')[0] as HTMLIFrameElement) 
        //console.log("iframe found")
        if (iframe) {
            //console.log("iframe found")
            //var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
            var innerDoc = iframe.contentDocument || iframe.contentWindow?.document;
            var restore_el = innerDoc?.getElementsByTagName("button");
            if (restore_el){
                //console.log("restore_el found")
                for (var i = 0; i < restore_el.length; i++) {
                    //console.log(restore_el[i].id)
                    if (restore_el[i].id.indexOf("restore") >= 0) {
                        //console.log("clicking restore")
                        restore_el[i].click();
                        // var close_el = innerDoc?.getElementsByClassName("goog-close-link");

                        //close_el[0].click();
                        //return;
                    }
                }
            }
        }


        //document.documentElement.setAttribute('lang', 'en');
        let response = await refreshfrontendSettings(r[3], document.documentElement.lang,window.sessionStorage.getItem('selectedProgramCode'), msalInstance, settings);    
        //console.log("after refreshing env")
        //console.log(response)
        // if (!isFAQPaneOpen){
        //     setIsFAQPaneOpen(true);
        // }
        appStateContext?.dispatch({ type: 'ENV_UPDATE_FRONTEND_SETTINGS', payload: response as FrontendSettings });
        if (response !== null) {
            b = response as FrontendSettings
            branding = b.branding;
            //console.log(b.branding);
        }

        // Refresh auth state because switching programs does not rerun the auth effect.
        const selectedProgramEnablesProfilePanel = (response as FrontendSettings)?.branding?.show_profile_panel === "Y";
        if (b2cAuthResponse && selectedProgramEnablesProfilePanel) {
          await makeApiRequestB2CAuthValidate(true);
        }

    }
    setPopUpBlocker(false);
    setShowPageLoading(false);
   
};

    const toggleDropDown = debounce(() => {
        if(!showDropDown){
            setPopUpBlocker(true);
        }
        setShowDropDown(!showDropDown);
    }, 150);
            
    const parsePlotFromMessage = (message: ChatMessage) => {
        if (message?.role && message?.role === "tool") {
            try {
                const execResults = JSON.parse(message.content) as AzureSqlServerExecResults;
                const codeExecResult = execResults.all_exec_results.at(-1)?.code_exec_result;
                if (codeExecResult === undefined) {
                    return null;
                }
                return codeExecResult;
            }
            catch {
                return null;
            }
            // const execResults = JSON.parse(message.content) as AzureSqlServerExecResults;
            // return execResults.all_exec_results.at(-1)?.code_exec_result;
        }
        return null;
    }
    const errorDialogContentProps = {
        type: DialogType.close,
        title: errorMsg?.title,
        closeButtonAriaLabel: 'Close',
        subText: errorMsg?.subtitle,
    };
    const pgmDialogContentProps = {
        type: DialogType.close,
        title: selectPgm + " Program ",
        closeButtonAriaLabel: 'Close',
        subText: 'Coming soon! Currently in development.'
        
    };
    const pgmModalProps = {
        titleAriaId: 'labelId',
        subtitleAriaId: 'subTextId',
        isBlocking: true,
        styles: { main: { maxWidth: 450 } } 
    };  
   
    const translateModalProps = {
        titleAriaId: 'labelId',
        subtitleAriaId: 'subTextId',
        isBlocking: true,
        styles: { main: { maxWidth: 450} },
    };  
    // const pdfRef = useRef(null);
    const modalProps = {
        titleAriaId: 'labelId',
        subtitleAriaId: 'subTextId',
        isBlocking: true,
        styles: { main: { maxWidth: 450 } },
    };  
    const handleCautionModalClick = () => {
        setIsCautionModalPanelOpen(!isCautionModalPanelOpen);
        setPopUpBlocker(true);
        if (isCautionModalPanelOpen){
            setTimeout(() => setText1(" "),100);
        }
        setTimeout(() => {
            document.getElementById("cautions-close")?.focus();
        }, 200);
        
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const scrollIframeToBottom = () => {
        const iframe = document.getElementById("widgetIframe") as HTMLIFrameElement;
        if (iframe?.contentWindow) {
            // Send a message to the iframe to scroll to the bottom
            iframe.contentWindow.postMessage({ action: 'SCROLL_TO_BOTTOM' }, '*');
        }
    };

    useEffect(()=>{
        if (showWidget || isFullScreen) {
            scrollIframeToBottom();
        }
    }, [showWidget, isFullScreen]);

    // Listen for messages from the parent window to scroll the widget iframe to the bottom
    useEffect(() => {
        const handleParentMessage = (event: MessageEvent) => {  
            if (event.data?.action === 'SCROLL_TO_BOTTOM') {
                window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
            }
        };
    
        // Listen for messages from the parent window
        window.addEventListener('message', handleParentMessage);
    
        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('message', handleParentMessage);
        };
    }, []);

    const toggleFullScreen = (state?: boolean ) => {
        const iframe = document.getElementById("widgetIframe") as HTMLIFrameElement;
        const newState = state !== undefined ? state : !isFullScreen;

        iframe?.contentWindow?.postMessage({ action: "TOGGLE_FULLSCREEN", payload: newState }, "*");
        window.parent.postMessage({ action: "TOGGLE_FULLSCREEN", payload: newState }, "*");

        // Sets the local state
        setIsFullScreen(newState);
    };   

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            const { action, payload } = event.data;
    
            if (action === "TOGGLE_FULLSCREEN") {
                setIsFullScreen(payload);    
                if (payload === true) {
                    document.body.style.overflow = 'hidden';
                } else {
                    document.body.style.overflow = 'auto';
                }
            }
        };
    
        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    const hideWidget = () => {
        const iframe = document.getElementById("widgetIframe") as HTMLIFrameElement;
        window.parent.postMessage({ action: "HIDE_WIDGET" }, "*");
        iframe?.contentWindow?.postMessage({ action: "HIDE_WIDGET" }, "*");
    };

    useEffect(() => {
        const handleParentMessage = (event: MessageEvent) => {
            const { action } = event.data;

            if (action === "HIDE_WIDGET") {
                toggleFullScreen(false);
                setShowWidget(false);
                document.body.style.overflow = 'auto';
            }
        };
        window.addEventListener("message", handleParentMessage);
        return () => {
            window.removeEventListener("message", handleParentMessage);
        };
    }, []);

   
    const toggleWidget = (state?: boolean) => {
        setShowWidget(prevShowWidget => state !== undefined ? state : !prevShowWidget);
        document.body.style.overflow = 'auto';
    }; 

    // Function to calculate iframe styles based on fullscreen state
    const calculateIframeStyles = (): React.CSSProperties => {
        if (isFullScreen) {
            return {
                border: "none",
                borderRadius: "0px",
                boxShadow: "",
                right: "0",
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
            };
        } else {
            return {
                border: "1px solid #000",
                borderRadius: "10px",
                boxShadow: "rgba(0, 0, 0, 0.35) 0px 4px 12px",
                right: "10px",
                position: "relative",
                top: "10px",
                left: windowSize.width <= 600 ? "10px" : "auto",
                width: windowSize.width <= 600 ? "calc(100% - 20px)" : "100%",                
            };
        }
    };

    // Update outer iframe styles whenever fullscreen or window size changes
    useEffect(() => {
        setIframeStyles(calculateIframeStyles());
    }, [isFullScreen, windowSize]);

    const handleFAQClick = () => {
      setIsFAQPaneOpen(prevState => !prevState);
      setTimeout(() => {
        document.getElementById("faq-panel-close")?.focus();
      }, 200);
    };    

    const handleCautionModalPanelDismiss = () => {
        setPopUpBlocker(false);
        setText1("");
        setIsCautionModalPanelOpen(false);
        setTimeout(() => {
          document.getElementById("ai-caution-button")?.focus();
        }, 200);
    };

  const [searchTextCitation, setSearchTextCitation] = useState("");
  const [currentMatchIndex, setCurrentMatchIndex] = useState(0);
  const [totalMatches, setTotalMatches] = useState(0);
  const [matchPositions, setMatchPositions] = useState<number[]>([]);
  const citationContentRef = useRef<HTMLDivElement>(null);
  const citationsContainerRef = useRef<HTMLDivElement>(null);
  const [translatedContent, setTranslatedContent] = useState<string | null>(null);
  const isTranslated = document.documentElement.lang !== 'en';

  // Capture translated content when available
  useEffect(() => {
    if (isTranslated && citationContentRef.current && activeCitation?.content) {
      // Wait a brief moment for translation to settle
      const timer = setTimeout(() => {
        if (citationContentRef.current) {
          const content = citationContentRef.current.innerHTML || '';
          setTranslatedContent(content);
        }
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [activeCitation, document.documentElement.lang]);

  // This function highlights search matches in the citation content
  // It preserves existing HTML structure and highlights only text nodes
  const highlightSearchMatches = (text: string, searchText: string): string => {
    if (!searchText.trim()) {
      return text;
    }

    try {
      // Check for unsupported characters (e.g., emojis, special symbols not classified as letters, numbers, punctuation, or spaces)
      const unsupportedCharRegex = /[^\p{L}\p{N}\p{P}\p{Z}]/gu;

      // Remove unsupported characters
      const sanitizedSearchText = searchText.replace(unsupportedCharRegex, '');
      if (!sanitizedSearchText.trim()) {
        return text; // Return original text if sanitized input is empty
      }

      // Use the stored translated content from state if available
      // Otherwise, fall back to the original text
      const contentToUse = isTranslated && translatedContent ? translatedContent : text;

      // Escape special regex characters in the sanitized text
      const escapedSearchText = sanitizedSearchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      // Create regex using the escaped sanitized text
      const regex = new RegExp(`(${escapedSearchText})`, 'gi');

      // Create a temporary div to safely manipulate the DOM
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = contentToUse;

      // Use TreeWalker to iterate over text nodes
      // This ensures we preserve existing HTML structure
      const treeWalker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null);
      const textNodes: Node[] = [];
      while (treeWalker.nextNode()) {
        textNodes.push(treeWalker.currentNode);
      }

      let matchIndex = 0;
      textNodes.forEach(node => {
        const nodeText = node.nodeValue || '';
        const matches = [...nodeText.matchAll(regex)];

        if (matches.length > 0) {
          const fragment = document.createDocumentFragment();
          let lastIndex = 0;

          matches.forEach(match => {
            const foundText = match[0];
            const startIndex = match.index!;
            
            // Add text before the match
            if (startIndex > lastIndex) {
              fragment.appendChild(document.createTextNode(nodeText.substring(lastIndex, startIndex)));
            }

            // Create and add the highlighted span
            const span = document.createElement('span');
            const isCurrentMatch = matchIndex === currentMatchIndex;
            span.className = isCurrentMatch ? styles.highlightedTextCurrent : styles.highlightedText;
            span.textContent = foundText;
            fragment.appendChild(span);

            matchIndex++;
            lastIndex = startIndex + foundText.length;
          });

          // Add any remaining text after the last match
          if (lastIndex < nodeText.length) {
            fragment.appendChild(document.createTextNode(nodeText.substring(lastIndex)));
          }

          // Replace the original text node with the new fragment
          node.parentNode?.replaceChild(fragment, node);
        }
      });
      
      return tempDiv.innerHTML;
    } catch (error) {
      console.error("Error highlighting text:", error);
      return text;
    }
};

// This calculates total matches and their positions whenever the search text or active citation changes
useEffect(() => {
  if (!searchTextCitation.trim() || !activeCitation?.content) {
    setTotalMatches(0);
    setMatchPositions([]);
    setText5Error("");
    return;
  }

  try {
    // Check for unsupported characters (e.g., emojis, special symbols not classified as letters, numbers, punctuation, or spaces)
    const unsupportedCharRegex = /[^\p{L}\p{N}\p{P}\p{Z}]/gu;
    const sanitizedSearchText = searchTextCitation.replace(unsupportedCharRegex, '');
    
    // Handle unsupported character case
    if (!sanitizedSearchText.trim()) {
      if (text5Error !== "Unsupported character ignored.") {
        setText5Error(getTranslatedText('error-unsupported-character'));
      }
      setTotalMatches(0);
      setMatchPositions([]);
      return;
    }
    
    // Use the stored translated content from state
    // Otherwise, fall back to the original content
    const contentToSearch = isTranslated && translatedContent ? translatedContent : activeCitation.content;

    // Escape special regex characters
    const escapedSearchText = sanitizedSearchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedSearchText})`, 'gi');
    
    // Find all matches and their positions
    const newMatchPositions: number[] = [];
    let count = 0;
    let match;
    
    // Create a temporary string for finding matches
    const tempContent = DOMPurify.sanitize(contentToSearch, { ALLOWED_TAGS: XSSAllowTags });
    
    // Use a new regex instance to prevent lastIndex issues
    const searchRegex = new RegExp(regex);
    
    // Find all positions of matches
    while ((match = searchRegex.exec(tempContent)) !== null) {
      newMatchPositions.push(match.index);
      count++;
    }
    
    // Update state after all calculations are done
    setTotalMatches(count);
    setMatchPositions(newMatchPositions);

    // Display "No matches found" if there are no matches
    if (count === 0) {
      setText5Error(getTranslatedText('error-no-matches'));
    } else {
      setText5Error(""); // Clear the error if matches are found
    }
    
    
    // Reset current index if needed
    if (currentMatchIndex >= count && count > 0) {
      setCurrentMatchIndex(0);
    }
  } catch (error) {
    console.error("Error calculating matches:", error);
  }
}, [searchTextCitation, activeCitation?.content, translatedContent, currentMatchIndex]);

  // Navigate to the next match
  const navigateToNextMatch = () => {
    if (totalMatches === 0) return;
    
    const nextIndex = (currentMatchIndex + 1) % totalMatches;
    setCurrentMatchIndex(nextIndex);
    scrollToMatch(nextIndex);
  };

  // Navigate to the previous match
  const navigateToPreviousMatch = () => {
    if (totalMatches === 0) return;
    
    const prevIndex = (currentMatchIndex - 1 + totalMatches) % totalMatches;
    setCurrentMatchIndex(prevIndex);
    scrollToMatch(prevIndex);
  };

  // Scroll to a specific match
  const scrollToMatch = (index: number) => {
    if (!citationContentRef.current || !matchPositions.length || index >= matchPositions.length) {
        console.log("Invalid conditions for scrolling");
        return;
    }

    const matchElements = citationContentRef.current.querySelectorAll('span[class*="highlightedText"]');

    if (matchElements.length > index) {
        matchElements[index].scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    } else {
        console.log("No match element found for the given index");
    }
};

  // Automatically scroll to the current match when it changes
  // when search text is cleared, scroll to the top
  useEffect(() => {
    if (totalMatches > 0 && matchPositions.length > 0 && searchTextCitation.trim()) {
      // Delay scrolling slightly to ensure DOM updates are complete
      setTimeout(() => {
        scrollToMatch(currentMatchIndex);
      }, 400);
    } else if (!searchTextCitation) {
      setCurrentMatchIndex(0);
      setTotalMatches(0);
      setMatchPositions([]);
      setText5Error("");
      if (citationsContainerRef.current) {
        citationsContainerRef.current.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    }
  }, [currentMatchIndex, totalMatches, searchTextCitation]);
    
    
    //const pList = ["Louisiana - SNAP", "Louisiana - CSE"];
    const pgmInput = () => {
        //console.log(branding?.pgmList)
        let pgmList = pList.filter((pgm: string) => !pgm.split('<>')[1]?.toLowerCase().includes("selectpgm"));
        return pgmList;

    };
    
    const subtitleRef = useRef<HTMLSpanElement>(null);
    const capitalizeFirstWord = () => {
        try {
            if (subtitleRef.current) {
            const text = subtitleRef.current.textContent || '';
            const htmlLang = document.documentElement.lang;
            if (htmlLang !== 'en') {
                const capitalizedText = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
                subtitleRef.current.textContent = capitalizedText;
            }
            }
        } catch {           
            // In case of error, revert to the original text and exit
            return;
        }
    };

    const handlePrivacyPolicyModalClick = () => {
        setIsPrivacyPolicyModalPanelOpen(!isPrivacyPolicyModalPanelOpen);
        setPopUpBlocker(true);
        if (isPrivacyPolicyModalPanelOpen){
            setTimeout(() => setText2(" "),100);
        } 
        else {
            setTimeout(() => capitalizeFirstWord(), 180);
        }
        setTimeout(() => {
          document.getElementById("privacy-close")?.focus();
        }, 200);
    };

    const handlePrivacyPolicyModalPanelDismiss = () => {
        setPopUpBlocker(false);
        setText2("");
        setIsPrivacyPolicyModalPanelOpen(false);
        setTimeout(() => {
          document.getElementById("privacy-policy-button")?.focus();
        }, 200);
    };

    const handleUserTermsModalClick = () => {
        setIsUserTermsModalPanelOpen(!isUserTermsModalPanelOpen);
        setPopUpBlocker(true);
        if (isUserTermsModalPanelOpen){
            setTimeout(() => setText3(" "),100);
        };
        setTimeout(() => {
          document.getElementById("user-terms-close")?.focus();
        }, 200);
    };

    const handleUserTermsModalPanelDismiss = () => {
        setPopUpBlocker(false);
        setText3("");
        setIsUserTermsModalPanelOpen(false);
        setTimeout(() => {
          document.getElementById("user-terms-button")?.focus();
        }, 200);
    };
     
    const handleFeedbackModalClick = () => {
        if (appStateContext?.state.isFeedbackPanelOpen){
            setStopMsgPlaying(false);
            setPopUpBlocker(false);
        } else {
            setStopMsgPlaying(true);
            setPopUpBlocker(true);
        }
       
        sessionStorage.msgID="";
        sessionStorage.msgFB ="neutral";
        appStateContext?.dispatch({ type: 'MSGFB', payload:'N' })
        appStateContext?.dispatch({ type: 'TOGGLE_FEEDBACK_PANEL' })
        setIsCitationPanelOpen(false);
        setIsCautionModalPanelOpen(false);
        setIsPrivacyPolicyModalPanelOpen(false);
        setIsUserTermsModalPanelOpen(false);
       
    };

    const [ASSISTANT, TOOL, ERROR] = ["assistant", "tool", "error"];
     
    const handleErrorDialogClose = () => {
        toggleErrorDialog()
      
        setTimeout(() => {
            setErrorMsg(null)
        }, 500);
    }
    const handlePgmDialogOpen = () => {
        
        setShowPgmMessage(true);
        if (showPgmMessage) {
            setTimeout(() => setText4("AAA"), 100);
        };

    }
    const handlePgmDialogClose = () => {
       setStopMsgPlaying(false);
       setText4("");
       setShowPgmMessage(false);
       setSelectPgm(selectPrevPgm);
       setSelectPgmCode(selectPrevPgmCode);
       setConfigCode(prevConfigCode);
       
    }


    const onAuthFieldValChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      //console.log("new value " + e.target.value)
      const fieldName = e.target.id;
      const value = e.target.value ?? "";
      
      updateAuthFieldsVal(prev => ({
          ...prev,
          [fieldName]: value
      }));
    };

    const validateAuthFields = () => {
      const errors: { [key: string]: string } = {};
      // Check all fields in authFields
      authFields.split(',').forEach((field) => {
        const key = field.trim().toLowerCase().replace(/\s+/g, '');
        const value = authFieldsVal[key] || "";
        if (!value) {
          // Get translated field name from hidden span
          const fieldNameElement = document.getElementById(`${key}FieldName`);
          const translatedField = fieldNameElement?.textContent || field.trim();
          const requiredPrefix = getTranslatedText('error-field-required');
          errors[key] = `${requiredPrefix} ${translatedField}`;
        }
        // SSN validation
        if (key === 'socialsecuritynumber' && value && !/^\d{9}$/.test(value)) {
          errors.socialsecuritynumber = getTranslatedText('error-ssn-format');
        }
        // DOB validation
        if (key === 'dateofbirth' && value && !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          errors.dateofbirth = getTranslatedText('error-dob-format');
        }
      });
      const firstError = Object.values(errors).find(e => e);
      setText5Error(firstError || "");
      return Object.keys(errors).length === 0;
};

    const [lastFocusedElement, setLastFocusedElement] = useState<HTMLElement | null>(null);

    const handleAuthDialogOpen = () => {
        setLastFocusedElement(document.activeElement as HTMLElement);
        setPopUpBlocker(true);
        setShowAuthDialogMessage(true);
        setIsPopoverOpen(false);
        if (showAuthDialogMessage) {
            setText5Error("")
            setTimeout(() => setText5("AAA"), 100);
        };

    }
    const handleAuthDialogClose = () => {
        setPopUpBlocker(false);
        setStopMsgPlaying(false);
        setText5Error("");
        setShowAuthDialogMessage(false);
        setIsVerified(false);
        setTimeout(() => {
          document.getElementById("sign-in-out-icon")?.focus();
      }, 200);
    }

    const handleTranslateDialogClose = () => {
        setStopMsgPlaying(false); 
        setShowTranslate(false); 

        setPopUpBlocker(false);
        setTimeout(()=> {
          document.getElementById("additional-chat-options") ? 
          document.getElementById("additional-chat-options")?.focus() : document.getElementById("language-setting")?.focus();
        }, 200);
    }
    const handleTranslateOpen = () => {
       setStopMsgPlaying(true); 
       setIsPopoverOpen(false);
       setShowTranslate(true);

       setPopUpBlocker(true);
       setTimeout(()=> {document.getElementById('google-translate')?.focus()}, 200);

    }
    const handleTranslate  = () => {
        setStopMsgPlaying(true);
        setShowTranslate(true);

        setPopUpBlocker(true);
        setTimeout(()=> {document.getElementById('google-translate')?.focus()}, 200);
    }
    const handleChangeModeOpen = () => {
        setIsPopoverOpen(false); 
        setIsDarkMode(!isDarkMode)
        if (document.getElementById("additional-chat-options")){
            setTimeout(() => {
              document.getElementById("additional-chat-options")?.focus();
           }, 200);
        }
    }
    
    const errorDialogClose = () => {
       setErrorMsg(null)
        
    }

    const [isMsgRenderComplete, setIsMsgRenderComplete] = useState(true);
    const [isMsgPlaying, setIsMsgPlaying] = useState(false);
    const [stopMsgPlaying, setStopMsgPlaying] = useState(false);
    const getUserInfoList = async () => { 
        if (!AUTH_ENABLED) {
            setShowAuthMessage(false);
           
            return;
        } else{
            const userInfoList = await getUserInfo();
            if (userInfoList.length === 0 && window.location.hostname !== "127.0.0.1") {
                setShowAuthMessage(true);
            }
            else {
                setShowAuthMessage(false);
            }
        }
      
         
    }
  
    const retrievePromptTokenCount = () => {
        if (!promptTokenCount) {
          promptTokenCount = Number(sessionStorage.promptTokenCount)
       }
    }

    const retrieveChatUUID = () => {
        if (lastQuestionRef.current && !chatUUID) {
          //chatUUID = uuidv4();
          chatUUID = sessionStorage.sessionUUID
       }
    }
    const onShowCitation = (citation: Citation) => {
        setIsProfilePaneOpen(false);
        setActiveCitation(undefined);
        setIsCitationPanelOpen(false);
        setActiveCitation(citation);
        setIsCitationPanelOpen(true);
    };

    const openProfilePane = () => {
        setIsCitationPanelOpen(false);
        setActiveCitation(undefined);
        setIsProfilePaneOpen(true);
    };

    const onViewSource = (citation: Citation) => {
        if (citation.url && !citation.url.includes("blob.core")) {
            window.open(citation.url, "_blank");
        }
    };
    
    // Citations arrive without a url; resolve one from the Knowledge Base blob list by filename
    const resolveCitationUrl = (citation: Citation): Citation => {
        if (citation.url || !citation.filepath) return citation;
        const url = kbDocUrls.get(citation.filepath.split('/').pop()?.toLowerCase() || '');
        return url ? { ...citation, url } : citation;
    };

    const parseCitationFromMessage = (message: ChatMessage) => {
        if (message?.role && message?.role === "tool") {
            try {
                const toolMessage = JSON.parse(message.content) as ToolMessageContent;
                return toolMessage.citations.map(resolveCitationUrl);
            }
            catch {
                return [];
            }
        }
        return [];
    }

    const disabledButton = () => {
        // console.log("is msg render complete " + isMsgRenderComplete);
        // console.log("is chat history loaded " + appStateContext?.state.chatHistoryLoadingState);
        // console.log("is clearing chat " + clearingChat);
        // console.log("has no messages" + (messages && messages.length === 0));
        let x = (!isMsgRenderComplete) || (messages && messages.length === 0) || clearingChat || appStateContext?.state.chatHistoryLoadingState === ChatHistoryLoadingState.Loading
        //console.log(x);
        return x
        //return isLoading || (messages && messages.length === 0) || clearingChat || appStateContext?.state.chatHistoryLoadingState === ChatHistoryLoadingState.Loading
    }
 
    

    const hideFeedbackButton = () => {
         //console.log("isanscomp " + isMsgRenderComplete);
         return (!isMsgRenderComplete) || appStateContext?.state.isFeedbackPanelOpen   || (messages && messages.length === 0) || clearingChat || appStateContext?.state.chatHistoryLoadingState === ChatHistoryLoadingState.Loading;
       //return (isLoading) || appStateContext?.state.isFeedbackPanelOpen   || (messages && messages.length === 0) || clearingChat || appStateContext?.state.chatHistoryLoadingState === ChatHistoryLoadingState.Loading;
    }

    
 
    // #region clearChat
    const clearChat = async () => {
        lastQuestionRef.current = "";
        setClearingChat(true)
        setAnswers([]);
        setSpeechUrls([]);
        if(appStateContext?.state.currentChat?.id && appStateContext?.state.isCosmosDBAvailable.cosmosDB){
            let response = await historyClear(appStateContext?.state.currentChat.id,sessionStorage.sessionUUID, selectPgmCode)
            if(!response.ok){
                setErrorMsg({
                    title: "Error clearing current chat",
                    subtitle: "Please try again. If the problem persists, please contact the site administrator.",
                })
                toggleErrorDialog();
            }else{
                appStateContext?.dispatch({ type: 'DELETE_CURRENT_CHAT_MESSAGES', payload: appStateContext?.state.currentChat.id});
                appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY', payload: appStateContext?.state.currentChat});
                setActiveCitation(undefined);
                setIsCitationPanelOpen(false);
                setIsIntentsPanelOpen(false)
                setMessages([])
            }
        }
        setClearingChat(false)
    };
    // #endregion
    const tryGetRaiPrettyError = (errorMessage: string) => {
        try {
            // Using a regex to extract the JSON part that contains "innererror"
            const match = errorMessage.match(/'innererror': ({.*})\}\}/)
            if (match) {
                // Replacing single quotes with double quotes and converting Python-like booleans to JSON booleans
                const fixedJson = match[1]
                    .replace(/'/g, '"')
                    .replace(/\bTrue\b/g, 'true')
                    .replace(/\bFalse\b/g, 'false')
                const innerErrorJson = JSON.parse(fixedJson)
                let reason = ''
                // Check if jailbreak content filter is the reason of the error
                const jailbreak = innerErrorJson.content_filter_result.jailbreak
                if (jailbreak.filtered === true) {
                    reason = 'Jailbreak'
                }

                // Returning the prettified error message
                if (reason !== '') {
                    return (
                        'The prompt was filtered due to triggering Azure OpenAI’s content filtering system.\n' +
                        'Reason: This prompt contains content flagged as ' +
                        reason +
                        '\n\n' +
                        'Please modify your prompt and retry. Learn more: https://go.microsoft.com/fwlink/?linkid=2198766'
                    )
                }
            }
        } catch (e) {
            console.error('Failed to parse the error:', e)
        }
        return errorMessage
    };
    const parseErrorMessage = (errorMessage: string) => {
        let errorCodeMessage = errorMessage.substring(0, errorMessage.indexOf('-') + 1)
        const innerErrorCue = "{\\'error\\': {\\'message\\': "
        if (errorMessage.includes(innerErrorCue)) {
            try {
                let innerErrorString = errorMessage.substring(errorMessage.indexOf(innerErrorCue))
                if (innerErrorString.endsWith("'}}")) {
                    innerErrorString = innerErrorString.substring(0, innerErrorString.length - 3)
                }
                innerErrorString = DOMPurify.sanitize(innerErrorString);
                innerErrorString = innerErrorString.replaceAll("\\'", "'")
                let newErrorMessage = errorCodeMessage + ' ' + innerErrorString
                errorMessage = newErrorMessage
            } catch (e) {
                console.error('Error parsing inner error message: ', e)
            }
        }
        return tryGetRaiPrettyError(errorMessage)
    };

    function addWaterMark(doc:any) {
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++ ) {
          doc.setPage(i);
          doc.setTextColor(150);
          doc.setFontSize(40);
          doc.text(50, doc.internal.pageSize.height - doc.internal.pageSize.height/2, `Transcript Powered by ${agentName}`, {angle: 45});
         }

        return doc;
      }
    function addFooters(doc:any) {
        const pageCount = doc.internal.getNumberOfPages()
        const pageText = getTranslatedText("page");
        const ofText = getTranslatedText("of");
        const footerText = `${pageText} 1 ${ofText} ${pageCount}`;
        doc.setTextColor(28, 27, 44);

        // Set font based on language detection (Arabic, Korean, Chinese do not have italic style)
        if (isArabic(footerText)) {
          doc.setFont('NotoSansArabic', 'normal');
        } else if (isKorean(footerText)) {
          doc.setFont('NotoSansKR', 'normal');
        } else if (isChinese(footerText)) {
          doc.setFont('NotoSansSC', 'normal');
        } else {
          doc.setFont('Roboto', 'italic');
        }

        doc.setFontSize(12)
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          doc.text(`${pageText} ${String(i)} ${ofText} ${String(pageCount)}`, doc.internal.pageSize.width / 2, 287, {
            align: 'center'
          })
        }
        return doc;
      }  

    let sanitizedCautionText = DOMPurify.sanitize(branding?.caution_text || '');
    sanitizedCautionText = sanitizedCautionText.replaceAll(">", "");
    const cautionLines = sanitizedCautionText?.split('\r\n\r\n');
    const brandingCautionLine1 = cautionLines && cautionLines.length > 0 ? cautionLines[0] : '';
    const brandingCautionLine2 = cautionLines && cautionLines.length > 1 ? cautionLines[1] : '';
    
    function addHeaders(doc:any, convId:string, dt:string, pgm:string) {
        const pageCount = doc.internal.getNumberOfPages()
        doc.setTextColor(28, 27, 44);
        doc.setFontSize(12)
        const chatHistoryText = getTranslatedText("chat-history");
        const conversationIdText = getTranslatedText("conversation-id");
        const msgList2Text = getTranslatedText("caution-label");
        const cautionLine1 = getTranslatedText("cautionLine1");
        const cautionLine2 = getTranslatedText("cautionLine2");

        let msgList1 = pgm + `\n${chatHistoryText} ` + dt   + ` | ${conversationIdText} ` + convId + `\n\n`;
        let msgList2 = `${msgList2Text} ` + `${cautionLine1}\n\n` + `${cautionLine2}`+ `\n\n`;

        // Set font based on language detection (Arabic, Korean, Chinese do not have italic style)
        if (isArabic(msgList1)) {
          doc.setFont('NotoSansArabic', 'normal');
        } else if (isKorean(msgList1)) {
          doc.setFont('NotoSansKR', 'normal');
        } else if (isChinese(msgList1)) {
          doc.setFont('NotoSansSC', 'normal');
        } else {
          doc.setFontSize(11)
          doc.setFont('Roboto', 'italic');
        }

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
            doc.text(msgList1, 8, 10, { align: 'left', maxWidth: doc.internal.pageSize.width * 0.95 })
            doc.text(msgList2, 8, 25, { align: 'left', maxWidth: doc.internal.pageSize.width * 0.95 })
            doc.text("-".repeat(120), 8, 55, { align: 'left', maxWidth: doc.internal.pageSize.width * 0.85 });
         
        }
        return doc;
      }
  
    // Helper function to get translated user message from DOM if available
    const getTranslatedUserMessage = (messageIndex: number): string | null => {
        try {
            // Check if page is translated
            const isTranslated = document.documentElement.lang !== 'en';
            if (!isTranslated) {
                return null;
            }

            // Get all chat messages in order
            const chatContainer = document.querySelector('[class*="chatMessageStream"]');
            if (!chatContainer) {
                return null;
            }

            // Find the specific message by index
            const allMessages = chatContainer.querySelectorAll('[class*="chatMessageUser"]');
            const targetMessage = allMessages[messageIndex];

            if (!targetMessage) {
                return null;
            }

            // Extract only from chatMessageUserMessage
            const userMessageElement = targetMessage.querySelector('[class*="chatMessageUserMessage"]');
            if (userMessageElement) {
                const clone = userMessageElement.cloneNode(true) as HTMLElement;

                // Remove timestamp element (msgTime)
                clone.querySelectorAll('[class*="msgTime"]').forEach(el => el.remove());

                let text = clone.textContent?.trim() || '';
                return text || null;
            }
        } catch (error) {
            console.error('Error extracting translated user message:', error);
        }
        return null;
    };

    // Helper function to get translated FAQ question from clicked element
    const getTranslatedFAQ = (element: HTMLElement | EventTarget | null, fallbackQuestion: string): string => {
        try {
            if (!element || !(element instanceof HTMLElement)) {
                return fallbackQuestion;
            }
            const questionElement = element.querySelector('[class*="spReg"]');
            return questionElement?.textContent?.trim() || fallbackQuestion;
        } catch (error) {
            console.error('Error extracting translated FAQ question:', error);
            return fallbackQuestion;
        }
    };

    const generateChatPDF = async (): Promise<{ pdf: jsPDF; dt: string }> => {
        let pdf = new jsPDF('p','mm', 'a4',true);

        let dt =new Date().toLocaleString();
        let conversation: Conversation | null | undefined;
        let convId = "";
        let pgm = "";
        const roleText = getTranslatedText("role");
        const stoppedText = getTranslatedText("stopped-answer");
        const relatedQuestionsText = getTranslatedText("related-questions");
        const aiContentText = getTranslatedText("ai-content");

        conversation = appStateContext?.state?.currentChat;
        // console.log('conversation', conversation);
        if (conversation){
            convId = conversation.id;
        }
        if ( branding?.header_title !== undefined) {
            pgm = branding?.header_title;
        }

        // Preload fonts needed for this conversation
        if (conversation) {
            const messages = conversation.messages
                .filter((answer) => answer.role !== ERROR && answer.role !== TOOL)
                .map((msg) => ({ content: msg.content }));

            try {
                await preloadFontsForMessages(pdf, messages);
            } catch (error) {
                console.error('Error preloading fonts:', error);
            }
        }

        pdf.setFontSize(14)
        var pageHeight = pdf.internal.pageSize.getHeight();
        var y = 65

        if (conversation) {
            let r = conversation?.messages.filter((answer) => answer.role !== ERROR && answer.role !== TOOL);
            let messageIndex = 0;

            // Iterate through each message in the conversation for processing
            r.forEach((item) => {
                let msgList= ""
                let isUserMessage = false;

                if (item.role === 'user') {
                    // User message
                    // Try to get translated user message from DOM first
                    const translatedText = getTranslatedUserMessage(messageIndex);
                    const contentToUse = translatedText || item.content;
                    msgList += `${roleText} ` + contentToUse;
                    isUserMessage = true;
                } else {
                    // Assistant message
                    if (item.isStopped === true) {
                        msgList += `[${stoppedText}]\n`;
                    }
                    msgList += `${agentName}: ` + item.content;
                    if (item.context && item.context.followup_questions) {
                        msgList += `\n${relatedQuestionsText}\n`;
                        item.context.followup_questions.forEach((question, index) => {
                            msgList += `${index + 1}. ${question}\n`;
                        });
                    }
                    msgList += `\n\n*** ${aiContentText} ***`
                }

              // Remove HTML anchor tags from the message
              msgList = msgList.replace(/<a\s+href="[^"]*">([^<]+)<\/a>/gi, '$1');
              // Remove citation markers ([docX]) and the malformed ones the model
              // emits on case records ([doc?], [doc-case]) here, on the whole
              // message: the word loop below splits on "?" so it never sees "[doc?]"
              msgList = msgList.replace(/ ?\[doc[^\]]*\]/gi, '');

              // Set font for this message
              if (isArabic(msgList)) {
                pdf.setFont('NotoSansArabic', isUserMessage ? 'bold' : 'normal');
              }  else if (isKorean(msgList)) {
                pdf.setFont('NotoSansKR', isUserMessage ? 'bold' : 'normal');
              }  else if (isChinese(msgList)) {
                pdf.setFont('NotoSansSC', isUserMessage ? 'bold' : 'normal');
              } else {
                pdf.setFont('Roboto', isUserMessage ? 'bold' : 'normal');
              }

              // Split and process this message
              var messageLines = pdf.splitTextToSize(msgList, 180);

              // Iterate through each line in the message
              messageLines.forEach((line: string, i: number ) => {
                  if (y + 15 > pageHeight) {
                    y = 65;
                    pdf.addPage();
                  }
                  // Process words for proper formatting and font handling
                  let words = line.split(/(\s+|[.,!?;:])/);
                  let isArabicText = isArabic(line);

                  // Reverse the order of words for Arabic text
                  if (isArabicText) {
                    words = words.reverse();
                  }

                  let x = 8; // Initialize horizontal position
                  let txtHeight = 0;

                  // Iterate through each word
                  words.forEach((word) => {
                    // Remove citation markers like [docX], plus the malformed
                    // [doc] / [doc?] / [doc-case] the model sometimes emits on case records
                    word = word.replace(/ ?\[doc[^\]]*\]/gi, '');

                    // Remove markdown links and extract the hypertext
                    word = word.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

                    // Replace ** with double spaces
                    word = word.replace(/\*\*(.*?)\*\*/gs, '  $1  ');

                    txtHeight = pdf.getTextDimensions(word).h;
                    if (txtHeight > 0) {
                      // Check if the word exceeds the margin
                      if (x + pdf.getTextWidth(word) > 200) {
                          x = 8; // Reset horizontal position
                          y += txtHeight; // Move to the next line
                      }
      
                      pdf.text(word, x, y);
                      x += pdf.getTextWidth(word); // Increment horizontal position
                  }
                });
                y = y + 7; // Move to next line with minimum spacing
              });
              // Increment message index for translated user messages
              messageIndex++;
              // Add extra spacing between messages
              if (!isUserMessage) {
                  y += 5;
              }
          });
        }
        
        pdf = addHeaders(pdf, convId,dt,pgm);
        pdf= addWaterMark(pdf);
        pdf = addFooters(pdf);
        return { pdf, dt };
    };

    const exportChatPDF = async () => {
        setIsPopoverOpen(false);
        const { pdf, dt } = await generateChatPDF();
        pdf.save("Chat_History_"+ dt +".pdf");
    };
       
    const exportChat = () => {
        setIsPopoverOpen(false);
        //const fileData =  appStateContext?.state.chatHistory;
        let dt =new Date().toLocaleString();
        let msgList = 'Chat History ' + dt + '\n\n';
        let conversation: Conversation | null | undefined;
        conversation = appStateContext?.state?.currentChat;
        if (conversation){
            let r = conversation?.messages.filter((answer) => answer.role !== ERROR && answer.role !== TOOL);
            r.forEach((item) => {
                if (item.role === 'user'){
                    msgList += 'User: ' + item.content + '\n';
                }
                else {
                    msgList += 'Priya: ' + item.content + '\n\n';
                } 
            });

        }
       
        const blob = new Blob([msgList], { type: "text/plain" });
        //const blob = new Blob([fileData], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
         
        //link.download = "Chat_History_"+ dt +".txt";
        link.download = "Chat_History_"+ dt +".txt";
        link.href = url;
        link.click();
      }
    // #region newChat
    const newChatMisc = () => {
        if (isMsgPlaying) {
            //console.log("***stop msg playing and new chat")
            setStopMsgPlaying(true);
            setTimeout(() => newChat(), 100);
        }
        else {
            //console.log("***new chat")
            newChat();
        }
        
        
    };

    let isFirstAuthQuestion = window.sessionStorage.getItem("firstAuthQuestion");     

    const newChat = () => {
        //console.log(" New chat ")
        //console.log("STM " + stopMsgPlaying)
        window.sessionStorage.removeItem("firstAuthQuestion");
        window.sessionStorage.removeItem("profile");
        window.sessionStorage.removeItem("ivrProfile");
        window.sessionStorage.removeItem('pendingAuthFAQ');
        setProcessMessages(messageStatus.Processing)
        setQuestionV("")
        setMessages([]);
        setAnswers([]);
        setSpeechUrls([]);
        setIsCitationPanelOpen(false);
        setActiveCitation(undefined);
        setIsIntentsPanelOpen(false);
        setauthFields("");
        setauthType("");
        // A B2C sign-in and its selected case outlive the conversation, so keep them for the next chat
        if (!b2cAuthResponse) {
            updateAuthFieldsVal({});
            setSelectedDropdownCase("");
            setActiveCase("");
        }
        setIsStopped(false);
        setSearchTextCitation('');
        setCurrentMatchIndex(0);
        setTotalMatches(0);
        setMatchPositions([]);
        setText5Error('');
        appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: null });
        let date: Date= new Date();
        dt1 = date.toLocaleTimeString([], {hour: 'numeric', minute: '2-digit', hour12: true}) ;
        setIsNewConv(true);
        setProcessMessages(messageStatus.NotRunning)
        
        setStopMsgPlaying(false);
        //console.log("STM a " + stopMsgPlaying)
    };
    
    const signOut = async () => {
        setauthFields("");
        setauthType("");     
        updateAuthFieldsVal({});
        setProfilePaneData({});
        setSelectedProfileSection("");
        setIsProfilePaneOpen(false);
        setCaseSelectDialogOpen(false);
        setAddCaseDialogOpen(false);
        setSelectedDropdownCase("");
        setActiveCase("");
        setCasesVal("");
        setCaseNumbersAndNamesVal("");
        window.sessionStorage.removeItem('pendingAuthFAQ');
        window.sessionStorage.removeItem("profile");
        window.sessionStorage.removeItem("ivrProfile");
        window.sessionStorage.removeItem("selectedProgramConfig");
        window.sessionStorage.removeItem("selectedProgramCode");
        clearSessionToken();
        //setOpenSignOutDialog(false);
        handleAuthDialogClose();

        handleShowSlideIn({});
        if (b2cAuthResponse) {
          setTimeout(() => {
              setTimeout(() => {
                handleB2CSignOut();
              }, Number(branding?.signout_close_time) * 1900);
          }, 10);
      }
    };

    // Single merged Sign In/Out handler. When signed in via any source -> sign out.
    // Otherwise B2C-primary: prefer B2C sign-in when enabled, else open the IVR dialog (IVR-only sites).
    const handleMergedSignInOut = (closePopover: () => void, isMobile = false) => {
        if (isAnySignedIn) {
            signOut();
        } else if (b2cEnabled) {
            setQuestionV("");
            if (isMobile) setPopUpBlocker(false);
            handleB2CSignIn();
        } else {
            setauthType("msivr");
            setauthFields(ivrAuthFields ?? "");
            setQuestionV("");
            handleAuthDialogOpen();
        }
        closePopover();
    };

    // #endregion
    const onShowExecResult = () => {
        setIsIntentsPanelOpen(true)
    }
    // #region stopGenerating
    const stopGenerating = async () => {
        abortFuncs.current.forEach(a => a.abort());
        setShowLoadingMessage(false);
        setIsLoading(false);        
    
        const stoppedMessage: ChatMessage = {
            id: uuidv4(),
            role: "assistant",
            content: getTranslatedText("stopped-answer"),
            context: { followup_questions: null },
            date: new Date().toISOString(),
            prompt_tokens: 0,
            completion_tokens: 0,
            feedbackOnMsg: FeedbackEnum.Neutral,
        };
    
        // Update the messages state
        setMessages(prevMessages => {
            const updatedMessages = [...prevMessages, stoppedMessage];
            return updatedMessages;
        });
    
        const updatedMessages = [...messages, stoppedMessage];
        let conversationId = appStateContext?.state.currentChat?.id || "";
        // console.log('conversationId', conversationId);   
    
        // Update appStateContext with the new messages to keep the chat history in sync
        appStateContext?.dispatch({
            type: 'UPDATE_CURRENT_CHAT',
            payload: {
                id: conversationId,
                title: appStateContext?.state.currentChat?.title || '',
                date: new Date().toISOString(),
                messages: updatedMessages,
            }
        });
    
        appStateContext?.dispatch({
            type: 'UPDATE_CHAT_HISTORY',
            payload: {
                id: conversationId,
                title: appStateContext?.state.currentChat?.title || '',
                date: new Date().toISOString(),
                messages: updatedMessages,
            }
        });
    
        // Prepare the user message to generate the conversation history
        const userMessage = [...messages].reverse().find(msg => msg.role === 'user');
        if (!userMessage) {
            console.error("No user message found in previous messages.");
            return;
        }
    
        let generateRequest = {
            messages: updatedMessages,
            chatUUID,
        };  
    
        const abortController = new AbortController();
    
        try {
            // Generate new conversation history with the user message
            let generateResponse = await historyGenerate(generateRequest, abortController.signal, chatUUID, b2cAuthResponse, "English", "N", selectPgmCode, "", {}, conversationId, isStopped, hasStoppedGenerating?.current, msalInstance, settings);
            if (!generateResponse.ok) {
                console.error("Failed to generate chat history.");
                return;
            }
            const generateResponseData = await generateResponse.json();
            conversationId = generateResponseData.history_metadata?.conversation_id;

            if (conversationId !== appStateContext?.state.currentChat?.id) {
                // New conversation created - reset the messages state
                setMessages([]);
                setAnswers([]);
                setSpeechUrls([]);
                const newConversationMessages = updatedMessages.slice(-2); // Get only the latest user message and assistant answer
                
                appStateContext?.dispatch({
                    type: 'UPDATE_CURRENT_CHAT',
                    payload: {
                        id: conversationId,
                        title: generateResponseData.history_metadata?.title || '',
                        date: new Date().toISOString(),
                        messages: newConversationMessages,
                    }
                });
        
                appStateContext?.dispatch({
                    type: 'UPDATE_CHAT_HISTORY',
                    payload: {
                        id: conversationId,
                        title: generateResponseData.history_metadata?.title || '',
                        date: new Date().toISOString(),
                        messages: newConversationMessages,
                    }
                });
                setMessages(newConversationMessages);
                setAnswers([[newConversationMessages[0].content, { choices: [{ message: newConversationMessages[1].content, index: 0, has_toolmsg: "N" }] }]]);

                // Update conversation history with the new conversation
                let updateResponse = await historyUpdate(newConversationMessages, conversationId, chatUUID, b2cAuthResponse, selectPgmCode, true, hasStoppedGenerating?.current, copilotFormData);
                if (!updateResponse.ok) {
                    console.error("Failed to update chat history with newConversationMessages.");
                }
            } else {
                // Update existing conversation history with the stopped message
                appStateContext?.dispatch({
                    type: 'UPDATE_CURRENT_CHAT',
                    payload: {
                        id: conversationId,
                        title: appStateContext?.state.currentChat?.title || '',
                        date: new Date().toISOString(),
                        messages: updatedMessages,
                    }
                });
            
                appStateContext?.dispatch({
                    type: 'UPDATE_CHAT_HISTORY',
                    payload: {
                        id: conversationId,
                        title: appStateContext?.state.currentChat?.title || '',
                        date: new Date().toISOString(),
                        messages: updatedMessages,
                    }
                });
                
                setAnswers(prevAnswers => prevAnswers.map(([q, res]) => {
                    if (res.choices[0].message === "") {
                        return [q, { choices: [{ ...res.choices[0], message: stoppedMessage.content }] }];
                    }
                    return [q, res];
                }));  

                // Update existing conversation history with the stopped message
                let updateResponse = await historyUpdate(updatedMessages, conversationId, chatUUID, b2cAuthResponse, selectPgmCode, true, hasStoppedGenerating?.current, {});
                if (!updateResponse.ok) {
                    console.error("Failed to update chat history with updatedMessages.");
                }
            }
        } catch (err) {
            console.error("Error updating or generating chat history:", err);
        } finally {           
            abortController.abort();
            setIsDone(true);
            setProcessMessages(messageStatus.NotRunning)
            setStopMsgPlaying(false);
            setIsMsgRenderComplete(true);            
        }
    };
    // #endregion

    // #region processResultMessage    
    let assistantMessage = {} as ChatMessage
    let toolMessage = {} as ChatMessage
    let assistantContent = ""
    let assistantContext ={}  as ResponseContext
    let assistantContextO = {} as ResponseContext
    const processResultMessage = (resultMessage: ChatMessage, userMessage: ChatMessage, conversationId?: string) => {
        if (resultMessage.content.includes('all_exec_results')) {
            const parsedExecResults = JSON.parse(resultMessage.content) as AzureSqlServerExecResults
            setExecResults(parsedExecResults.all_exec_results)
        }
        if (resultMessage.role === ASSISTANT) {
            //console.log("assistant" + JSON.stringify(resultMessage))
            //console.log("user" + JSON.stringify(userMessage))   
            assistantContent += resultMessage.content
            assistantMessage = resultMessage
            assistantMessage.content = assistantContent
            assistantMessage.feedbackOnMsg = FeedbackEnum.Neutral
            assistantMessage.isFaq = resultMessage.isFaq
            if (resultMessage.context !== undefined){
                //console.log("assistant" + resultMessage.context)
                assistantContext= resultMessage.context 
                //console.log("assistant follow up" + assistantContext.followup_questions)
                assistantMessage.context = assistantContext
            }
            //console.log("assistant" + JSON.stringify(assistantMessage))
        }

        if (resultMessage.role === TOOL){
            toolMessage = resultMessage
        } 

        if (!conversationId) {
            isEmpty(toolMessage) ?
                setMessages([...messages, userMessage, assistantMessage]) :
                setMessages([...messages, userMessage, toolMessage, assistantMessage]);
        } else {
            isEmpty(toolMessage) ?
                setMessages([...messages, assistantMessage]) :
                setMessages([...messages, toolMessage, assistantMessage]);
        }
    };
    // #endregion

  

    // #region makeApiRequest
    const [isVerified, setIsVerified] = useState(false);
    type LoginValidationResult = { status: string; profilePaneData: any };
    const validateLogin = async (caseNumber = caseInputFieldsVal || '', programNameOverride = '') => {
        let validLoginReturn = "Invalid login credentials";
        let validatedProfilePaneData: any = {};
        let openPaneAfterLoad = false;
        //console.log("comes here to validate login")
        const submittedCaseNumber = caseNumber.trim();
        const resolvedAuthType = authTypeVRef.current || authTypeV || (b2cAuthResponse ? "profile" : "");
        const authFieldsPayload = { ...authFieldsValRef.current };
        if (authFieldsPayload.casenumber?.trim() === "No cases found.") {
          delete authFieldsPayload.casenumber;
        }
        const authPayload = {
          ...authFieldsPayload,
          ...((!authFieldsPayload.oid && b2cClaims?.oid) ? { oid: b2cClaims.oid } : {}),
          ...(submittedCaseNumber ? { casenumber: submittedCaseNumber } : {})
        };

        let conversationId = appStateContext?.state.currentChat?.id ? appStateContext?.state.currentChat?.id :""
        const programName = programNameOverride || selectPgm;
        
        let r = await signOnValidate(authPayload, resolvedAuthType, chatUUID, programName, conversationId, b2cAuthResponse, false, msalInstance, settings);

        if (!r.ok) {
            if (b2cAuthResponse && enableProfilePanel) {
                const profileVerificationErrorMessage = "We couldn't verify your profile right now. Please sign out and sign back in, then try again.";
                setText5Error(profileVerificationErrorMessage);
                return { status: profileVerificationErrorMessage, profilePaneData: validatedProfilePaneData };
            }

            let errorMessage = "";
            try {
                const errorData = await r.json();
                errorMessage = errorData?.error || errorData?.message || "";
            } catch {
                errorMessage = await r.text().catch(() => "");
            }

            if (errorMessage) {
                setText5Error(errorMessage);
            }
            return { status: validLoginReturn, profilePaneData: validatedProfilePaneData };
        }

        if (r.ok) {
            const data = await r.json();
            if (data && data.profile && data.profile.length > 0) {
              validatedProfilePaneData = { profile: data.profile };
              
              if (data.template && Object.keys(data.template).length > 0) {
                const infoTemplateData = data.template || {};
                validatedProfilePaneData = {
                  ...infoTemplateData,
                  profile: data.profile,
                };
                setProfilePaneData((prev: any) => mergeProfilePaneData(prev, validatedProfilePaneData));

                if (branding?.profile_pane_default_open === "true" && branding?.show_signin === "Y" && enableProfilePanel){
                  // Deferred to the end of validateLogin so the pane only opens
                  // once the information-template sections have loaded too
                  openPaneAfterLoad = true;
                } else if (branding?.profile_pane_default_open === "false" && branding?.show_signin === "Y") {
                  setIsProfilePaneOpen(false);
                }
              }

              window.sessionStorage.setItem("profile", data);
                if ("cases" in data.profile[0]) {
                   const rawCases = Array.isArray(data.profile[0].cases) ? data.profile[0].cases : [];

                   const firstNames = data.profile[0].first_names && typeof data.profile[0].first_names === "object" ? data.profile[0].first_names : {};

                   const cases = rawCases
                    .map((caseNumber: unknown) => String(caseNumber).trim())
                    .filter((caseNumber: string) => caseNumber && caseNumber !== "No cases found.");
                   setMemberFirstNames(firstNames);

                   const submittedCaseMissing =
                    submittedCaseNumber &&
                    (!cases.includes(submittedCaseNumber) || (Object.keys(firstNames).length > 0 && !(submittedCaseNumber in firstNames)));
                    
                   if (submittedCaseMissing) {
                      validLoginReturn = getTranslatedText('error-case-not-found');
                      setText5Error(validLoginReturn);
                      // The rejected number was staged as the active case while it was
                      // being typed; fall back to a case that is actually on the profile
                      const fallbackCase = cases.includes(activeCaseRef.current) ? activeCaseRef.current : (cases.length === 1 ? cases[0] : "");
                      updateAuthFieldsVal(prev => ({ ...prev, casenumber: fallbackCase }));
                      setActiveCase(fallbackCase);
                   } else if (cases.length === 0) {
                      validLoginReturn = "No cases found.";
                      updateAuthFieldsVal(prev => ({
                        ...prev,
                        casenumber: "No cases found."
                      }));
                    } else if (cases.length === 1) {
                      // Handle single case
                      setCasesVal(cases[0]);
                      setCaseNumbersAndNamesVal("");
                      updateAuthFieldsVal(prev => ({
                        ...prev,
                        casenumber: cases[0]
                      }));
                      setActiveCase(cases[0]);
                      validLoginReturn = "";
                      await fetchCaseDbInfoTemplate(cases[0]);
                    } else {
                      // Handle multiple cases
                      const casesString = cases.join(',');
                      setCasesVal(casesString);
                      setCaseNumbersAndNamesVal("");
                      if (submittedCaseNumber) { // If new case was added, set it as default
                        updateAuthFieldsVal(prev => ({
                          ...prev,
                          casenumber: submittedCaseNumber
                        }));
                        setActiveCase(submittedCaseNumber);
                        validLoginReturn = "";
                        await fetchCaseDbInfoTemplate(submittedCaseNumber);
                      } else { // If no new case is being added, trigger handleCaseSelectDialogOpen()
                        validLoginReturn = "Multiple cases found";
                      }
                  }
                }
              }
            } 
        if (openPaneAfterLoad) {
          openProfilePane();
        }
        return { status: validLoginReturn, profilePaneData: validatedProfilePaneData } as LoginValidationResult;
    }

    let signedIn = window.sessionStorage.getItem("profile");

    const makeApiRequestB2CAuthValidate = async (keepLoadingAfterValidate = false) => {
      if (branding?.show_profile_panel !== "Y") {
        return;
      }
      if (b2cAuthResponse) {
        setShowPageLoading(true);
        setPopUpBlocker(true);
        setIsSignOnInProgress(true);

        let validation = await validateLogin();

        const selectedProgramCode = selectPgmCode || window.sessionStorage.getItem("selectedProgramCode") || "";

        const shouldAssignExternalProgramPostSignin =
          appStateContext?.state.b2cInternalAuthState === 'not_applicable' &&
          !hasInternalPrograms &&
          !!selectedProgramCode &&
          !selectedProgramCode.toLowerCase().includes("selectpgm") &&
          !hasAssignedProgram(validation.profilePaneData, selectedProgramCode);

        if (shouldAssignExternalProgramPostSignin) {
          const result = await handleExternalProgramAssignment(selectedProgramCode, authFieldsValRef.current);
          if (result.success) {
            validation = await validateLogin();
            const response = await refreshfrontendSettings(
              window.sessionStorage.getItem('selectedProgramConfig') || configCode,
              document.documentElement.lang,
              selectedProgramCode,
              msalInstance,
              settings
            );
            if (response) {
              appStateContext?.dispatch({ type: 'ENV_UPDATE_FRONTEND_SETTINGS', payload: response as FrontendSettings });
            }
          }
        }

        let r = validation.status;
        if (!keepLoadingAfterValidate) {
          setShowPageLoading(false);
        }
        if (r === "" || r === "No cases found.") {
            resumePendingAuthRequest(activeCaseRef.current);
            setIsSignOnInProgress(false);
            if (!keepLoadingAfterValidate) {
              setPopUpBlocker(false);
            }
        } 
        else if (r === "Multiple cases found") {
          // Show modal to select case
          handleCaseSelectDialogOpen();
        }
        else {
            setIsSignOnInProgress(false);
            if (!keepLoadingAfterValidate) {
              setPopUpBlocker(false);
            }
        }
      }
    }

    const [isFocusTrapActive, setIsFocusTrapActive] = useState(false);
    const [isFocusTrapPaused, setIsFocusTrapPaused] = useState(false);
    const [isOtherFocusTrapOpen, setIsOtherFocusTrapOpen] = useState(false);

    const handleCaseSelectDialogOpen = () => {
        setPopUpBlocker(false);
        setCaseSelectDialogOpen(true);
        setIsPopoverOpen(false);
        setIsSignInPopoverOpen(false);
        setSelectedDropdownCase(activeCase);
        setTimeout(() => {
            document.getElementById("caseSelect-close")?.focus();
        }, 200);

        setIsFocusTrapActive(false);
        const dropdown = document.querySelector('.ms-Dropdown-container') as HTMLElement;
        if (dropdown) {
            dropdown.focus(); // Explicitly set focus back to the dropdown
        }

    };

    const handleCaseSelectDialogClose = () => {
      setIsSignOnInProgress(false);
      setPopUpBlocker(false);
      setCaseSelectDialogOpen(false);
      setIsFocusTrapActive(true); // Ensure FocusTrap is deactivated
      setTimeout(() => {
          document.getElementById("additional-chat-options")?.focus();
      }, 600);
      if (isProfilePaneOpen && isFocusTrapActive){
        document.getElementById("profile-close")?.focus();
      } else if (document.getElementById("additional-chat-options")) {
        document.getElementById("additional-chat-options")?.focus();
      } else {
        document.getElementById("sign-in-out-icon")?.focus();
      }
  };

    const handleAddCaseDialogOpen = (source: "profile" | "auth" = "profile") => {
      setPopUpBlocker(false);
      setAddCaseDialogSource(source);
      setAddCaseDialogOpen(true);
      setTimeout(() => {
        document.getElementById("addCase-close")?.focus();
      }, 200);

      setIsFocusTrapActive(false);
      const inputField = document.getElementById('caseNumber') as HTMLElement;
      if (inputField) {
        inputField.focus(); // Explicitly set focus back to the input field
      }
    }

    const handleAddCaseDialogClose = () => {
      setPopUpBlocker(false);
      setAddCaseDialogOpen(false);
      setAddCaseDialogSource("profile");
      setCaseInputFieldsVal('')
      setText5Error('');
      setIsFocusTrapActive(true); // Ensure FocusTrap is deactivated
      setTimeout(() => {
          document.getElementById("additional-chat-options")?.focus();
      }, 600);
      if (isProfilePaneOpen && isFocusTrapActive){
        document.getElementById("profile-close")?.focus();
      } else if (document.getElementById("additional-chat-options")) {
        document.getElementById("additional-chat-options")?.focus();
      } else {
        document.getElementById("sign-in-out-icon")?.focus();
      }
    }

    const handleSubmitCase = async () => {
      const submittedCaseNumber = caseInputFieldsVal.trim();
      if (isLoading || !submittedCaseNumber) return; // Don't proceed if field is empty

      // Check if case exists in current options
      const existingCases = casesVal.split(',').map(c => c.trim()).filter(Boolean);
      if (existingCases.includes(submittedCaseNumber)) {
        setText5Error(getTranslatedText('error-case-exists'));
        return;
      }
      setIsLoading(true);
      const validationResult = await validateLogin(submittedCaseNumber);
      setIsLoading(false);
      if (validationResult.status !== "") {
        setIsVerified(false);
        return;
      }
      setIsVerified(true);
      setCaseInputFieldsVal('');
      setText5Error('');
      const shouldCloseAfterSubmit = addCaseDialogSource === "auth" && validationResult.status === "";
      setTimeout(() => {
        setIsVerified(false);
        if (shouldCloseAfterSubmit) {
          handleAddCaseDialogClose();
            resumePendingAuthRequest(submittedCaseNumber);
        }
      }, 1000);
    };

    const onCaseFieldValChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setCaseInputFieldsVal(event.target.value);
        updateAuthFieldsVal(prev => ({
          ...prev,
          casenumber: event.target.value
        }));
        setText5Error('');
    };
    
    const handleSubmit = async () => {
      if (selectedDropdownCase && selectedDropdownCase !== activeCase) {
        setActiveCase(selectedDropdownCase);
        updateAuthFieldsVal(prev => ({
        ...prev,
        casenumber: selectedDropdownCase
        }));
        setIsLoading(true);
      
        setTimeout(async () => {
          setIsLoading(false);
          setIsVerified(true);
          
          setTimeout(async () => {
            if (ivrProfile) {
              setPopUpBlocker(true);
              const infoTemplateResponse = await fetchInformationTemplate(authFieldsValRef.current, authTypeV);
              if (infoTemplateResponse && infoTemplateResponse.status === 200) {
                const infoTemplateData = await (infoTemplateResponse as Response).json();
                const updatedProfilePaneData = updateProfilePaneDataWithCaseNames(infoTemplateData, caseNumbersAndNamesVal, selectedDropdownCase);
                setProfilePaneData((prev: any) => mergeProfilePaneData(prev, updatedProfilePaneData));
                if (showAuthDialogMessage && branding?.profile_pane_default_open === "true") {
                  openProfilePane();
                }
              }
            }
            await fetchCaseDbInfoTemplate(selectedDropdownCase);
            setIsVerified(false);
            setPopUpBlocker(false);
            setCaseSelectDialogOpen(false);
            // Close the Auth Dialog if open
            handleAuthDialogClose();

            // If there's a pending question, process it
            resumePendingAuthRequest(selectedDropdownCase);
          }, 3000);
        }, 2500);
        setIsSignOnInProgress(false);
    }
  }

  const actionHandlers: Record<string, () => void> = {
      handleCaseSelectDialogOpen,
      signOut,
      handleB2CProfileEdit,
      handleAddCaseDialogOpen,
    };

  const applyServerProfileResponse = (profile: any, template: any) => {
    if (!profile || !Array.isArray(profile) || profile.length === 0) return;
    if (template && typeof template === "object" && Object.keys(template).length > 0) {
      setProfilePaneData((prev: any) => mergeProfilePaneData(prev, { ...template, profile }));
    } else {
      setProfilePaneData((prev: any) => mergeProfilePaneData(prev, { profile }));
    }
  };

  const onExternalProgramSelect = async (programCode: string) => {
    const currentProgramCode = window.sessionStorage.getItem('selectedProgramCode') || selectPgmCode;
    const currentProgramConfig = window.sessionStorage.getItem('selectedProgramConfig') || configCode;
    let loadingCleared = false;
    setShowPageLoading(true);
    setPopUpBlocker(true);
    try {
      const result = await handleExternalProgramAssignment(programCode, authFieldsValRef.current);
      if (!result.success) return;
      if (currentProgramCode) {
        window.sessionStorage.setItem('selectedProgramCode', currentProgramCode);
        setSelectPgmCode(currentProgramCode);
      }
      if (currentProgramConfig) {
        window.sessionStorage.setItem('selectedProgramConfig', currentProgramConfig);
      }

      // Avoid stale reads by using the returned profile.
      applyServerProfileResponse(result.profile, result.template);

      const response = await refreshfrontendSettings(
        currentProgramConfig,
        document.documentElement.lang,
        currentProgramCode,
        msalInstance,
        settings
      );
      appStateContext?.dispatch({ type: 'ENV_UPDATE_FRONTEND_SETTINGS', payload: response as FrontendSettings });
      setShowPageLoading(false);
      loadingCleared = true;
    } finally {
      if (!loadingCleared) {
        setShowPageLoading(false);
      }
      setPopUpBlocker(false);
    }
  };

  const onExternalProgramRemove = async (programCode: string) => {
    const currentProgramCode = window.sessionStorage.getItem('selectedProgramCode');
    const removingActive = currentProgramCode === programCode;
    let loadingCleared = false;
    setShowPageLoading(true);
    setPopUpBlocker(true);
    try {
      const result = await handleExternalProgramRemoval(programCode, authFieldsValRef.current);
      if (!result.success) return;

      let nextProgramCode = currentProgramCode;
      let nextProgramConfig = configCode || window.sessionStorage.getItem('selectedProgramConfig') || "";

      if (removingActive) {
        // Switch to a remaining program so the server can resolve branding from its env.
        const nextEntry = (result.external_programs || [])
          .map(code => pList.find((p: string) => p.split("<>")[1]?.trim() === code))
          .find(Boolean);
        const parts = nextEntry ? nextEntry.split("<>") : [];
        const nextName = parts[0]?.trim() || "";
        nextProgramCode = parts[1]?.trim() || "";
        nextProgramConfig = parts[3]?.trim() || "";

        window.sessionStorage.setItem('selectedProgramCode', nextProgramCode);
        window.sessionStorage.setItem('selectedProgramConfig', nextProgramConfig);
        setSelectPgm(nextName);
        setSelectPgmCode(nextProgramCode);
        setConfigCode(nextProgramConfig);
      }

      // Avoid stale reads by using the returned profile.
      applyServerProfileResponse(result.profile, result.template);
      const response = await refreshfrontendSettings(
        nextProgramConfig,
        document.documentElement.lang,
        nextProgramCode,
        msalInstance,
        settings
      );
      appStateContext?.dispatch({ type: 'ENV_UPDATE_FRONTEND_SETTINGS', payload: response as FrontendSettings });
      setShowPageLoading(false);
      loadingCleared = true;
    } finally {
      if (!loadingCleared) {
        setShowPageLoading(false);
      }
      setPopUpBlocker(false);
    }
  };

  const onCaseRemove = async (caseNumber: string) => {
    const removingActive = activeCase === caseNumber;
    let loadingCleared = false;
    setShowPageLoading(true);
    setPopUpBlocker(true);
    try {
      const result = await handleCaseRemoval(caseNumber, authFieldsValRef.current);
      if (!result.success) return;

      const remaining = result.cases || [];
      if (removingActive) {
        const nextCase = remaining[0] || "";
        setActiveCase(nextCase);
        setSelectedDropdownCase(nextCase);
        activeCaseRef.current = nextCase;
        updateAuthFieldsVal(prev => ({ ...prev, casenumber: nextCase }));
      }
      setCasesVal(remaining.join(','));

      // Avoid stale reads by using the returned profile.
      applyServerProfileResponse(result.profile, result.template);
      if (removingActive) {
        // Merge never drops sections, so remove the case's own ones explicitly
        const caseSections = caseDbSectionsRef.current;
        caseDbSectionsRef.current = [];
        setProfilePaneData((prev: any) => removeCaseDbSections(prev, caseSections));
        if (remaining[0]) {
          await fetchCaseDbInfoTemplate(remaining[0]);
        }
      }
      setShowPageLoading(false);
      loadingCleared = true;
    } finally {
      if (!loadingCleared) {
        setShowPageLoading(false);
      }
      setPopUpBlocker(false);
    }
  };

  const showSwitchCases = casesVal.includes(',');

  const activeCaseRef = useRef(activeCase);
  useEffect(() => {
    activeCaseRef.current = activeCase;
  }, [activeCase]);
       
    const makeApiRequestAuthValidate = async () => {
      if (authTypeV.includes("ivr")) {
        // Validate fields before proceeding
        if (!validateAuthFields()) {
          return;
        }
        let response = await validateIVRLogin(authFieldsValRef.current.socialsecuritynumber, authFieldsValRef.current.dateofbirth);
        if (response && response.status === 200) {
          const data = await (response as Response).json();
          updateAuthFieldsVal(prev => ({
              ...prev,
              ivr_id: data.personNumber
          }));
          window.sessionStorage.setItem("ivrProfile", data.personNumber);
          if (Array.isArray(data.caseNumbers) && data.caseNumbers.length > 0) {
              setCasesVal(data.caseNumbers.join(','));
              setCaseNumbersAndNamesVal(data.caseNumbersAndNames.join(','));
              // If multiple cases, open case selection dialog
              if (data.caseNumbers.length > 1) {
                  setActiveCase(""); // Clear any previous selection
                  setSelectedDropdownCase(""); // Clear dropdown selection
                  handleCaseSelectDialogOpen();
                  return; // Wait for user to select a case
              } else {
                  // Only one case, select it automatically
                  setActiveCase(data.caseNumbers[0]);
                  updateAuthFieldsVal(prev => ({
                      ...prev,
                      casenumber: data.caseNumbers[0]
                  }))
              }
          }
          setIsVerified(true);
          setTimeout(async () => {
            setPopUpBlocker(true);
            const infoTemplateResponse = await fetchInformationTemplate(authFieldsValRef.current, authTypeV);
            if (infoTemplateResponse && infoTemplateResponse.status === 200) {
              const infoTemplateData = await (infoTemplateResponse as Response).json();
              const updatedProfilePaneData = updateProfilePaneDataWithCaseNames(infoTemplateData, data.caseNumbersAndNames.join(','), data.caseNumbers[0]);
              setProfilePaneData((prev: any) => mergeProfilePaneData(prev, updatedProfilePaneData));
              if (showAuthDialogMessage && branding?.profile_pane_default_open === "true") {
                openProfilePane();
              }
            }
            setIsSignOnInProgress(false);
            handleAuthDialogClose();
            setTimeout(() => {
              document.getElementById("question-input-textarea")?.focus();
            }, 100);
              if (questionV !== "") {
                let conversationId = appStateContext?.state.currentChat?.id ? appStateContext?.state.currentChat?.id : undefined
                makeApiRequest(questionV, isFaqV, "Y", conversationId, activeCaseRef.current);
                window.sessionStorage.setItem("firstAuthQuestion", "true");
              }
          }, 800);
        } else if (response && response.status === 401){
          const data = await (response as Response).json();
            if (data && data.error === "No case numbers found"){
              setText5Error(getTranslatedText('error-no-cases'));
              updateAuthFieldsVal({});
              setIsSignOnInProgress(false);
              setPopUpBlocker(false);
            } else {
              setText5Error(getTranslatedText('error-incorrect-info'));
              updateAuthFieldsVal({});
              setIsSignOnInProgress(false);
              setPopUpBlocker(false);
          }
      } else {
        setText5Error(getTranslatedText('error-validation-failed'));
        setIsSignOnInProgress(false);
        setPopUpBlocker(false);
      }
      } else {
        handleAuthDialogClose();
        let conversationId = appStateContext?.state.currentChat?.id ? appStateContext?.state.currentChat?.id : undefined
        makeApiRequest(questionV, isFaqV, "Y", conversationId, activeCaseRef.current);
        window.sessionStorage.setItem("firstAuthQuestion", "true");
      }
  }

    const validateIVRLogin = async (authfield1: string, authField2: string) => {
      try {
        setPopUpBlocker(true);
        setIsSignOnInProgress(true);
        
        let conversationId = appStateContext?.state.currentChat?.id ? appStateContext?.state.currentChat?.id : ""
        
        const response = await validateIVRCredentials(
          authfield1,
          authField2,
          authTypeV,
          chatUUID,
          selectPgmCode,
          conversationId
        );
        
        return response;
      } catch (error) {
        console.error("Error validating IVR credentials:", error);
        return {
          ok: false,
          status: 500,
          statusText: "Error validating credentials"
        };
      }
    }

    // Fetch the profile-pane information template for the given auth fields/type.
    // Shared by the legacy IVR (msivr) flow and the B2C case-DB flow.
    const fetchInformationTemplate = async (authFields: any, authType: string) => {
      try {
        let conversationId = appStateContext?.state.currentChat?.id ? appStateContext?.state.currentChat?.id : ""
        const response = await getIVRInformationTemplate(
          authFields,
          authType,
          chatUUID,
          selectPgmCode,
          conversationId
        );
        return response;
      } catch (error) {
        console.error("Error getting information template:", error);
        return {
          ok: false,
          status: 500,
          statusText: "Error getting information template"
        };
      }
    }

    // B2C case-DB flow: fetch + merge the case/financial sections when the
    // program's auth FAQs use profilecasedb. The legacy IVR flow (ivrProfile)
    // fetches its own template, so skip it here.
    const fetchCaseDbInfoTemplate = async (caseNumber: string) => {
      if (!caseDbAuthType || !caseNumber || caseNumber === "No cases found.") return;
      if (window.sessionStorage.getItem("ivrProfile")) return;
      const response = await fetchInformationTemplate(
        {
          ...authFieldsValRef.current,
          casenumber: caseNumber,
          firstname: String(b2cClaims?.given_name ?? ""),
          lastname: String(b2cClaims?.family_name ?? "")
        },
        caseDbAuthType
      );
      if (response && response.status === 200) {
        const infoTemplateData = await (response as Response).json();
        // Sections not also shown for B2C sign-in (b2c/shared tags); removed with the case
        const authTypes: Record<string, string[]> = infoTemplateData?.section_auth_types || {};
        caseDbSectionsRef.current = Object.keys(authTypes)
          .filter((title) => !authTypes[title].some((tag) => tag === "b2c" || tag === "shared"));
        setProfilePaneData((prev: any) => mergeProfilePaneData(prev, infoTemplateData));
      }
    };

    const caseDbSectionsRef = useRef<string[]>([]);

    const removeCaseDbSections = (prev: any, titles: string[]) => {
      if (!prev || titles.length === 0) return prev;
      const omit = (obj: any) => Object.fromEntries(Object.entries(obj || {}).filter(([key]) => !titles.includes(key)));
      return {
        ...prev,
        sections: (prev.sections || []).filter((title: string) => !titles.includes(title)),
        subsections: omit(prev.subsections),
        subsection_data: omit(prev.subsection_data),
      };
    };

    function updateProfilePaneDataWithCaseNames(
      profilePaneData: any,
      caseNumbersAndNamesVal: string,
      selectedCase: string
    ) {
      const regex = new RegExp(
        `${selectedCase}\\s*\\|\\s*NCP:\\s*([^,]+),\\s*CP:\\s*([^,|]+)`,
        "i"
      );
      const match = caseNumbersAndNamesVal.match(regex);

      const ncpName = match ? match[1].trim() : "";
      const cpName = match ? match[2].trim() : "";

      const newProfilePaneData = { ...profilePaneData };
      if (newProfilePaneData.subsection_data) {
        
        // Iterate through each section in subsection_data
        Object.keys(newProfilePaneData.subsection_data).forEach((sectionKey: string) => {
          const section = newProfilePaneData.subsection_data[sectionKey];
          if (Array.isArray(section)) {
            section.forEach((subsection: any) => {
              if (subsection.items && Array.isArray(subsection.items)) {
                subsection.items.forEach((item: any) => {
                  if (item.value === "<CP>") item.value = cpName;
                  if (item.value === "<NCP>") item.value = ncpName;
                });
              }
            });
          }
        });
      }
      return newProfilePaneData;
    }

    // Union two profile-pane responses so B2C and IVR sections coexist instead of overwriting
    // each other. Each backend response carries only its own (authType-tagged) sections.
    function mergeProfilePaneData(prev: any, incoming: any) {
      if (!prev || Object.keys(prev).length === 0) return incoming;
      if (!incoming || Object.keys(incoming).length === 0) return prev;

      const prevSections: string[] = Array.isArray(prev.sections) ? prev.sections : [];
      const incomingSections: string[] = Array.isArray(incoming.sections) ? incoming.sections : [];
      const mergedSections = [
        ...prevSections,
        ...incomingSections.filter((title) => !prevSections.includes(title)),
      ];

      return {
        ...prev,
        ...incoming,
        sections: mergedSections,
        subsections: { ...(prev.subsections || {}), ...(incoming.subsections || {}) },
        subsection_data: { ...(prev.subsection_data || {}), ...(incoming.subsection_data || {}) },
        profile: incoming.profile ?? prev.profile,
      };
    }

    const ivrProfile = window.sessionStorage.getItem("ivrProfile") || '';

    // Signed in via any auth source (B2C and/or IVR). Drives the single merged Sign In/Out item.
    const isAnySignedIn = Boolean(b2cAuthResponse) || Boolean(ivrProfile) || Boolean(signedIn);

    useEffect(() => {
        authTypeVRef.current = authTypeV;
    }, [authTypeV]);

    useEffect(() => {
      if (text5Error === "Invalid login credentials"){
        setTimeout(() => {
          document.getElementById("loginUser")?.focus();
        }, 200);
      }
  },[text5Error])

   
const makeApiRequestAuth = async (
    question: string,
    isFaq: string,
    answer: string,
    requiresAuth: string,
    authType: string,
    authFields: string
  ) => {
    if (requiresAuth !== "Y") {
      makeApiRequestAfterClear(question, isFaq, "N");
      return;
    }

    // Store pending auth data
    writePendingAuthRequest({
      question,
      isFaq,
      answer,
      requiresAuth,
      authType,
      authFields
    });

    // Set state
    setauthFields(authFields);
    setauthType(authType);
    authTypeVRef.current = authType;
    setQuestionV(question);
    setIsFAQV(isFaq);

    const caseList = casesVal.split(',').map(caseNumber => caseNumber.trim()).filter(Boolean);
    const selectedCase = authFieldsValRef.current.casenumber?.trim() || "";
    const hasValidCase = !!selectedCase && selectedCase !== "No cases found.";
    const hasNoCases = caseList.length === 0 || selectedCase === "No cases found.";
    const isProfileAuth = authType.includes("profile");
    const isIvrAuth = authType.includes("ivr");
    const hasMultipleCases = caseList.length > 1;
    const singleCase = caseList.length === 1 ? caseList[0] : "";

    // LAMI/IVR authentication (non-profile auth types)
    if (!isProfileAuth) {
      if (showAuthDialogMessage) {
        return;
      }

      if (isIvrAuth) {
        if (!ivrProfile) {
          handleAuthDialogOpen();
          return;
        }
      } else if (!signedIn && !hasValidCase) {
        handleAuthDialogOpen();
        return;
      }
    }

    // Already have valid auth fields - proceed directly
    if (hasValidCase) {
      makeApiRequestAfterClear(question, isFaq, requiresAuth);
      return;
    }

    // Profile-based auth
    if (isProfileAuth) {
      if (!b2cAuthResponse) {
        handleB2CSignIn();
      } else if (hasNoCases) {
        handleAddCaseDialogOpen("auth");
      } else if (hasMultipleCases) {
        handleCaseSelectDialogOpen();
      } else {
        updateAuthFieldsVal(prev => ({ ...prev, casenumber: singleCase }));
        makeApiRequestAfterClear(question, isFaq, requiresAuth);
      }
      return;
    }
  }

    const makeApiRequestAfterClear = async (question: string, isFaq: string, requiresAuth: string) => {
      //  newChat();
        let conversationId = appStateContext?.state.currentChat?.id ? appStateContext?.state.currentChat?.id : undefined
        makeApiRequest(question, isFaq, requiresAuth,conversationId, activeCaseRef.current);
    }

    const languageNames = new Intl.DisplayNames(['en'], {
        type: 'language'
    });
    const exportSummary = async ( userMessage: ChatMessage, assistantMessage:ChatMessage) => {
        //console.log("I am asked to get a summary")
        let conversation: Conversation | null | undefined;
        let convId = "";

        conversation = appStateContext?.state?.currentChat;
        if (conversation) {
            convId = conversation.id;
        }
        conversation = appStateContext?.state?.chatHistory?.find((conv) => conv.id === convId)
        let request: ConversationRequest;
        let messages=[]
        if (!conversation) {
           
            messages.push(userMessage);
            messages.push(assistantMessage);

            //console.log("***no conversation for transcript")
            //setTranscript("");
        } else {
            messages = [...conversation.messages.filter((answer) => answer.role !== ERROR && answer.role !== TOOL)]
        }

        request = {
            messages:messages,
            chatUUID,
        };
        //console.log("here are my messages")
        //console.log(request)
        const response = await summaryGenerate(request, chatUUID, selectPgm, convId)

        if (response.body) {
            let reader = response.body.getReader();
            const { done, value } = await reader.read();
            var text = new TextDecoder("utf-8").decode(value);
            //console.log("***My transcript is, " +  text);
            setTranscript(text);
        }
        return "OK";

        
    };
    const makeApiRequest = async (question: string,isFaq:string, requiresAuth: string, conversationId?: string, activeCase?: string) => {
        let tranferToCopilotFlow = false;
        let flow_name = ""
             
        setIsStopped(false);
        hasStoppedGenerating.current = false;
        setPartiallyRenderedText("");        
        let clearAuthFields = false;
        //console.log("make api request" , authTypeV , authFieldsValRef.current, requiresAuth)
        let tranferToAgent = false;
        setStopMsgPlaying(true);
        let lan = ! isUndefined(languageNames.of(document.documentElement.lang)) ? languageNames.of(document.documentElement.lang) : "English";
        
        let lang = "English"
        if (! isUndefined(lan)){
            lang = lan;
        }
        // Updates the authType to reflect the question asked
        let updatedAuthType = authTypeVRef.current;
        let useUpdatedAuthType = false;      
        if (isFaq === "N" && fList.length > 0) {
            // Typed question
            const normalizeString = (str: string) => 
                str.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()?'"\[\]\|<>+@\\]/g, "")
                .replace(/\s{2,}/g, " ")
                .toLowerCase();
                const normalizedQuestion = normalizeString(question);
                const faqQuestions = fList.map(faq => normalizeString(faq.question));
                const bestMatch = stringSimilarity.findBestMatch(normalizedQuestion, faqQuestions);
                var faqItem = bestMatch.bestMatch.rating > 0.8 ? fList[bestMatch.bestMatchIndex] : null;
                
                const similarQuestions: { [key: string]: string } = {};
                fList.forEach(faq => {
                    (faq as any).similarQuestions?.forEach((similarQuestion: string) => {
                        const normalizedSimilarQuestion = normalizeString(similarQuestion);
                        similarQuestions[normalizedSimilarQuestion] = faq.requiresAuth;
                        if (normalizedQuestion === normalizedSimilarQuestion){
                            faqItem = faq;
                        }
                    });
                });
                
                requiresAuth = similarQuestions[normalizedQuestion] || (faqItem && faqItem.requiresAuth === 'Y' ? 'Y' : 'N');
                
            if (requiresAuth === 'Y') {
                useUpdatedAuthType = true;
                updatedAuthType = faqItem && faqItem.authType !== '' ? faqItem.authType : '';
                let  rauthFields = faqItem && faqItem.authFields !== '' ? faqItem.authFields : '';
                isFaq = 'Y';
                setauthType(updatedAuthType || "");
                setauthFields(rauthFields || "");
            
             
            }
        }
        const scopedCase = authFieldsValRef.current.casenumber?.trim() || activeCaseRef.current || "";
        const caseScope = requiresAuth === 'N' && isFaq === 'N' && caseDbAuthType && b2cAuthResponse && scopedCase && scopedCase !== "No cases found." ? "Y" : "N";
        // The caller's identity for case records comes from the B2C token the
        // request carries (see historyGenerate), never from these fields
        const caseAuthFields = caseScope === "Y" ? { ...authFieldsValRef.current } : {};
        // A case question needs a live B2C token. If the session has expired (the page
        // still looks signed in, but MSAL can't renew silently), prompt to sign in
        // again and resend the question afterwards instead of answering without the case
        if (caseScope === "Y" && !(await getAccessToken(msalInstance, settings))) {
            writePendingAuthRequest({ question, isFaq, answer: "", requiresAuth: "N", authType: "", authFields: "" });
            setQuestionV(question);
            setIsFAQV(isFaq);
            handleB2CSignIn();
            return;
        }
        if (requiresAuth === 'Y') {
            if (isFirstAuthQuestion) {
                window.sessionStorage.setItem("firstAuthQuestion", "false");
            } else {
                window.sessionStorage.setItem("firstAuthQuestion", "true");
            }
          writePendingAuthRequest({
            question,
            isFaq,
            answer: "",
            requiresAuth,
            authType: updatedAuthType || "",
            authFields: authFields || "",
          });
        }

        // Requests b2c authentication if required
        if (requiresAuth === 'Y' && !b2cAuthResponse && updatedAuthType.includes("profile")) {
            //console.log("requires auth but do not have auth fields")
            window.sessionStorage.removeItem("firstAuthQuestion");
            setQuestionV(question);
            setIsFAQV(isFaq);
            handleB2CSignIn();
            return;
        } 
        // Requests lami authentication if required
        else if (requiresAuth === 'Y' && !signedIn && !updatedAuthType.includes("profile") && Object.keys(authFieldsValRef.current).length === 0) {
          //console.log("requires auth but do not have auth fields")
          window.sessionStorage.removeItem("firstAuthQuestion");
          setQuestionV(question);
          setIsFAQV(isFaq);
          handleAuthDialogOpen();
          return;
       } 

       // Requests IVR authentication if required.
        else if (requiresAuth === 'Y' && !ivrProfile && updatedAuthType.includes("ivr")) {
          //console.log("requires auth but do not have auth fields")
          window.sessionStorage.removeItem("firstAuthQuestion");
          setQuestionV(question);
          setIsFAQV(isFaq);
          handleAuthDialogOpen();
          return;
       }

       const caseList = casesVal.split(',').map(caseNumber => caseNumber.trim()).filter(Boolean);
       const selectedCase = authFieldsValRef.current.casenumber?.trim() || "";
       const hasValidCase = !!selectedCase && selectedCase !== "No cases found.";
       const hasNoCases = caseList.length === 0 || selectedCase === "No cases found.";
       const hasMultipleCases = caseList.length > 1;
       const singleCase = caseList.length === 1 ? caseList[0] : "";

       // if signed in with b2c, user has no assigned cases: requests case entry
       if (requiresAuth === 'Y' && b2cAuthResponse && updatedAuthType.includes("profile") && !hasValidCase && hasNoCases) {
            window.sessionStorage.removeItem("firstAuthQuestion");
            setQuestionV(question);
            setIsFAQV(isFaq);
            handleAddCaseDialogOpen("auth");
            return;
       }

       // if signed in with b2c, user has multiple cases, and an active case has not been selected: requests case selection
       else if (requiresAuth === 'Y' && (!activeCase && !selectedDropdownCase && hasMultipleCases) && b2cAuthResponse && updatedAuthType.includes("profile")) {
            //console.log("requires auth and missing case number")
            window.sessionStorage.removeItem("firstAuthQuestion");
            setQuestionV(question);
            setIsFAQV(isFaq);
            handleCaseSelectDialogOpen();
            return;
        }

        // Automatically selects the single case if user is signed in with b2c, auth type includes profile, user has no active case selected, but has one case assigned
        if (requiresAuth === 'Y' && updatedAuthType.includes("profile") && !hasValidCase && singleCase) {
            updateAuthFieldsVal(prev => ({
                ...prev,
                casenumber: singleCase
            }));
        }

        setIsMsgRenderComplete(false);
         

        conversationId = conversationId || appStateContext?.state.currentChat?.id;
        let convid = conversationId? conversationId : "";
        setConvidRef(convid);

        if (branding?.pii_redaction_enabled === "Y"){
            //console.log("PII redaction")
            let r = await pii_redaction(question, document.documentElement.lang, selectPgmCode, convid,sessionStorage.sessionUUID);
            if (r.ok){
                if (r?.body) {
                    let r1 = r.body.getReader();
                    const { done, value } = await r1.read();
                    question = new TextDecoder("utf-8").decode(value);                
                } 
            } else {
                console.error("PII redaction failed");
            }
        }


   
        setActiveCitation(undefined);
        setIsCitationPanelOpen(false);
        setSearchTextCitation('');
        setCurrentMatchIndex(0);
        setTotalMatches(0);
        setMatchPositions([]);
        setText5Error('');
        
        if ((Math.max(window.screen.width, window.innerWidth) <= 768)) {
            //console.log("window.screen.width: " + window.screen.width);
            //console.log("window.innerWidth: " + window.innerWidth);
            setIsFAQPaneOpen(false);
        
        } 
        lastQuestionRef.current = question;
        //console.log("start   -true")
        setIsDone(false);
        setIsLoading(true);
        setShowLoadingMessage(true);
        retrieveChatUUID();
        retrievePromptTokenCount()
        //set answer complete to false
        let manswers = answers;
        const abortController = new AbortController();
        abortFuncs.current.unshift(abortController);
        //console.log("********COSMOS DB*****")
        //console.log(chatUUID)
        const userMessage: ChatMessage = {
            id: uuidv4(),
            role: "user",
            content: question,
            context: { followup_questions: null },
            date: new Date().toISOString(),
            prompt_tokens: promptTokenCount,
            completion_tokens: 0,
        };

        //api call params set here (generate)
        let request: ConversationRequest;
        let conversation;

         
      
        if(conversationId){
            //console.log("############## FOUND conversation ID ################")
            //console.log(conversationId)
            conversation = appStateContext?.state?.chatHistory?.find((conv) => conv.id === conversationId)
            if(!conversation){
                //console.log("NO CONVERSATION FOUND")
                console.error("Conversation not found.");
              
                setIsLoading(false);
                setShowLoadingMessage(false);
                abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
                return;
            }else{
                //console.log("CONVERSATION FOUND")
                conversation.messages.push(userMessage);
                request = {
                    messages: [...conversation.messages.filter((answer) => answer.role !== ERROR)],
                    //sessionUUID: sessionStorage.sessionUUID,
                    chatUUID,
                };
            }
        }else{
            //console.log("######NO CONVERSATION ID FOUND######")
            request = {
                messages: [userMessage].filter((answer) => answer.role !== ERROR),
                //sessionUUID: sessionStorage.sessionUUID,
                chatUUID,
            };
            setMessages(request.messages)
        }
        let result = {} as ChatResponse;
        var errorResponseMessage = "Please try again. If the problem persists, please contact the site administrator.";
        let ans = ""
        try {
            let response;

            if (conversationId) {
                if (requiresAuth === "Y") {
                    response = await historyGenerate(request, abortController.signal, chatUUID, b2cAuthResponse, lang, isFaq, selectPgmCode, authTypeVRef.current, authFieldsValRef.current, conversationId, isStopped, hasStoppedGenerating?.current, msalInstance, settings);
                } else {
                    response = await historyGenerate(request, abortController.signal, chatUUID, b2cAuthResponse, lang, isFaq, selectPgmCode, "", caseAuthFields, conversationId, isStopped, hasStoppedGenerating?.current, msalInstance, settings, caseScope);
                }
            } else {
                if (requiresAuth === "Y") {
                    if (useUpdatedAuthType){
                        response = await historyGenerate(request, abortController.signal, chatUUID, b2cAuthResponse, lang, isFaq, selectPgmCode, updatedAuthType, authFieldsValRef.current, conversationId, isStopped, hasStoppedGenerating?.current, msalInstance, settings);
                    } else {
                        response = await historyGenerate(request, abortController.signal, chatUUID, b2cAuthResponse, lang, isFaq, selectPgmCode, authTypeVRef.current, authFieldsValRef.current, conversationId, isStopped, hasStoppedGenerating?.current, msalInstance, settings);
                    }
                } else {
                    response = await historyGenerate(request, abortController.signal, chatUUID, b2cAuthResponse, lang, isFaq, selectPgmCode, "", caseAuthFields, "", isStopped, hasStoppedGenerating?.current, msalInstance, settings, caseScope);
                }
            }
            if(!response?.ok){
                //console.log("err on resp")
                const responseJson = await response.json();
                errorResponseMessage = responseJson.error === undefined ? errorResponseMessage : parseErrorMessage(responseJson.error);
                let errorChatMsg: ChatMessage = {
                    id: uuidv4(),
                    role: ERROR,
                    content: `There was an error generating a response. Chat history can't be saved at this time. ${errorResponseMessage}`,
                    context: { followup_questions: null },
                    date: new Date().toISOString(),
                    prompt_tokens: 0,
                    completion_tokens: 0,
                   
                }
                let resultConversation;
              
                //console.log(conversationId)
                //conversationId = x
                if(conversationId){
                    resultConversation = appStateContext?.state?.chatHistory?.find((conv) => conv.id === conversationId)
                    if(!resultConversation){
                        console.error("####Conversation not found.###");
                        console.error("Conversation not found.");
                       
                        setIsLoading(false);
                        setShowLoadingMessage(false);
                        abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
                        return;
                    }
                    resultConversation.messages.push(errorChatMsg);
                }else{
                   
                    setMessages([...messages, userMessage, errorChatMsg])
                    setIsLoading(false);
                    setShowLoadingMessage(false);
                    abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
                    return;
                }
                appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: resultConversation });
                setMessages([...resultConversation.messages]);
                return;
            }
            if (response?.body) {
                //console.log("BBB");
                const reader = response.body.getReader();
                
                let runningText = "";
                while (true) {
                    //console.log("makeapirequestwithcosmos 1");
                    setProcessMessages(messageStatus.Processing)
                    const {done, value} = await reader.read();
                    if (done) {break;}
                  
                    var text = new TextDecoder("utf-8").decode(value);
                    const objects = text.split("\n");
                    objects.forEach((obj) => {
                        try {
                          //throw new Error("This is a test error from Chat component.");
                            //console.log("obj: " + obj)
                            if (obj !== "" && obj !== "{}") {
                                runningText += obj;
                                result = JSON.parse(runningText);
                                if (result.choices?.length > 0) {
                                    result.choices[0].messages.forEach((msg) => {
                                        //console.log("msg: " + msg)
                                        if (msg.content !="[DONE]") { 
                                            msg.id = uuidv4();
                                            msg.date = new Date().toISOString();
                                            // if (msg.role === ASSISTANT) {
                                            //     msgLen += msg.content.length;
                                            // }
                                            //console.log("msg content: "+  msg.content )
                                            if (msg.role === ASSISTANT){
                                                ans += msg.content
                                            }
                                            
                                            if (msg.clearAuth != undefined && msg.clearAuth === "Y") {
                                                clearAuthFields = true;
                                            }
                                            processResultMessage(msg, userMessage, conversationId);
                                            //console.log("****msg*** ")
                                            //console.log(msg)
                                            if (msg.copilot_tranferAgent === "Y") {
                                                //console.log("Transfer to Agent")

                                                tranferToAgent = true;
                                            }

                                             if (msg.copilot_tranfertoFlow !== undefined) {
                                                if (msg.copilot_tranfertoFlow !== "") {
                                                    //console.log("Transfer to Flow X" + msg.copilot_tranfertoFlow +"Y")
                                                    flow_name = msg.copilot_tranfertoFlow? msg.copilot_tranfertoFlow : "";
                                                    tranferToCopilotFlow = true;
                                                }
                                            }
                                        }
                                    })
                                }
                                runningText = "";
                                if (result.choices[0].messages?.some(m => m.role === ASSISTANT && m.content !== "[DONE]")) {
                                    setShowLoadingMessage(false);
                                    // setTimeout(() => {
                                    //     setShowLoadingMessage(false);
                                    // }, 600);
                                }
                             
                            }
                        }
                        catch (e) {
                            if (!(e instanceof SyntaxError)) {
                                console.error(e);
                                throw e;
                            } else {
                                console.log("Incomplete message. Continuing...")
                            }
                         }
                    });
                }
                //console.log("Chat 1 Comes here "  + result.isFaq);
                //undefined means regular Extension flow result
                //console.log("******** what is my result*****")
                //console.log(result)
                if (isUndefined(result.isFaq)){
                    result.isFaq = "No"
                }
                //if the user typed in a FAQ question
                if (result.isFaq === "Yes" && result.isFaqUserMessage === "N"){
                    userMessage["isFaq"] = "Typed"
                }
                assistantMessage["isFaq"] = result.isFaq
                
                let resultConversation;
                //console.log("old conv id " + conversationId);
                //console.log("new conv id " + result.history_metadata.conversation_id);

                if (conversationId != result.history_metadata.conversation_id) {
                    //console.log("set the conv id to null");
                    setAnswers([]);
                    setSpeechUrls([]);
                    setMessages([]);
                    manswers=[]
                    conversationId = undefined;
                    let date: Date= new Date();
                    dt1 = date.toLocaleTimeString([], {hour: 'numeric', minute: '2-digit', hour12: true}) ;
                    setIsNewConv(true);
                }
                else {
                   dt2 = dt1;
                   setIsNewConv(false);
                }

                if(conversationId){
                    //console.log("or Comes here");
                    resultConversation = appStateContext?.state?.chatHistory?.find((conv) => conv.id === conversationId)
                    if(!resultConversation){
                        console.error("Conversation not found.");
                        
                        setIsLoading(false);
                        setShowLoadingMessage(false);
                        abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
                        return;
                    } 
                    isEmpty(toolMessage) ?
                        resultConversation.messages.push(assistantMessage) :
                        resultConversation.messages.push(toolMessage, assistantMessage)
                }else{
                    
                    resultConversation = {
                        id: result.history_metadata.conversation_id,
                        title: result.history_metadata.title,
                        messages: [userMessage],
                        date: result.history_metadata.date
                    }
                    // Update convidRef with the new conversation ID so button handlers have access to it
                    setConvidRef(result.history_metadata.conversation_id);
                    isEmpty(toolMessage) ?
                        resultConversation.messages.push(assistantMessage) :
                        resultConversation.messages.push(toolMessage, assistantMessage)
                }
                if(!resultConversation){
                   
                    setIsLoading(false);
                    setShowLoadingMessage(false);
                    abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
                    return;
                }
              
                appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: resultConversation });
                isEmpty(toolMessage) ?
                    setMessages([...messages, assistantMessage]) :
                    setMessages([...messages, toolMessage, assistantMessage]);     
            }
            
        } catch ( e )  {
            if (!abortController.signal.aborted) {
                let errorMessage = `An error occurred. ${errorResponseMessage}`;
                if (result.error?.message) {
                    errorMessage = result.error.message;
                }
                else if (typeof result.error === "string") {
                    errorMessage = result.error;
                }
                errorMessage = parseErrorMessage(errorMessage);
                let errorChatMsg: ChatMessage = {
                    id: uuidv4(),
                    role: ERROR,
                    content: errorMessage,
                    context: { followup_questions: null },
                    date: new Date().toISOString(),
                    prompt_tokens: 0,
                    completion_tokens: 0 
                }
                let resultConversation;
                console.log("there was an error - this is my conversationId " + conversationId)
                console.log("there was an error - this is my session conversationId " + window.sessionStorage.getItem('conversationId'))
                console.log("there was an error - this is my current chat conversationId " + appStateContext?.state.currentChat?.id)
               
                if(conversationId){
                    resultConversation = appStateContext?.state?.chatHistory?.find((conv) => conv.id === conversationId)
                    if(!resultConversation){
                        let errorMessage = `An error occurred. Conversation not found. ${errorResponseMessage}`;
                        errorChatMsg.content =errorMessage
                        //console.error("Conversation not found.");
                        // Add error to UI
                        setMessages([...messages, userMessage, errorChatMsg]);
                        setIsLoading(false);
                        setShowLoadingMessage(false);
                        setProcessMessages(messageStatus.NotRunning)
                        setStopMsgPlaying(false);
                        setIsMsgRenderComplete(true); 
                        abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
                        return;
                    }
                    resultConversation.messages.push(errorChatMsg);
                }else{
                    if(!result.history_metadata){
                        let errorMessage = `An error occurred retrieving data from response. ${errorResponseMessage}`;
                        errorChatMsg.content = errorMessage
                        //console.error("Error retrieving data from response.", result);
                         // Add error to UI
                        setMessages([...messages, userMessage, errorChatMsg]);
                        setIsLoading(false);
                        setShowLoadingMessage(false);
                         
                        setProcessMessages(messageStatus.NotRunning)
                        setStopMsgPlaying(false);
                        setIsMsgRenderComplete(true);     
                        abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
                        return;
                    }
                    resultConversation = {
                        id: result.history_metadata.conversation_id,
                        title: result.history_metadata.title,
                        messages: [userMessage],
                        date: result.history_metadata.date
                    }
                    resultConversation.messages.push(errorChatMsg);
                }
                if(!resultConversation){
                    
                    setIsLoading(false);
                    setShowLoadingMessage(false);
                    abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
                    return;
                }
                appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: resultConversation });
                setMessages([...messages, errorChatMsg]);
            } else {
                setMessages([...messages, userMessage])
            }
        } finally {
            //console.log("fin -false")
            
            let  hasToolMsg ="N";
            if (! isEmpty(toolMessage)){
                hasToolMsg = "Y";
            }
            let rc: ResponseChoice = { index: 0, message: ans, has_toolmsg: hasToolMsg };
            let cr: ChatAppResponse = { choices: [rc] };
            //console.log(answers)
            //console.log(manswers)
            setAnswers([...manswers, [question, cr]]);
             
            setIsDone(true);
            setIsLoading(false);
            setShowLoadingMessage(false);
            setQuestionV("");
            abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
            setProcessMessages(messageStatus.Done)
            setStopMsgPlaying(false);
            window.sessionStorage.removeItem('pendingAuthFAQ');
            if (clearAuthFields) {
                //console.log("clear auth fields - why?")
                updateAuthFieldsVal({});
            }
            if (tranferToAgent) {
                //console.log("I am going to creat a summary and start a live chat")
                let r = await exportSummary(userMessage, assistantMessage);
                if (r === "OK") {
                    //console.log("I am going to transfer to live chat");
                    setshowLiveChat(true);
                    //setTimeout(() => setshowLiveChat(true), 5000);
                }
            }
             if (tranferToCopilotFlow) {
                //console.log("I am going to create a summary and start a flow")
                let r = await exportSummary(userMessage, assistantMessage);
                //console.log("I am going to transfer to copilot flow" , flow_name);
                setstartCopilotFlow(flow_name);
                setCopilotFlowContext1(question)
                setshowLiveFlow(true);
                 
            }
            
           
        }
        return abortController.abort();

    }
    // #endregion

    // #region sendFeedback
    const sendFeedback = async (rating: number, feedback: string, conversationId?: string, messageId?:string, messageFb?:string) => {
         
        const abortController = new AbortController();
        abortFuncs.current.unshift(abortController);
        let cId = '';
        
        //api call params set here (generate)
        let request: FeedbackRequest;
        let conversation;
        if(conversationId){
            cId = conversationId
            
            conversation = appStateContext?.state?.chatHistory?.find((conv) => conv.id === conversationId)
            if(!conversation){
             
                console.error("Conversation not found.");
              
                abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
                return;
            } 
        }else{
            console.error("Conversation not found.");
            setIsLoading(false);
        }
        let result = {} as ChatResponse;
        try {
            const feedbackMsgv: FeedbackMessage = {
                rating: rating,
                feedback: feedback,
                assistantMessageId: messageId,
                feedbackMsg: messageFb,
            };
            request = {
                message: [feedbackMsgv],
                chatUUID,
            };
            
            const response =   await feedbackGenerate(request, abortController.signal, chatUUID, cId, selectPgmCode, b2cAuthResponse);
            if(!response?.ok){
                console.log("There was an error saving feedback.  If the problem persists, please contact the site administrator.")
                return;
            }
           
            
        } catch ( e )  {
            if (!abortController.signal.aborted) {
                abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
                return;
            }
        } finally {
            abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
            //appStateContext?.dispatch({ type: 'TOGGLE_FEEDBACK_PANEL' })
        }
        return abortController.abort();

    }
    // #endregion

    // #endregion
 
    setIconOptions({
        disableWarnings: true
    });
    
    // #region useEffect
    // useEffect(() => {
    //     // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    //     const remove = initTranslate();
    
    //     return remove;
    //   }, []);

    // Helper function to process speech URLs for answers
    const processSpeechUrls = async (
        currentUrls: (string | null)[],
        updateUrls: (urls: (string | null)[]) => void,
        getTextToSpeak?: () => string | null
    ) => {
        const getUrl = async (msg: string) => {
            let response: string | null = null;
            if (msg !== "") {
                let conversationId = appStateContext?.state.currentChat?.id || "";
                response = await requestTTS(msg, conversationId, chatUUID);
            }
            return response;
        };

        if (answers && branding?.text_to_speech_enabled === "Y") {
            let mspeechUrls = currentUrls;
            let tctr = 0;
            
            // For each answer that is missing a speech URL, fetch the speech URL
            for (let i = 0; i < answers.length; i++) {
                // question
                if (!mspeechUrls[tctr]) {
                    mspeechUrls = [...mspeechUrls.slice(0, tctr), tctr.toString(), ...mspeechUrls.slice(tctr + 1)];
                }
                tctr += 1;

                // tool?
                if (answers[i][1].choices[0].has_toolmsg === "Y") {
                    if (!mspeechUrls[tctr]) {
                        mspeechUrls = [...mspeechUrls.slice(0, tctr), tctr.toString(), ...mspeechUrls.slice(tctr + 1)];
                    }
                    tctr += 1;
                }

                // answer
                if (answers[i][1].choices[0].message !== "" && !mspeechUrls[tctr]) {
                    const citationLinks = answers[i][1].choices[0].message.match(/\[(doc\d\d?\d?)]/g);
                    let citationReindex = 0;

                    if (branding?.citation_disabled == "false") {
                        // Ensure the correct citation index is passed to the TTS API
                        citationLinks?.forEach(link => {
                            answers[i][1].choices[0].message = answers[i][1].choices[0].message.replaceAll(link, ` doc ${++citationReindex} `);
                        });
                    }
                    if (branding?.citation_disabled === "true") {
                        // remove any citations such as [doc1] from the TTS answer
                        answers[i][1].choices[0].message = answers[i][1].choices[0].message.replace(/\[doc[^\]]*]/g, '');
                    }

                    
                    const textToSpeak = getTextToSpeak ? getTextToSpeak() : answers[i][1].choices[0].message;

                    if (textToSpeak) {
                        let r = getUrl(textToSpeak).then(speechUrl => {
                            mspeechUrls = [...mspeechUrls.slice(0, tctr), speechUrl, ...mspeechUrls.slice(tctr + 1)];
                            updateUrls(mspeechUrls);
                        });
                    }
                }
                tctr += 1;
            }
            updateUrls(mspeechUrls);
        }
    };

    // Process speech URLs for completed answers
    useEffect(() => {
        processSpeechUrls(speechUrls, setSpeechUrls);
    }, [answers]);

    // Process speech URL for partially rendered answer text
    useEffect(() => {
        processSpeechUrls(
            speechUrls,
            setSpeechUrls,
            () => {
                if (isStopped && !hasStoppedGenerating.current && !isMsgRenderComplete && partiallyRenderedText) {
                    return partiallyRenderedText;
                }
                return null;
            }
        );
    }, [isStopped, isMsgRenderComplete, partiallyRenderedText]);

    useEffect(() => {
        if(appStateContext?.state.isCosmosDBAvailable?.status === CosmosDBStatus.NotWorking && appStateContext.state.chatHistoryLoadingState === ChatHistoryLoadingState.Fail && hideErrorDialog){
            let subtitle = `${appStateContext.state.isCosmosDBAvailable.status}. Please contact the site administrator.`
            setErrorMsg({
                title: "Chat history is not enabled",
                subtitle: subtitle
            })
            toggleErrorDialog();
        }
    }, [appStateContext?.state.isCosmosDBAvailable]);

    
    useEffect(() => {
        setIsLoading(appStateContext?.state.chatHistoryLoadingState === ChatHistoryLoadingState.Loading)
     }, [appStateContext?.state.chatHistoryLoadingState])

  
 
    useEffect(() => {
        if (appStateContext?.state.currentChat) {

            setMessages(appStateContext.state.currentChat.messages)
        }else{
            setMessages([])
        }
    }, [appStateContext?.state.currentChat]);

    useEffect(() => {
        if (!lastQuestionRef.current) {
          chatUUID = '';
        }
      }, [lastQuestionRef.current]);

    useEffect(() => {
        //     if (AUTH_ENABLED !== undefined) getUserInfoList();
    // }, [AUTH_ENABLED]);
      //prevent flash of auth message onload
      const timer = setTimeout(() => {
      if (AUTH_ENABLED === undefined) {
          setShowAuthMessage(false);
        }
      }, 2000);
      if (AUTH_ENABLED !== undefined) {
        clearTimeout(timer);
        if (!AUTH_ENABLED) return;
        getUserInfoList();
      }
      return () => clearTimeout(timer);}, [AUTH_ENABLED]);

    
      useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | undefined;
    
        const updateStoppedMessageHistory = async () => {
            if (isStopped && isDone) {
                timer = setTimeout(async () => {
                    if (messages.length >= 2 && !hasStoppedGenerating.current) {
                        try {
                            const response = await historyUpdate(messages, id, chatUUID, b2cAuthResponse, selectPgmCode, isStopped, hasStoppedGenerating?.current, copilotFormData);
                            if (!response.ok) {
                                console.error("Failed to update history.");
                            }
                        } catch (err) {
                            console.error("Error updating history:", err);
                        } finally {
                            setIsMsgRenderComplete(true);
                        }
                    }
                }, 500);
            }
        };
    
        updateStoppedMessageHistory();
    
        return () => clearTimeout(timer);
    }, [isStopped, isDone, messages]);

        
    useLayoutEffect(() => {
        const saveToDB = async (messages: ChatMessage[], id: string) => {
            //console.log("saveTODB: this is my chat UUID: " +  chatUUID)
            //console.log("saveTODB: convId: " +  id)
            const doUpdate = () => historyUpdate(messages, id, chatUUID, b2cAuthResponse, selectPgmCode, isStopped, hasStoppedGenerating?.current, copilotFormData)
            try {
                const response = await doUpdate()
                if (response.ok) {
                    return response
                }
                console.error("Failed to save chat history, retrying once.")
            } catch (err) {
                console.error("Error saving chat history, retrying once:", err)
            }
            // a transient save failure would otherwise permanently lose the answer
            await new Promise(resolve => setTimeout(resolve, 2000))
            return doUpdate()
        }

        const logErrorToDB = async (message: ChatMessage, id: string) => {
            //console.log("logErrorToDB: this is my chat UUID: " +  chatUUID)
            const response = await historyLogError(message, id, chatUUID,selectPgmCode)
            return response
        }
        //console.log("in use layout effect " + processMessages)
        //console.log("current chat: " + appStateContext?.state.currentChat)
        if (appStateContext && appStateContext.state.currentChat && (processMessages === messageStatus.Done || (Object.keys(copilotFormData).length > 0 && !showLiveFlow))) {
                if(appStateContext.state.isCosmosDBAvailable.cosmosDB){
                    if(!appStateContext?.state.currentChat?.messages){
                        console.error("Failure fetching current chat state.")
                        return 
                    }
                    id= appStateContext.state.currentChat.id
                    const lastMsg = appStateContext.state.currentChat.messages[appStateContext.state.currentChat.messages.length - 1]
                    if (lastMsg?.role === ERROR) {
                        setProcessMessages(messageStatus.NotRunning)
                        if (!showLiveFlow) {
                            setCopilotFormData({})
                        }
                        return
                    }
                    //console.log("save db")
                    saveToDB(appStateContext.state.currentChat.messages, appStateContext.state.currentChat.id)
                    .then(async (res) => {
                        if(!res.ok){
                            const clonedRes = res.clone();
                            const errorBody = await clonedRes.text();
                            let errorMessage = "An error occurred. Answers can't be saved at this time. If the problem persists, please contact the site administrator.";
                            let errorChatMsg: ChatMessage = {
                                id: uuidv4(),
                                role: ERROR,
                                content: errorMessage,
                                context: { followup_questions: null },
                                date: new Date().toISOString(),
                                prompt_tokens: 0,
                                completion_tokens: 0 
                            }

                            // Parse the error body to extract meaningful error information to include in db logging
                            try {
                                const errorData = JSON.parse(errorBody);
                                if (errorData && errorData.error) {
                                    errorChatMsg.content = `${errorMessage} Error: ${errorData.error} ${errorData.message ? '- ' + errorData.message : ''}`;
                                }
                            } catch (jsonError) {
                                // If JSON parsing fails, use the error body as is, if it's not empty
                                if (errorBody && errorBody.trim()) {
                                    errorChatMsg.content = `${errorMessage} Error: ${errorBody.trim()}`;
                                }
                            }

                            logErrorToDB(errorChatMsg,id)
                            if(!appStateContext?.state.currentChat?.messages){
                                let err: Error = {
                                    ...new Error,
                                    message: "Failure fetching current chat state."
                                }
                                throw err
                            }

                            // Reset error message content to generic message for UI display
                            errorChatMsg.content = errorMessage
                            setMessages([...appStateContext?.state.currentChat?.messages, errorChatMsg])
                        } 
                        
                        return res as Response
                    })
                    .catch((err) => {
                        console.error("Error: ", err)
                        let errorChatMsg: ChatMessage = {
                            id: uuidv4(),
                            role: ERROR,
                            content: `Error saving chat history: ${err?.message || err}`,
                            context: { followup_questions: null },
                            date: new Date().toISOString(),
                            prompt_tokens: 0,
                            completion_tokens: 0 
                        }
                        logErrorToDB(errorChatMsg,id)
                        return new Response(null, { status: 500 });
                    })
                }else{
                }
                appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY', payload: appStateContext.state.currentChat });
                setMessages(appStateContext.state.currentChat.messages)
            setProcessMessages(messageStatus.NotRunning)
            if (!showLiveFlow) {
              setCopilotFormData({})
            }
        }
    }, [processMessages, copilotFormData, showLiveFlow]);

    useEffect(() => {
        if(appStateContext?.state.frontendSettings?.branding){
            const main_api = appStateContext?.state.frontendSettings?.branding?.main_api || ''
            const connection_string = (appStateContext?.state.frontendSettings as any).branding?.connection_string || ''
            fetchCSSConfig(connection_string, main_api, isDarkMode, configCode);
        }
    }, [configCode, isDarkMode]);


    window.addEventListener('message', (event) => {
        if (event.data.action === 'CHANGE_BUTTON_COLORS') {
            if (event.source) {
                event.source.postMessage({
                    action: 'UPDATE_BUTTON_COLORS',
                    minButtonColor: getComputedStyle(document.documentElement)
                        .getPropertyValue('--YW_Theme_Header_CompactView_Icon_Color'),
                    maxButtonColor: getComputedStyle(document.documentElement)
                        .getPropertyValue('--YW_Theme_Header_CompactView_Icon_Color'),
                }, { targetOrigin: event.origin });
            }
        }
    });

    const inIframe = (() => {
        try {
          return window.self !== window.top; // Will work for same-origin iframes
        } catch (e) {
          return true; // Assume it's in an iframe if access throws an error
        }
    })();
    const isEmbeddedInAdmin = inIframe && new URLSearchParams(window.location.search).get("source") === "admin";

    const [copyWelcomeMsgStatus, setCopyWelcomeMsgStatus] = useState(false);
    const activeCopyOperation = useRef<{
      statusTimeout: ReturnType<typeof setTimeout>;
      refTimeout: ReturnType<typeof setTimeout>;
      resetStatus: () => void;
    } | null>(null);

    const scrollToEnd = useCallback(() => {
      chatMessageStreamEnd.current?.scrollIntoView({ behavior: "smooth" });
    }, [chatMessageStreamEnd]);

    const chatStreamObserver = useRef<MutationObserver | null>(null);
    const setChatStreamContainer = useCallback((node: HTMLDivElement | null) => {
        chatStreamContainerRef.current = node;
        chatStreamObserver.current?.disconnect();
        if (node) {
          chatStreamObserver.current = new MutationObserver(() => {
            // Don't scroll if user is currently copying text
            if (activeCopyOperation.current) {
              return;
            }
            scrollToEnd();
          });
          chatStreamObserver.current.observe(node, {
            childList: true,
            subtree: true,
          });
        }
    }, [scrollToEnd]);

    const copyToClipboard = (msg: string, setCopyStatus: React.Dispatch<React.SetStateAction<boolean>>) => {
        // Clear and reset any existing copy operation
        if (activeCopyOperation.current) {
          clearTimeout(activeCopyOperation.current.statusTimeout);
          clearTimeout(activeCopyOperation.current.refTimeout);
          activeCopyOperation.current.resetStatus();
        }

        navigator.clipboard.writeText(msg);
        setCopyStatus(true);

        const statusTimeout = setTimeout(() => {
          setCopyStatus(false);
          // Keep ref true for a bit longer to prevent scrolling when message is removed from DOM
          const refTimeout = setTimeout(() => {
            activeCopyOperation.current = null;
          }, 300);

          if (activeCopyOperation.current) {
            activeCopyOperation.current.refTimeout = refTimeout;
          }
        }, 2000);

        activeCopyOperation.current = {
          statusTimeout,
          refTimeout: 0 as any, // Will be set in the first timeout
          resetStatus: () => setCopyStatus(false)
        };
    };

    // #endregion

    useEffect(() => {
        let isCollapseDefault = String(branding?.subsection_collapse_default);
        setExpandedSections(() => {
            if (isCollapseDefault === "true") {
                return {}; // All subsections collapsed
            }
            
            // All subsections expanded
            return sList.reduce<ExpandedSections>((acc, section) => {
                acc[section.id] = true;
                return acc;
            }, {});
        });
    }, [branding?.subsection_collapse_default]);

    useEffect(() => {
      let isCollapseDefault = String(branding?.profile_subsection_collapse_default);
        setExpandedProfileSections(() => {
            if (isCollapseDefault === "true") {
                return {}; // All subsections collapsed
            }
            
            const expanded: ExpandedSections = {};

            // Expand all profile subsections by subsection_title
            if (profilePaneData?.subsections) {
              Object.entries(profilePaneData.subsections).forEach(([section, titles]) =>
                (titles as string[]).forEach(title => {
                  expanded[`${section}|${title}`] = true;
                })
              );
            }
            return expanded;
        });
  }, [branding?.profile_subsection_collapse_default, profilePaneData]);

    const toggleSection = (sectionId: string) => {
        setExpandedSections((prevState) => ({
            ...prevState,
            [sectionId]: !prevState[sectionId],
        }));
    };
    const toggleProfileSection = (sectionId: string) => {
        setExpandedProfileSections((prevState) => ({
            ...prevState,
            [sectionId]: !prevState[sectionId],
        }));
    };

    useEffect(() => {
        if (branding?.faq_panel_default_open === "true"){
            setIsFAQPaneOpen(true);
        }
        else if (branding?.faq_panel_default_open === "false") {
            setIsFAQPaneOpen(false);
        }
    }, [branding?.faq_panel_default_open]);


    useEffect(() => {
      if (isProfilePaneOpen && isFocusTrapActive){
        setTimeout(() => {
          document.getElementById("profile-close")?.focus();
        }, 200);
      }
    }, [isProfilePaneOpen])

    const [scrollbarVisible, setScrollbarVisible] = useState(false);
    const [isAtTop, setIsAtTop] = useState(true);
  
    const scrollToTop = useCallback(() => {
        document.documentElement.scrollIntoView({ behavior: "smooth" });
    }, []);

    useEffect(() => {
        const handleScroll = () => {
          const htmlElement = document.documentElement;
          setIsAtTop(htmlElement.scrollTop === 0);
          checkScrollbar();
        };
    
        const checkScrollbar = () => {
          const htmlElement = document.documentElement;
          setScrollbarVisible(htmlElement.scrollHeight > htmlElement.clientHeight);
        };
    
        document.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', checkScrollbar);
    
        checkScrollbar();
    
        return () => {
          document.removeEventListener('scroll', handleScroll);
          window.removeEventListener('resize', checkScrollbar);
        };
      }, []);

    const [showCustomSlideIn, setShowCustomSlideIn] = useState(false);
    const [slideInMessage, setSlideInMessage] = useState<string>(`${branding?.signout_message}`);
    const [slideInTitle, setSlideInTitle] = useState<string>(`${branding?.signout_title}`);
    const [slideInBackgroundColor, setSlideInBackgroundColor] = useState<string | undefined>(undefined);
    const characterLimit = Number(branding?.question_inputfield_character_limit) || 4000;

    const headerContainerRef = useRef<HTMLDivElement>(null);

    const handleShowSlideIn = ({ title, message, backgroundColor }: { title?: string; message?: string; backgroundColor?: string; }) => {
        if (title) {
            setSlideInTitle(title);
        }else{
            setSlideInTitle(`${branding?.signout_title}`);
        }

        if (message) {
            setSlideInMessage(message);
        }else{
            setSlideInMessage(`${branding?.signout_message}`);
        }

        setSlideInBackgroundColor(backgroundColor);
        setShowCustomSlideIn(true);
    };
    
    const addErrorMessageToChat = (message: string) => {
        try {
            // Create the error message object
            const errorChatMsg: ChatMessage = {
                id: uuidv4(), // Generate a unique ID for the message
                role: ERROR, // Set the role to "ERROR"
                content: message, // Use the provided error message
                context: { followup_questions: null }, // No follow-up questions for errors
                date: new Date().toISOString(), // Timestamp for the error message
                prompt_tokens: 0, // No prompt tokens for errors
                completion_tokens: 0, // No completion tokens for errors
            };
    
            // Update the chat transcript in the state
            setMessages((prevMessages) => [...prevMessages, errorChatMsg]);
    
            // Update the current chat in the app state context
            const currentChat = appStateContext?.state.currentChat;
            if (currentChat) {
                const updatedMessages = [...currentChat.messages, errorChatMsg];
                appStateContext?.dispatch({
                    type: 'UPDATE_CURRENT_CHAT',
                    payload: {
                        ...currentChat,
                        messages: updatedMessages,
                    },
                });
            } else {
                console.error("No current chat found in app state context.");
            }
    
            //console.log("Error message added to chat:", message);
        } catch (error) {
            console.error("Error while adding error message to chat:", error);
        }
    };

    useEffect(() => {
      if (appStateContext?.state.isFeedbackPanelOpen === true) {
        setTimeout(() => {
          const closeButton = document.getElementById("feedback-panel-close");
          if (closeButton) {
            closeButton.focus();
          }
        }, 100);
      }
    }, [appStateContext?.state.isFeedbackPanelOpen]);

    const [isFAQPanelInteracted, setIsFAQPanelInteracted] = useState(false);

    const handleFAQPanelInteraction = () => {
        setIsFAQPanelInteracted(true);
    };

    const openKnowledgeBase = () => {
        // Logic to open the knowledge base
        setKnowledgeBaseOpen(true);
        setPopUpBlocker(true);
        setIsFocusTrapActive(false);
        // Clear selected document when opening
        setSelectedDocument("");
        setSelectedDocumentLink("");
        
        // Focus the input field after the modal opens
        setTimeout(() => {
            knowledgeDropdownRef.current?.focusInput();
        }, 100); // Small delay to ensure modal is rendered
    };

    const closeKnowledgeBase = () => {
      setPopUpBlocker(false);
      setKnowledgeBaseOpen(false);
      setIsFocusTrapActive(true);
  };

  // Release Notes Modal Handlers
  //const adminAppUrl = "http://localhost:50505";
  const adminAppUrl = appStateContext?.state.frontendSettings?.branding?.YW_Admin_App_URL || "";
  const adminLoginHint = (b2cAuthResponse as any)?.account?.username || "";
  const adminIframeSrc = adminAppUrl && adminLoginHint
    ? `${adminAppUrl}?loginHint=${encodeURIComponent(adminLoginHint)}`
    : adminAppUrl;
  const releaseNotesUrl = appStateContext?.state.frontendSettings?.branding?.release_notes_url || "";
  const releaseNotesModalMessage = appStateContext?.state.frontendSettings?.branding?.release_notes_modal_message || "";
  const releaseDate = appStateContext?.state.frontendSettings?.branding?.release_date || "";

  const openReleaseNotes = () => {
      setReleaseNotesOpen(true);
      setPopUpBlocker(true);
      setIsFocusTrapActive(false);
      setIsPopoverOpen(false);
      
      // Focus the modal content after it opens
      setTimeout(() => {
          const releaseNotesContent = document.getElementById("releaseNotes-close");
          if (releaseNotesContent) {
              releaseNotesContent.focus();
          }
      }, 100); // Small delay to ensure modal is rendered
  };

  const closeReleaseNotes = () => {
      setPopUpBlocker(false);
      setReleaseNotesOpen(false);
      setIsFocusTrapActive(true);
      setTimeout(()=> {
          document.getElementById("additional-chat-options") ? 
          document.getElementById("additional-chat-options")?.focus() : document.getElementById("release-notes")?.focus();
        }, 200);
  };

  const handleViewReleaseNotes = () => {
    if (releaseNotesUrl) {
        window.open(releaseNotesUrl, '_blank', 'noopener,noreferrer');
    }
  };

  // Cookie utilities for release notes popup
  const getReleaseNotesCookie = (name: string): string | null => {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return null;
  };

  const setReleaseNotesCookie = (name: string, value: string, days: number = 365) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/;SameSite=Lax`;
  };

  // Check if release notes popup should be shown
  const showReleaseNotesPopupDaysAfter = appStateContext?.state.frontendSettings?.branding?.show_release_notes_days_after || "";

  const shouldShowReleaseNotesPopup = (): boolean => {
    // Check if feature is enabled
    if (branding?.show_release_notes !== "Y") return false;

    // Check if release date is configured
    if (!releaseDate) return false;

    // Check if user has already seen this release's popup (cookie check)
    const seenReleaseCookie = getReleaseNotesCookie('release_notes_seen');
    if (seenReleaseCookie === releaseDate) return false;

    // Parse the release date and check if we're within the display window
    const releaseDateObj = new Date(releaseDate);
    releaseDateObj.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Check if release date is valid
    if (isNaN(releaseDateObj.getTime())) return false;

    // Check if today is on or after the release date
    if (today < releaseDateObj) return false;

    // Check if we're within the "days after" window (if configured)
    if (showReleaseNotesPopupDaysAfter) {
      const daysAfter = parseInt(showReleaseNotesPopupDaysAfter, 10);
      if (!isNaN(daysAfter) && daysAfter > 0) {
        const endDate = new Date(releaseDateObj);
        endDate.setDate(endDate.getDate() + daysAfter);
        if (today > endDate) return false;
      }
    }

    return true;
  };

  const showReleaseNotesPopupIfNeeded = () => {
    if (shouldShowReleaseNotesPopup()) {
      // Set cookie to mark as seen for this release date
      setReleaseNotesCookie('release_notes_seen', releaseDate);
      openReleaseNotes();
    }
  };

  // Effect to show release notes popup on page load (for internal users)
  useEffect(() => {
    // Only trigger once frontend settings are loaded and release date is available
    if (releaseDate && branding?.show_release_notes === "Y") {
      // Small delay to let the page fully render
      const timer = setTimeout(() => {
        showReleaseNotesPopupIfNeeded();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [releaseDate, branding?.show_release_notes]);

  const handleKnowledgeBaseEscape = () => {
      // Close the modal
      setPopUpBlocker(false);
      setKnowledgeBaseOpen(false);
      setIsFocusTrapActive(true);
      
      // Return focus to the knowledge base icon
      setTimeout(() => {
          const knowledgeBaseIcon = document.getElementById("knowledge-base-download");
          if (knowledgeBaseIcon) {
              knowledgeBaseIcon.focus();
          }
      }, 100); // Small delay to ensure modal close animation completes
  };

  const handleDocumentSelection = (documentName: string, documentLink: string) => {
    setSelectedDocument(documentName);
    setSelectedDocumentLink(documentLink);
  };

  // Opens a document (by name + blob link) in a new tab, reusing the /document-proxy
  // so PDFs render inline in the viewer and Office files open in Office Online.
  const openDocumentInViewer = (documentName: string, documentLink: string) => {
    if (!documentName || !documentLink) return;
    const fileExtension = documentName.toLowerCase().split('.').pop() || '';
    const isPDF = fileExtension === 'pdf' || documentLink.includes('.pdf');
    const isOfficeFile = ['xlsx', 'docx', 'pptx'].includes(fileExtension);

    if (!isPDF && !isOfficeFile) {
      window.open(documentLink, '_blank');
      return;
    }

    // PDFs render inline in the viewer; Office files open in Office Online.
    // Open exactly once: a null return from window.open is not a reliable "blocked" signal
    // (Teams opens the link itself and still returns null), so no fallback retry.
    const proxyType = isPDF ? 'pdf' : fileExtension;
    window.open(`/document-proxy?url=${encodeURIComponent(documentLink)}&type=${proxyType}`, '_blank');
  };

  const handleKnowledgeSubmit = async () => {
    if (selectedDocument && selectedDocumentLink) {
      openDocumentInViewer(selectedDocument, selectedDocumentLink);
    }
    closeKnowledgeBase();
  };

  // Opens the Knowledge Base document associated with a citation in the viewer.
  const onOpenCitationDocument = (citation: Citation) => {
    if (!citation.url) return;
    openDocumentInViewer(citation.filepath ?? citation.url, citation.url);
  };

    return (
        <div className={styles.container} role="main">
            <a href="#main" aria-hidden="true" tabIndex={-1} className={styles.skipToMain}>Skip to main content</a>
            
            {branding?.show_skip_nav_panel == 'Y' ?(
                <SkipTo isDarkMode={isDarkMode} env={configCodeRef.current} isFocusTrapPaused={isFocusTrapPaused} setIsFocusTrapPaused={setIsFocusTrapPaused} />
            ):null}

            {/* Hidden container for Google Translate - all translatable strings in one place */}
            <TranslationStrings cautionLine1={brandingCautionLine1} cautionLine2={brandingCautionLine2} />

            {showAuthMessage ? (
                <Stack className={styles.chatEmptyState}>
                    <ShieldLockRegular className={styles.chatIcon} style={{color: 'darkorange', height: "200px", width: "200px"}}/>
                    <h1 className={styles.chatEmptyStateTitle}>Authentication Not Configured</h1>
                    <h2 className={styles.chatEmptyStateSubtitle}>
                        This app does not have authentication configured. Please add an identity provider by finding your app in the 
                        <a aria-label="Azure Portal" href="https://portal.azure.com/" target="_blank"> Azure Portal </a>
                        and following 
                        <a aria-label="Microsoft Authentication"  href="https://learn.microsoft.com/en-us/azure/app-service/scenario-secure-app-authentication-app-service#3-configure-authentication-and-authorization" target="_blank"> these instructions</a>.
                    </h2>
                    <h2 className={styles.chatEmptyStateSubtitle} style={{fontSize: "20px"}}><strong>Authentication configuration takes a few minutes to apply. </strong></h2>
                    <h2 className={styles.chatEmptyStateSubtitle} style={{fontSize: "20px"}}><strong>If you deployed in the last 10 minutes, please wait and reload the page after 10 minutes.</strong></h2>
                </Stack>
            ) : (
                <B2CAuthGate onSignOut={signOut} onIframeSignIn={handleIframeSignIn}>
                <Stack horizontal className={styles.chatRoot} id="main">
                  {showPageLoading && (
                    <>
                      {/* This overlay blocks all interaction. Loading Icon for program switch */}
                      <div
                        style={{
                          position: "fixed",
                          top: 0, left: 0, right: 0, bottom: 0,
                          zIndex: 10000,
                          background: "transparent",
                          pointerEvents: "auto"
                        }}
                        tabIndex={0}
                        onKeyDown={e => e.preventDefault()}
                        onKeyUp={e => e.preventDefault()}
                        onMouseDown={e => e.preventDefault()}
                        onClick={e => e.preventDefault()}
                      />
                      {/* Centered loading icon */}
                      <div style={{
                        position: "fixed",
                        top: 0, left: 0, right: 0, bottom: 0,
                        zIndex: 10001,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                        <Loading />
                      </div>
                    </>
                  )}
                        {showLiveChat && <div className="blur-overlay"></div>}
                    {showLiveFlow && <div className="blur-overlay"></div>}
                        <div className={styles.chatContainer} data-theme={isDarkMode? "dark" :""} >
                    <div ref={headerContainerRef} className={styles.headerContainer}>                        
                    <header className={styles.header}>
                              
                        <Stack horizontal verticalAlign="center" horizontalAlign="space-between" className={styles.headerInterior}>
                        
                          <MediaQuery query="(min-width: 601px)">
                            <Stack horizontal verticalAlign="center"  horizontalAlign="start">
                           {(!inIframe || isEmbeddedInAdmin) && (
                            <a
                              aria-label="Back"
                              href={popUpBlocker ? undefined : branding?.header_left_link}
                              target={isEmbeddedInAdmin ? "_blank" : "_self"} role="button" title="Back"
                              style={{ color: "#FFFFFF", cursor: popUpBlocker ? 'not-allowed' : 'pointer'}}
                              onClick={(e) => {if (popUpBlocker) e.preventDefault();}}
                              ><ChevronLeft12Filled
                              //className={popUpBlocker ? styles.disabled : ''}
                              style={{ color: "var(--YW_Theme_Header_Border_Color)", cursor: popUpBlocker ? 'not-allowed' : 'pointer' }} /></a>
                            )}
                                <img
                                    src={isDarkMode ? branding?.header_left_image_darkmode : branding?.header_left_image}
                                    className={styles.headerIconLeft}
                                    aria-label="Back"
                                    alt="Back"
                                />
                            </Stack>
                            </MediaQuery>
                         
                          
                            <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 4 }} horizontalAlign="center" style={window === window.parent ? undefined : { marginLeft: "10px"}}>
                                    {(window === window.parent || isEmbeddedInAdmin) &&
                                    <MediaQuery query="(max-width: 600px)">
                                             <a aria-label="Back"
                                            href={popUpBlocker ? undefined : branding?.header_left_link}
                                            target={isEmbeddedInAdmin ? "_blank" : "_self"} role="button" title="Back"
                                            style={{ color: "#FFFFFF", cursor: popUpBlocker ? 'not-allowed' : 'pointer', marginRight: "10px"}}
                                            onClick={(e) => {if (popUpBlocker) e.preventDefault();}}>
                                                <ChevronLeft12Filled style={{
                                                color: "#FFFFFF" ,
                                                display: "flex", position: "fixed",top: "36px" , cursor: popUpBlocker ? 'not-allowed' : 'pointer'}} /></a>
                                    </MediaQuery>}
                                     {pList.length === 1 ? (
                                        <h1 className={headerClass} style={{ cursor: 'default' }}>
                                            {selectPgm ? selectPgm : pList[0].split("<>")[0]} 
                                            {branding?.show_heater_title_beta == "Y"?<sup style={{fontSize: "12px", lineHeight:"12px"}}> Beta</sup>:""}
                                       
                                        </h1>  
                                    ) : (
                                        <div className={headerDDClass}>
                                        <button
                                            disabled={!isMsgRenderComplete || (popUpBlocker && !showDropDown)}
                                            style={{ background: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', textAlign: 'left', cursor: !isMsgRenderComplete || (popUpBlocker && !showDropDown) ? 'not-allowed' : 'pointer' }}
                                            onClick={(): void => toggleDropDown()}
                                            aria-label="Program selection"
                                            aria-haspopup="menu"
                                            aria-expanded={showDropDown}
                                        >
                                        <h1 className={headerClass} style={{ cursor: !isMsgRenderComplete || (popUpBlocker && !showDropDown) ? 'not-allowed' : 'pointer' }}>
                                            {/* {branding?.header_title} */}
                                            {selectPgm ? selectPgm : pList[0].split("<>")[0]} 
                                            {branding?.show_heater_title_beta == "Y"?<sup style={{fontSize: "12px", lineHeight:"12px"}}> Beta</sup>:""}
                                            <ChevronDown16Filled style={{ marginLeft:"10px" ,color: "--YW_Header_Program_Dropdown_Font_Color", cursor: !isMsgRenderComplete || (popUpBlocker && !showDropDown) ? 'not-allowed' : 'pointer' }} />
                                            </h1>
                                        </button>

                                        {/* <div>{selectPgm ? "Select: " + selectPgm : "Select ..." + pList[0]} </div> */}
                                        {showDropDown && isMsgRenderComplete && (
                                        <DropDown
                                            
                                            ddInput={pgmInput()}
                                            showDropDown={showDropDown}
                                            setShowDropDown={setShowDropDown}
                                            toggleDropDown={(): void => toggleDropDown()}
                                            ddSelection={pgmSelection}
                                            popUpBlocker={popUpBlocker}
                                            setPopUpBlocker={setPopUpBlocker}
                                            setShowPageLoading={setShowPageLoading}
                                                        />)}
                                                </div>)}
                        
                            </Stack>
                            {inIframe && !isEmbeddedInAdmin && (
                                    <div
                                    style={{
                                        position: "fixed",
                                        top: "2px",
                                        right: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        zIndex: 1000,
                                      }}
                                    >
                                        <a
                                        tabIndex={0}
                                        title="Minimize Widget"
                                        aria-label="Minimize Widget"
                                        role="button"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            hideWidget();
                                        }}
                                        onKeyDown={(e)=>{
                                            if (e.key === "Enter" || e.key === " ") {
                                              e.stopPropagation();
                                              hideWidget();
                                            }
                                        }}
                                        style={{                                           
                                            color: "var(--YW_Theme_Header_CompactView_Icon_Color)",
                                            cursor: "pointer",
                                            fontSize: "30px",                                                                                  
                                        }}
                                        >
                                        -
                                        </a>
                                        <a
                                        tabIndex={0}
                                        title={isFullScreen ? "Restore Down" : "Maximize"}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            if (isFullScreen){
                                                toggleFullScreen(false);
                                                toggleWidget(true);
                                            } else {
                                                toggleFullScreen(true);
                                            }
                                        }}
                                        onKeyDown={(e)=>{
                                            if (e.key === "Enter" || e.key === " ") {
                                              e.stopPropagation();
                                              if (isFullScreen){
                                                toggleFullScreen(false);
                                                toggleWidget(true);
                                            } else {
                                                toggleFullScreen(true);
                                            }
                                          }}
                                        }
                                        style={{                                           
                                            cursor: "pointer",                                                                                      
                                        }}
                                        >
                                        <StackItem>
                                            {isFullScreen ? RestoreDown : NewWindowIcon}
                                        </StackItem>
                                        </a>
                                    </div>
                            )}
                            <Stack horizontal tokens={{ childrenGap: 4 }}  horizontalAlign="end">
                                    <button id="loadAgent" style={{ display: 'none' }} role="none"  aria-hidden="true"></button>
                                    <button id="loadCopilot" style={{ display: 'none' }} role="none" aria-hidden="true"></button>
                                    {/* <textarea disabled id="output" cols={59} rows={1}>...</textarea>
                                    <input type="text" id="field" value="HELP!" />  */}
                                    <MediaQuery query="(max-width: 600px)"> 
                                        <img
                                            src={ isDarkMode? branding?.header_right_small_image_darkmode : branding?.header_right_small_image}
                                            className={styles.headerIconRightSmall}
                                            aria-hidden="true"
                                            alt="Brand Name"
                                        /> 
                                    </MediaQuery>
                                 
                                    <MediaQuery query="(min-width: 601px)"> 
                                    <img
                                        src={isDarkMode? branding?.header_right_image_darkmode : branding?.header_right_image}
                                        className={styles.headerIconRight}
                                        aria-hidden="true"
                                        alt="Brand Name"
                                    />
                                    {branding?.YW_Admin_App_URL && branding?.is_admin && (
                                        <Stack horizontal verticalAlign="center" horizontalAlign="end" style={{ width: "100%" }}>
                                          <div style={{ width: "100%" }}>
                                              <div className={styles.languageBar}>
                                                  <div
                                                      id="return-to-admin"
                                                      aria-label="Return to Admin"
                                                      title="Return to Admin"
                                                      role="button"
                                                      tabIndex={0}
                                                      style={{
                                                          paddingRight: "5px",
                                                          verticalAlign: "center",
                                                          cursor: popUpBlocker ? "not-allowed" : "pointer"
                                                      }}
                                                      onClick={() => {
                                                          if (!popUpBlocker) handleAdminIconClick();
                                                      }}
                                                      onKeyDown={(e) => {
                                                          if (e.key === "Enter" || e.key === ' ') {
                                                              if (!popUpBlocker) handleAdminIconClick();
                                                          }
                                                      }}
                                                  >
                                                    <div
                                                        className={styles.languageImg}
                                                        style={{ cursor: popUpBlocker ? "not-allowed" : "pointer", color: "var(--YW_Theme_Header_Border_Color)" }}
                                                    >
                                                        {<ReturnToAdminIcon/>}
                                                    </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </Stack>
                                    )}
                                    {powerBI.hasPowerBIAccess && (
                                        <Stack horizontal verticalAlign="center" horizontalAlign="end" style={{ width: "100%" }}>
                                          <div style={{ width: "100%" }}>
                                              <div className={styles.languageBar}>
                                                  <div
                                                      id="power-bi"
                                                      aria-label="Power BI"
                                                      title="Power BI"
                                                      role="button"
                                                      tabIndex={0}
                                                      style={{
                                                          paddingRight: "5px",
                                                          verticalAlign: "center",
                                                          cursor: popUpBlocker ? "not-allowed" : "pointer"
                                                      }}
                                                      onClick={(e) => {
                                                          if (!popUpBlocker) powerBI.handlePowerBIIconClick(e.currentTarget);
                                                      }}
                                                      onKeyDown={(e) => {
                                                          if (e.key === "Enter" || e.key === ' ') {
                                                              if (!popUpBlocker) powerBI.handlePowerBIIconClick(e.currentTarget);
                                                          }
                                                      }}
                                                  >
                                                    <div
                                                        className={styles.languageImg}
                                                        style={{ cursor: popUpBlocker ? "not-allowed" : "pointer", color: "var(--YW_Theme_Header_Border_Color)" }}
                                                    >
                                                        {<PBIIcon/>}
                                                    </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </Stack>
                                    )}
                                    {branding?.show_release_notes == "Y" && (
                                        <Stack horizontal verticalAlign="center" horizontalAlign="end" style={{ width: "100%" }}>
                                          <div style={{ width: "100%" }}>
                                              <div className={styles.languageBar}>
                                                  <div
                                                      id="release-notes"
                                                      title="Release Notes"
                                                      role="button"
                                                      tabIndex={0}
                                                      style={{
                                                          paddingRight: "5px",
                                                          verticalAlign: "center",
                                                          cursor: popUpBlocker ? "not-allowed" : "pointer"
                                                      }}
                                                      onClick={() => {
                                                          if (!popUpBlocker) openReleaseNotes();
                                                      }}
                                                      onKeyDown={(e) => {
                                                          if (e.key === "Enter" || e.key === ' '){ if(!popUpBlocker) {
                                                            openReleaseNotes();
                                                          }
                                                        }
                                                      }}
                                                  >
                                                    <div
                                                        className={styles.languageImg}
                                                        style={{ cursor: popUpBlocker ? "not-allowed" : "pointer", color: "var(--YW_Theme_Header_Border_Color)" }}
                                                    >
                                                        {<ReleaseNotesIcon/>}
                                                    </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </Stack>
                                    )} 
                                    {branding?.show_knowledgebase_download == "Y" && (
                                        <Stack horizontal verticalAlign="center" horizontalAlign="end" style={{ width: "100%" }}>
                                          <div style={{ width: "100%" }}>
                                              <div className={styles.languageBar}>
                                                  <div
                                                      id="knowledge-base-download"
                                                      title="Knowledge Base Documents"
                                                      role="button"
                                                      tabIndex={0}
                                                      style={{
                                                          paddingRight: "5px",
                                                          verticalAlign: "center",
                                                          cursor: popUpBlocker ? "not-allowed" : "pointer"
                                                      }}
                                                      onClick={() => {
                                                          if (!popUpBlocker) openKnowledgeBase();
                                                      }}
                                                      onKeyDown={(e) => {
                                                          if (e.key === "Enter" || e.key === ' '){ if(!popUpBlocker) {
                                                            openKnowledgeBase();
                                                          }
                                                        }
                                                      }}
                                                  >
                                                    <div
                                                        className={styles.languageImg}
                                                        style={{ cursor: popUpBlocker ? "not-allowed" : "pointer", color: "var(--YW_Theme_Header_Border_Color)" }}
                                                    >
                                                        {<KnowledgeIcon/>}
                                                    </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </Stack>
                                    )}
                                    {branding?.show_site_translate == "Y" &&
                                        <Stack horizontal verticalAlign="center" horizontalAlign="end" style={{ width: "100%" }}>
                                            <div style={{ width: "100%" }}>
                                                <div className={styles.languageBar}>
                                                    <div
                                                        id="language-setting"
                                                        title="Language Settings"
                                                        role="button"
                                                        tabIndex={0}
                                                        style={{
                                                            paddingRight: "5px",
                                                            verticalAlign: "center",
                                                            cursor: popUpBlocker ? "not-allowed" : "pointer"
                                                        }}
                                                        onClick={() => {
                                                            if (!popUpBlocker) handleTranslate();
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" || e.key === '') {
                                                              if (!popUpBlocker) {
                                                                handleTranslate();
                                                              }
                                                            };
                                                        }}
                                                    >
                                                      <div
                                                          className={styles.languageImg}
                                                          style={{ cursor: popUpBlocker ? "not-allowed" : "pointer", color: "var(--YW_Theme_Header_Border_Color)" }}
                                                      >
                                                          <WorldIcon/>
                                                      </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Stack>
                                    }
                                        <Stack horizontal verticalAlign="center" horizontalAlign="end" style={{ width: "100%" }}>
                                            <div style={{ width: "100%" }}>
                                                <div className={styles.languageBar}>
                                                    <div
                                                        title="Light/Dark Mode"
                                                        role="button"
                                                        tabIndex={0}
                                                        style={{
                                                            paddingRight: "5px",
                                                            verticalAlign: "center",
                                                            cursor: popUpBlocker ? "not-allowed" : "pointer"
                                                        }}
                                                        onClick={() => {
                                                            if (!popUpBlocker) setIsDarkMode(!isDarkMode);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" || e.key === ' '){ if(!popUpBlocker) {
                                                              setIsDarkMode(!isDarkMode);
                                                            }
                                                          }
                                                        }}
                                                    >
                                                      <div
                                                          className={styles.languageImg}
                                                          style={{ cursor: popUpBlocker ? "not-allowed" : "pointer", color: "var(--YW_Theme_Header_Border_Color)" }}
                                                      >
                                                          {isDarkMode ? <DarkModeIcon/>: <LightModeIcon/>}
                                                      </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Stack>
                                        {branding?.show_signin === "Y" && (b2cEnabled || ivrAuthEnabled) && (
                                            <Stack horizontal verticalAlign="center" horizontalAlign="end" style={{ width: "100%" }}>
                                                <div style={{ width: "100%" }}>
                                                <div className={styles.languageBar}>
                                                <Popover
                                                    data-theme={isDarkMode ? "dark" : ""}
                                                    isOpen={isSignInPopoverOpen}
                                                    positions={["bottom"]}
                                                    content={
                                                    <FocusTrap 
                                                      active={isSignInPopoverOpen && !isFocusTrapPaused}
                                                      focusTrapOptions={{
                                                        initialFocus: () => {
                                                          b2cAuthResponse && branding?.show_signin === "Y" ? document.getElementById("my-profile") : document.getElementById("sign-in-out");
                                                        },
                                                        clickOutsideDeactivates: true,
                                                        escapeDeactivates: true,
                                                        onActivate: () => setIsOtherFocusTrapOpen(true),
                                                        onDeactivate: () => setIsOtherFocusTrapOpen(false),
                                                        fallbackFocus: () => {
                                                          return (b2cAuthResponse && branding?.show_signin === "Y" ? document.getElementById("my-profile") : document.getElementById("sign-in-out")) || document.body;
                                                        }
                                                        
                                                      }}
                                                    >
                                                        <div role="menu" aria-label="User options" style={{ padding: "10px" }} tabIndex={-1}>
                                                        {(b2cAuthResponse || ivrProfile) && branding?.show_signin === "Y" && enableProfilePanel && isProfileDataLoaded() &&  (
                                                        <div
                                                        id="my-profile"
                                                        style={{ marginBottom: '10px', cursor: "pointer" }}
                                                        tabIndex={0}
                                                        role="menuitem"
                                                          onClick={() => {
                                                              isProfilePaneOpen ? setIsProfilePaneOpen(false) : openProfilePane();
                                                              setPopUpBlocker(false);
                                                              setIsSignInPopoverOpen(false);
                                                          }}
                                                          onKeyDown={(e) => {
                                                            if (e.key === "Enter" || e.key === " ") {
                                                              isProfilePaneOpen ? setIsProfilePaneOpen(false) : openProfilePane();
                                                              setPopUpBlocker(false);
                                                              setIsSignInPopoverOpen(false);
                                                          }}}>
                                                            My Profile
                                                        </div>)}
                                                        {(b2cAuthResponse || ivrProfile) && branding?.show_signin === "Y" && showSwitchCases && (<div
                                                        tabIndex={0}
                                                        role="menuitem"
                                                        style={{ marginBottom: '10px', cursor: !isMsgRenderComplete ? "not-allowed" : "pointer" }}
                                                          onClick={() => {
                                                            if(!isMsgRenderComplete) return;
                                                              setQuestionV("");
                                                              handleCaseSelectDialogOpen();
                                                          }}
                                                          onKeyDown={(e) => {
                                                            if(!isMsgRenderComplete) return;
                                                            if (e.key === "Enter" || e.key === " ") {
                                                                setQuestionV("");
                                                                handleCaseSelectDialogOpen();
                                                              }}}
                                                          >
                                                            Switch Cases
                                                        </div>)}
                                                       {(b2cEnabled || ivrAuthEnabled) && (<div
                                                            id="sign-in-out"
                                                            tabIndex={0}
                                                            role="menuitem"
                                                            style={{ cursor: !isMsgRenderComplete ? "not-allowed" : "pointer" }}
                                                            onClick={() => {
                                                            if(!isMsgRenderComplete) return;
                                                            handleMergedSignInOut(() => setIsSignInPopoverOpen(false));
                                                            }}
                                                            onKeyDown={(e)=>{
                                                              if(!isMsgRenderComplete) return;
                                                              if (e.key === "Enter" || e.key === " ") {
                                                                  handleMergedSignInOut(() => setIsSignInPopoverOpen(false));
                                                              }
                                                            }}
                                                        >
                                                            {isAnySignedIn ? "Sign Out" : "Sign In"}
                                                        </div>)}
                                                        </div>
                                                        </FocusTrap>
                                                    }
                                                    onClickOutside={() => {
                                                        setIsSignInPopoverOpen(false);
                                                        setTimeout(() => setPopUpBlocker(false), 500);
                                                    }}
                                                    transform={{ top: 40, left: 5 }}
                                                    transformMode="relative"
                                                    align="end"
                                                    nudgedLeft={20}
                                                    containerStyle={{
                                                        padding: "10px",
                                                        fontFamily: "Arial",
                                                        fontSize: "14px",
                                                        fontStyle: "normal",
                                                        fontWeight: "normal",
                                                        zIndex: "99",
                                                        top: "-2px",
                                                        lineHeight: "18px",
                                                        letterSpacing: "0.1px",
                                                        border: "none",
                                                        background: isDarkMode ? "#1C1B2C" : "white",
                                                        color: isDarkMode ? "#FFFFFF" : "#1C1B2C",
                                                        boxShadow:
                                                        "0px 4px 4px 0px rgba(50, 152, 135, 0.15), 0px 1px 1px 0px rgba(12, 19, 41, 0.35)",
                                                    }}
                                                    >
                                                    <div
                                                        id="sign-in-out-icon"
                                                        className={styles.languageImg}
                                                        role="button"
                                                        tabIndex={0}
                                                        title='User options'
                                                        aria-expanded={isSignInPopoverOpen}
                                                        style={{
                                                        cursor: popUpBlocker ? "not-allowed" : "pointer",
                                                        color: "var(--YW_Theme_Header_Border_Color)",
                                                        }}
                                                        onClick={() => {
                                                        if (!popUpBlocker || isSignInPopoverOpen) {
                                                            setIsSignInPopoverOpen(!isSignInPopoverOpen);
                                                            setPopUpBlocker(!popUpBlocker);
                                                        }
                                                        }
                                                      }
                                                        onKeyDown={(e) => {
                                                        if (e.key === "Enter" || e.key === " ") {
                                                            if (!popUpBlocker || isSignInPopoverOpen) {
                                                              setIsSignInPopoverOpen(!isSignInPopoverOpen);
                                                              setPopUpBlocker(!popUpBlocker);
                                                            }
                                                        }
                                                      }}
                                                    >
                                                        {SignIn}
                                                    </div>
                                                </Popover>
                                                </div>
                                                </div>
                                            </Stack>
                                            )}
                                    </MediaQuery>
                                    <MediaQuery query="(max-width: 600px)"> 
                                        <Popover 
                                            data-theme={isDarkMode? "dark" :""}
                                            isOpen={isPopoverOpen}
                                            positions={['bottom']} // preferred positions by priority
                                            content={
                                            <FocusTrap
                                              active={isPopoverOpen && !isFocusTrapPaused} 
                                              focusTrapOptions={{ 
                                                initialFocus: () => {
                                                  const firstElement = branding?.show_site_translate === "Y" 
                                                  ? document.getElementById("select-language")
                                                  : document.getElementById("display-mode");
                                                
                                                  return firstElement;
                                                },
                                                clickOutsideDeactivates: true, 
                                                escapeDeactivates: true,
                                                returnFocusOnDeactivate: true,
                                                onActivate: () => setIsOtherFocusTrapOpen(true),
                                                onDeactivate: () => setIsOtherFocusTrapOpen(false),
                                                fallbackFocus: () => {
                                                  return (branding?.show_site_translate === "Y" ? document.getElementById("select-language") : document.getElementById("display-mode")) || document.body;
                                                }
                                                }}>
                                              <div 
                                                role="menu" 
                                                aria-label="Menu options" 
                                                tabIndex={-1} 
                                                style={{ padding:'10px'}}>
                                               {branding?.show_site_translate === "Y" && (
                                                    <div id="select-language" role="menuitem" aria-label="Select Language" tabIndex={0} style={{ marginBottom: '10px', cursor: 'pointer' }} onClick={() => { handleTranslateOpen(); setPopUpBlocker(false) }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter" || e.key === " ") {
                                                            handleTranslateOpen();
                                                            setPopUpBlocker(false);
                                                        }
                                                    }}>
                                                        Select Language
                                                    </div>
                                                )}
                                                    <div id="display-mode" aria-label="Change Display Mode" role="menuitem" tabIndex={0} style={{ marginBottom: (branding?.show_signin === "Y" || branding?.show_release_notes === "Y") ? '10px' : '0px', cursor: 'pointer' }} onClick={() => {handleChangeModeOpen(); setPopUpBlocker(false)}}
                                                      onKeyDown={(e)=>{
                                                        if (e.key === "Enter" || e.key === " ") {
                                                            handleChangeModeOpen();
                                                            setPopUpBlocker(false);
                                                        }
                                                      }}>Change Display Mode</div>
                                                    {branding?.YW_Admin_App_URL && branding?.is_admin && (
                                                      <div id="return-to-admin" aria-label="Return to Admin" role="menuitem" tabIndex={0} style={{ marginBottom: '10px', cursor: 'pointer' }} onClick={() => { handleAdminIconClick(); setIsPopoverOpen(false); }}
                                                        onKeyDown={(e)=>{
                                                          if (e.key === "Enter" || e.key === " ") {
                                                            handleAdminIconClick(); setIsPopoverOpen(false);
                                                          }
                                                        }}>Return to Admin</div>
                                                    )}
                                                    {powerBI.hasPowerBIAccess && (
                                                      <div id="power-bi" aria-label="Power BI" role="menuitem" tabIndex={0} style={{ marginBottom: '10px', cursor: 'pointer' }} onClick={(e) => { powerBI.handlePowerBIIconClick(e.currentTarget); setIsPopoverOpen(false); }}
                                                        onKeyDown={(e)=>{
                                                          if (e.key === "Enter" || e.key === " ") {
                                                            powerBI.handlePowerBIIconClick(e.currentTarget); setIsPopoverOpen(false);
                                                          }
                                                        }}>Power BI</div>
                                                    )}
                                                    {branding?.show_release_notes == "Y" && (
                                                      <div id="release-notes" aria-label="Release Notes" role="menuitem" tabIndex={0} style={{ marginBottom: (branding?.show_signin === "Y" || branding?.show_knowledgebase_download === "Y") ? '10px' : '0px', cursor: 'pointer' }} onClick={() => {openReleaseNotes();}}
                                                        onKeyDown={(e)=>{
                                                          if (e.key === "Enter" || e.key === " ") {
                                                            openReleaseNotes();
                                                          }
                                                        }}>Release Notes</div>
                                                    )}
                                                    {branding?.show_knowledgebase_download == "Y" && (
                                                    <div id="knowledge-base" aria-label="Knowledge Base Documents" role="menuitem" tabIndex={0} style={{ marginBottom: branding?.show_signin === "Y" ? '10px' : '0px', cursor: 'pointer' }} onClick={() => {openKnowledgeBase();}}
                                                      onKeyDown={(e)=>{
                                                        if (e.key === "Enter" || e.key === " ") {
                                                          openKnowledgeBase();
                                                        }
                                                      }}>View Knowledge Base</div>
                                                    )}
                                                    {(signedIn || b2cAuthResponse || ivrProfile) && branding?.show_signin === "Y" && enableProfilePanel && isProfileDataLoaded() && (
                                                      <div 
                                                      role="menuitem"
                                                      aria-label="My Profile"
                                                      tabIndex={0}
                                                      style={{ marginBottom: '10px', cursor: 'pointer' }} 
                                                      onClick={() => {
                                                        if (!isProfilePaneOpen){
                                                          openProfilePane();
                                                          setIsPopoverOpen(false);
                                                          setPopUpBlocker(false);
                                                        } else {
                                                          setIsProfilePaneOpen(false);
                                                          setPopUpBlocker(false);
                                                        }}}
                                                        onKeyDown={(e) => {
                                                          if (e.key === "Enter" || e.key === " ") {
                                                              if (!isProfilePaneOpen){
                                                                openProfilePane();
                                                                setIsPopoverOpen(false);
                                                                setPopUpBlocker(false);
                                                              } else {
                                                                setIsProfilePaneOpen(false);
                                                                setPopUpBlocker(false);
                                                              }
                                                          }
                                                        }}
                                                        >My Profile</div>)}
                                                      {(signedIn || b2cAuthResponse || ivrProfile) && branding?.show_signin === "Y" && showSwitchCases && (
                                                      <div 
                                                      role="menuitem"
                                                      aria-label="Switch Cases"
                                                      style={{ marginBottom: '10px', cursor: 'pointer' }} 
                                                      tabIndex={0}
                                                      onClick={() => {
                                                        if(!isMsgRenderComplete) return;
                                                          setQuestionV("");
                                                          handleCaseSelectDialogOpen();
                                                        }}
                                                      onKeyDown={(e)=>{
                                                        if(!isMsgRenderComplete) return;
                                                        if (e.key === "Enter" || e.key === " ") {
                                                            setQuestionV("");
                                                            handleCaseSelectDialogOpen();
                                                        }
                                                      }}>Switch Cases</div>)}
                                                    {branding?.show_signin === "Y" && (b2cEnabled || ivrAuthEnabled) && (
                                                    <div id="sign-in-out" role="menuitem" aria-label={isAnySignedIn ? "Sign Out" : "Sign In"} tabIndex={0} style={{ cursor: 'pointer' }} onClick={() => {
                                                      if(!isMsgRenderComplete) return;
                                                      handleMergedSignInOut(() => setIsPopoverOpen(false), true);
                                                    }}
                                                    onKeyDown={(e)=>{
                                                        if(!isMsgRenderComplete) return;
                                                        if (e.key === "Enter" || e.key === " ") {
                                                            handleMergedSignInOut(() => setIsPopoverOpen(false), true);
                                                        }
                                                    }}>{isAnySignedIn ? "Sign Out" : "Sign In"}</div>
                                                )}
                                              </div></FocusTrap>}
                                            onClickOutside={() => {
                                              setIsPopoverOpen(false);
                                              setTimeout(() => setPopUpBlocker(false), 500);
                                            }}
                                            transform={{ top: 40, left: 5}}
                                            transformMode='relative'
                                            align='end'
                                            nudgedLeft={20}
                                            containerStyle={{
                                                padding: '10px', fontFamily: 'Arial', fontSize: '14px', fontStyle: 'normal', fontWeight: 'normal', zIndex: '99', top: '-2px',
                                                lineHeight: '18px', letterSpacing: '0.1px', border: 'none', background: isDarkMode ? '#1C1B2C' : 'white', color: isDarkMode ? '#FFFFFF' : '#1C1B2C',
                                                boxShadow: '0px 4px 4px 0px rgba(50, 152, 135, 0.15), 0px 1px 1px 0px rgba(12, 19, 41, 0.35)'}}
                                            >
                                          <div 
                                            id="additional-chat-options" 
                                            role="button"  
                                            tabIndex={0} 
                                            aria-label="Additional Chat Options" 
                                            title="Additional Chat Options"
                                            aria-haspopup="menu"
                                            aria-expanded={isPopoverOpen}
                                            style={{ cursor:'pointer', background: "transparent", border: "none", height: "40px"}}
                                            onClick={() => { 
                                              if (!popUpBlocker || isPopoverOpen){ 
                                                setIsPopoverOpen(!isPopoverOpen); 
                                                setPopUpBlocker(!isPopoverOpen); 
                                            }}} 
                                            onKeyDown={(e) => { 
                                              if (e.key === "Enter" || e.key === " ") {
                                                if (!popUpBlocker || isPopoverOpen){ 
                                                  setIsPopoverOpen(!isPopoverOpen); 
                                                  setPopUpBlocker(!isPopoverOpen); 
                                              }}}}
                                          >
                                            <StackItem className={styles.overflowDrawerWhite}>{OverflowDrawer}</StackItem>
                                          </div>
                                        </Popover>
                                             
                                       
                                    </MediaQuery>

                            </Stack>
                        </Stack>     
                       
                          
                       
                            
                    </header>
                                
                    </div> 
                        <div>
                            {showCustomSlideIn && (
                                <SlidingBox
                                    title={slideInTitle}
                                    message={slideInMessage}
                                    duration={Number(branding?.signout_close_time) * 1000} // Optional: Customize the duration (default is 5 seconds)
                                    onClose={() => setShowCustomSlideIn(false)} // Optional: Handle when the box closes
                                    headerRef={headerContainerRef}
                                    isFAQPaneOpen={isFAQPaneOpen}
                                    backgroundColor={slideInBackgroundColor} // Pass the background color
                                />
                            )}
                        </div>
                            {!disabledButton() && (
                                <div className={
                                    window.innerWidth >= 992 ? styles.headerTagBgBoth : styles.headerTagBg}>
                                    <Stack
                                        horizontalAlign="center"
                                        verticalAlign="center"
                                        className={styles.feedbackStack}
                                        style={{
                                            gap: window.innerWidth < 992 ? "0px" : "15px",
                                            display: "flex",
                                            flexDirection: "row", // Stack icons and labels vertically
                                            alignItems: "center",
                                            justifyContent: "center",
                                            position: isCitationPanelOpen || isProfilePaneOpen ? (window.innerWidth >= 992 ? "relative" : "fixed"): "fixed",
                                            right: "0", // Align it to the right edge of the screen
                                            paddingRight: window.innerWidth < 992 ? "2px" : "10px",
                                            paddingBottom: window.innerWidth < 992 ? "1px" : "5px",
                                            paddingTop: "0px",
                                            paddingLeft: window.innerWidth < 992 ? "2px" : "10px",
                                        }}
                                    >
                                        {/* Button 1 */}
                                        {branding?.show_submit_request_button === 'Y' && 
                                        <div
                                            title="Submit Request" role="button"
                                            tabIndex={0}
                                            className={styles.headerTagButton} 
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === " ") { 
                                                  if (!popUpBlocker) handleChatClick('submitrequest'); 
                                                }
                                            }}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column", // Stack icon and label vertically
                                                alignItems: "center", // Center icon and label horizontally
                                                justifyContent: "center", // Center content vertically
                                                cursor: popUpBlocker ? "not-allowed" : "pointer",
                                                transform: window.innerWidth < 992 ? "scale(0.8)" : "scale(1)"
                                            }}
                                            onClick={() => !popUpBlocker && handleChatClick("submitrequest")}
                                        >
                                            <div
                                                style={{
                                                    height: "40px",
                                                    width: "40px",
                                                    display: "flex", // Use flexbox for centering
                                                    alignItems: "center", // Center icon vertically
                                                    justifyContent: "center", // Center icon horizontally
                                                }}
                                            >
                                                <SubmitRequestIcon fill="var(--YW_Body_Top_Right_Tab_Icon_Color)" />
                                            </div>
                                            <span
                                                aria-hidden="true"
                                                style={{
                                                    textAlign: "center",
                                                    whiteSpace: "normal",
                                                    wordWrap: "break-word",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                    maxWidth: "60px",
                                                }}
                                            >
                                                SUBMIT REQUEST
                                            </span>
                                        </div>
                                        }
                                        {/* Button 2 */}
                                        {branding?.telephony_api !== '' &&
                                        <div
                                            title="Chat with live agent" role="button"
                                            tabIndex={0}
                                            className={styles.headerTagButton} 
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === " ") { 
                                                  if (!popUpBlocker) handleChatClick('agent'); 
                                                }
                                            }}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: popUpBlocker ? "not-allowed" : "pointer",
                                                transform: window.innerWidth < 992 ? "scale(0.8)" : "scale(1)"
                                            }}
                                            onClick={() => !popUpBlocker && handleChatClick("agent")}
                                        >
                                            <div
                                                style={{
                                                    height: "40px",
                                                    width: "40px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <Person16Filled className={styles.headerTagButtonImgAgent}/>
                                            </div>
                                            <span
                                                aria-hidden="true"
                                                style={{
                                                    textAlign: "center",
                                                    whiteSpace: "normal",
                                                    wordWrap: "break-word",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                    maxWidth: "80px",
                                                }}
                                            >
                                                AGENT
                                            </span>
                                        </div>
                                        }          
                                        {/* Button 3 */}
                                        <div
                                            title="Clear" role="button"
                                            tabIndex={0}
                                            className={styles.headerTagButton} 
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === " ") { 
                                                  if (!popUpBlocker) newChatMisc(); 
                                                }
                                            }}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: popUpBlocker ? "not-allowed" : "pointer",
                                                transform: window.innerWidth < 992 ? "scale(0.8)" : "scale(1)"
                                            }}
                                            onClick={() => !popUpBlocker && newChatMisc()}
                                        >
                                            <div
                                                style={{
                                                    height: "40px",
                                                    width: "40px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <ClearIcon fill="var(--YW_Body_Top_Right_Tab_Icon_Color)" />
                                            </div>
                                            <span
                                                aria-hidden="true"
                                                style={{
                                                    textAlign: "center",
                                                    whiteSpace: "normal",
                                                    wordWrap: "break-word",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                    maxWidth: "80px",
                                                }}
                                            >
                                                CLEAR
                                            </span>
                                        </div>

                                        {/* Button 4 */}
                                        <div
                                            title="Download" role="button"
                                            tabIndex={0}
                                            className={styles.headerTagButton} 
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === " ") { 
                                                  if (!popUpBlocker) exportChatPDF(); 
                                                }
                                            }}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: popUpBlocker ? "not-allowed" : "pointer",
                                                transform: window.innerWidth < 992 ? "scale(0.8)" : "scale(1)"
                                            }}
                                            onClick={() => !popUpBlocker && exportChatPDF()}
                                        >
                                            <div
                                                style={{
                                                    height: "40px",
                                                    width: "40px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <DownloadIcon fill="var(--YW_Body_Top_Right_Tab_Icon_Color)" />
                                            </div>
                                            <span
                                                aria-hidden="true"
                                                style={{
                                                    textAlign: "center",
                                                    whiteSpace: "normal",
                                                    wordWrap: "break-word",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                    maxWidth: "80px",
                                                }}
                                            >
                                                DOWNLOAD
                                            </span>
                                        </div>

                                        {/* Button 5 */}
                                        <div
                                            title="Feedback" role="button"
                                            tabIndex={0}
                                            className={styles.headerTagButton} 
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === " ") {
                                                  if (!popUpBlocker) handleFeedbackModalClick();
                                                }
                                            }}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: popUpBlocker ? "not-allowed" : "pointer",
                                                transform: window.innerWidth < 992 ? "scale(0.8)" : "scale(1)"
                                            }}
                                            onClick={() => !popUpBlocker && handleFeedbackModalClick()}
                                        >
                                            <div
                                                style={{
                                                    height: "40px",
                                                    width: "40px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <FeedbackIcon fill="var(--YW_Body_Top_Right_Tab_Icon_Color)" />
                                            </div>
                                            <span
                                                aria-hidden="true"
                                                style={{
                                                    textAlign: "center",
                                                    whiteSpace: "normal",
                                                    wordWrap: "break-word",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                    maxWidth: "80px",
                                                }}
                                            >
                                                FEEDBACK
                                            </span>
                                        </div>
                                    </Stack>
                            </div>)}
                    <MediaQuery query="(min-width: 992px)"> 
                    {isFAQPaneOpen && (
                        <Stack
                            horizontal
                            horizontalAlign="start"
                            style={{
                                maxWidth: '25%',
                                marginRight: '25px',
                                position: 'fixed',
                                zIndex: '98',
                                left: '0',
                            }}
                        >
                          <FocusTrap
                            active={isFAQPaneOpen && isFAQPanelInteracted && !isFocusTrapPaused && !isOtherFocusTrapOpen}
                            focusTrapOptions={{ 
                                initialFocus: () => {
                                    // Respect the current focus if already on an element inside the FAQ panel
                                    const currentFocusedElement = document.activeElement;
                                    if (currentFocusedElement && document.getElementById('faq-panel-close')?.contains(currentFocusedElement)) {
                                      return currentFocusedElement;
                                    }
                                    // Otherwise, focus the close button
                                    return document.getElementById('faq-panel-close');
                                  },
                              clickOutsideDeactivates: true, 
                              escapeDeactivates: true,
                              returnFocusOnDeactivate: true,
                              }}
                          >
                            <div className={isDarkMode ? styles.spContainerDeskTopDM : styles.spContainer}>
                                <Stack
                                    horizontal
                                    verticalAlign="center"
                                    horizontalAlign="start"
                                    className={styles.spTitleContainerFAQ}
                                >
                                    <StackItem className={styles.spTitle}>
                                        Frequently Asked Questions
                                    </StackItem>
                                    <StackItem
                                        id="faq-panel-close"
                                        onClick={() => {
                                            if (popUpBlocker) return;
                                            setIsFAQPaneOpen(false);
                                            setPopUpBlocker(false);
                                            handleFAQPanelInteraction();
                                        }}
                                        onFocus={handleFAQPanelInteraction}
                                        className={closeX}
                                        tabIndex={0}
                                        style={{ cursor: popUpBlocker ? 'not-allowed' : 'pointer' }}
                                        role="button"
                                        aria-label="Close FAQ Panel"
                                        title="Close FAQ Panel"
                                        onKeyDown={(e) => {
                                          if (!popUpBlocker) {
                                            if (e.key === "Enter" || e.key === " ") {
                                              setIsFAQPaneOpen(false);
                                              setPopUpBlocker(false);
                                              handleFAQPanelInteraction();
                                            }
                                          }
                                        }}
                                    >
                                        <CloseIcon />
                                    </StackItem>
                                </Stack>
                                {branding?.hide_faq_subsections === "Y"
                                ? (
                                    // Render only the FAQ questions without subsections
                                    fList.map((item) => (
                                        <Stack
                                            role="button"
                                            tabIndex={0}
                                            horizontal
                                            verticalAlign="center"
                                            horizontalAlign="start"
                                            className={
                                                isMsgRenderComplete
                                                    ? styles.spRegContainer
                                                    : styles.spRegContainerInactive
                                            }
                                            style={{
                                                cursor: popUpBlocker ? 'not-allowed' : 'pointer',
                                            }}
                                            onClick={(e) => {
                                              if (!popUpBlocker && isMsgRenderComplete) {
                                                  makeApiRequestAuth(
                                                      getTranslatedFAQ(e.currentTarget, item.question),
                                                      'Y',
                                                      item.answer,
                                                      item.requiresAuth,
                                                      item.authType,
                                                      item.authFields
                                                  );
                                              }
                                            }}
                                            onKeyDown={(e) => {
                                              if (!popUpBlocker && isMsgRenderComplete) {
                                                if (e.key === "Enter" || e.key === " ") {
                                                  makeApiRequestAuth(
                                                    getTranslatedFAQ(e.currentTarget, item.question),
                                                    'Y',
                                                    item.answer,
                                                    item.requiresAuth,
                                                    item.authType,
                                                    item.authFields
                                                  );
                                                }
                                              }
                                            }
                                          }
                                        >
                                            <StackItem className={styles.spReg}>
                                                {item.question}
                                            </StackItem>
                                            <StackItem
                                                className={styles.spAction}
                                                style={{
                                                    cursor: popUpBlocker ? 'not-allowed' : 'pointer',
                                                }}
                                            >
                                                {chevronRightIcon}
                                            </StackItem>
                                        </Stack>
                                    ))
                                )
                                : (
                                // Render the FAQ questions with subsections
                                sList
                                    .filter((section) =>
                                        fList.some((item) => String(item.subSectionId) === String(section.id))
                                    )
                                    .map((section) => (
                                        <Stack
                                            className={styles.spSubsectionContainer}                                        
                                            key={section.id}
                                        >            
                                            <Stack
                                                horizontal
                                                horizontalAlign="space-between"
                                                verticalAlign="center"
                                                tabIndex={0}
                                                onClick={() => {
                                                    if (popUpBlocker) return;
                                                    toggleSection(section.id);
                                                }}
                                                onKeyDown={(e) => {
                                                  if (!popUpBlocker) {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                      toggleSection(section.id);
                                                    }
                                                  }
                                                }
                                              }
                                                style={{ cursor: popUpBlocker ? 'not-allowed' : 'pointer' }}
                                            >                   
                                                <StackItem 
                                                    className={styles.spSubsectionTitle}
                                                >
                                                        {section.subSection}
                                                </StackItem>
                                                <StackItem
                                                    
                                                    className={styles.spExpand}
                                                    role="button"
                                                    style={{ cursor: popUpBlocker ? 'not-allowed' : 'pointer' }}
                                                    title="Expand/Collapse section"
                                                    aria-label="Expand/Collapse section"
                                                >
                                                    {expandedSections[section.id] ? MinimizeIcon : ExpandIcon} 
                                                </StackItem>
                                            </Stack>
                                            {expandedSections[section.id] && (
                                                fList
                                                    .filter((item) => String(item.subSectionId) === String(section.id))
                                                    .map((item) => (
                                                        <Stack                                                   
                                                            role="button"
                                                            tabIndex={0}
                                                            horizontal
                                                            verticalAlign="center"
                                                            horizontalAlign="start"
                                                            className={
                                                                isMsgRenderComplete
                                                                    ? styles.spRegContainer
                                                                    : styles.spRegContainerInactive
                                                            }
                                                            style={{
                                                                cursor: popUpBlocker ? 'not-allowed' : 'pointer',
                                                            }}
                                                            onClick={(e) => {
                                                              if (!popUpBlocker && isMsgRenderComplete) {
                                                                  makeApiRequestAuth(
                                                                      getTranslatedFAQ(e.currentTarget, item.question),
                                                                      'Y',
                                                                      item.answer,
                                                                      item.requiresAuth,
                                                                      item.authType,
                                                                      item.authFields
                                                                  );
                                                              }
                                                            }}
                                                            onKeyDown={(e) => {
                                                              if (!popUpBlocker && isMsgRenderComplete) {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                  makeApiRequestAuth(
                                                                    getTranslatedFAQ(e.currentTarget, item.question),
                                                                    'Y',
                                                                    item.answer,
                                                                    item.requiresAuth,
                                                                    item.authType,
                                                                    item.authFields
                                                                  );
                                                                }
                                                              }
                                                            }
                                                          }
                                                        >
                                                            <StackItem className={styles.spReg}>
                                                                {item.question}
                                                            </StackItem>
                                                            <StackItem
                                                                className={styles.spAction}
                                                                style={{
                                                                    cursor: popUpBlocker ? 'not-allowed' : 'pointer',
                                                                }}
                                                                 title="Select FAQ Question"
                                                                 aria-label="Select FAQ Question"
                                                            >
                                                                {chevronRightIcon}
                                                            </StackItem>
                                                        </Stack>
                                                    ))
                                            )}
                                        </Stack>
                                    ))
                                )}
                                </div>
                              </FocusTrap>
                            </Stack>
                        )}
                        </MediaQuery>
                        <ProfilePanel
                          isProfilePaneOpen={isProfilePaneOpen}
                          setIsProfilePaneOpen={setIsProfilePaneOpen}
                          profilePaneData={profilePaneData}
                          selectedProfileSection={selectedProfileSection}
                          setSelectedProfileSection={setSelectedProfileSection}
                          expandedProfileSections={expandedProfileSections}
                          isDarkMode={isDarkMode}
                          popUpBlocker={popUpBlocker}
                          isFocusTrapPaused={isFocusTrapPaused}
                          caseSelectDialogOpen={caseSelectDialogOpen}
                          addCaseDialogOpen={addCaseDialogOpen}
                          setIsOtherFocusTrapOpen={setIsOtherFocusTrapOpen}
                          setPopUpBlocker={setPopUpBlocker}
                          setQuestionV={setQuestionV}
                          toggleProfileSection={toggleProfileSection}
                          isProfileDataLoaded={isProfileDataLoaded}
                          actionHandlers={actionHandlers}
                          showSwitchCases={showSwitchCases}
                          hasInternalPrograms={hasInternalPrograms}
                          onExternalProgramSelect={onExternalProgramSelect}
                          onExternalProgramRemoveRequest={(code, label) => setRemoveProgramConfirm({ code, label })}
                          onCaseRemoveRequest={(number, label) => setRemoveCaseConfirm({ number, label })}
                        />
                            <div data-theme={isDarkMode? "dark" :""}  className={isFAQPaneOpen ? (isCitationPanelOpen || (isProfilePaneOpen && window.innerWidth >= 992)) ? styles.chatMainNudgeBoth : styles.chatMainNudge : (isCitationPanelOpen || (isProfilePaneOpen && window.innerWidth >= 992)) ? styles.chatMainNudgeRight : styles.chatMain}>
                            <Stack  horizontal>
                          
                                  <Stack  style= {{width: '100%'}}>
                                        
                                        <div ref={setChatStreamContainer} data-theme={isDarkMode? "dark" :""}
                                  className={isFAQPaneOpen? styles.chatMessageStreamNudge : styles.chatMessageStream} style={{ marginBottom: isLoading ? "40px" : "0px"}}>
                                            {branding?.brand_welcome_message_count !== undefined && branding?.brand_welcome_message_count >= 1 && (
                                            <Stack className={isDarkMode ? styles.answerContainerDM : styles.answerContainer} tabIndex={0} id="first-chat-message">
                                                <Stack horizontal horizontalAlign="start" className={styles.ansCont}>
                                              <Stack horizontal horizontalAlign="start">
                                                  <img src={isDarkMode ? branding?.msg_icon_darkmode : branding?.msg_icon} className={styles.msgIcon} aria-hidden="true" alt="Message Icon"  />
                                              </Stack>
                                                <Stack horizontal grow >
                                                  <Stack.Item grow>
                                                        <Stack horizontal horizontalAlign="space-between">  
                                                        <Stack tabIndex={0} horizontalAlign="start" className={styles.msgTimeA}>{isNewConv? dt1 : dt2} </Stack> 
                                                       
                                                        <Stack horizontalAlign="end" style={{ cursor: "pointer" }} aria-label="Copy" title="Copy" role="button"  tabIndex={0}
                                                            onClick={() => copyToClipboard(branding?.brand_welcome_message_line1 ? branding?.brand_welcome_message_line1 : " ", setCopyWelcomeMsgStatus)} onKeyDown={(e)=>{if (e.key === "Enter" || e.key === " ") copyToClipboard(branding?.brand_welcome_message_line1 ? branding?.brand_welcome_message_line1 : " ", setCopyWelcomeMsgStatus)}}>
                                                            <CopyRegular role="button" className={styles.errorIcon} style={{ color: isDarkMode ? 'white' : 'black', height: '22px', width: '22px', outline: 'none' }} aria-label="Copy" title="Copy" />
                                                        </Stack>
                                                        </Stack>
                                                        <div tabIndex={0}>
                                                          <ReactMarkdown linkTarget="_blank" remarkPlugins={[remarkGfm, supersub]} className={styles.answerText}
                                                            children={branding?.brand_welcome_message_line1? branding?.brand_welcome_message_line1 : " "} />
                                                          </div>
                                                  </Stack.Item>
                                              </Stack>
                                          </Stack>
                                  </Stack>)}
                                            {branding?.brand_welcome_message_count !== undefined && branding?.brand_welcome_message_count >=2 && (<>
                                <div style={{height: '10px'}}></div>
                                <Stack className={isDarkMode ? styles.answerContainerDM : styles.answerContainer} tabIndex={0}>
                                    <Stack horizontal horizontalAlign="start" className={styles.ansCont}>
                                        <Stack horizontal horizontalAlign="start">
                                            <img src={isDarkMode ? branding?.msg_icon_darkmode : branding?.msg_icon} className={styles.msgIcon} aria-hidden="true" alt="Message Icon" />
                                        </Stack>
                                        <Stack horizontal grow >
                                            <Stack.Item grow>
                                                <Stack horizontal horizontalAlign="space-between"> 
                                                    <Stack horizontalAlign="start" className={styles.msgTimeA}>{isNewConv? dt1 : dt2}</Stack> 
                                                        <Stack horizontalAlign="end" style={{ cursor: "pointer" }} aria-label="Copy" title="Copy" role="button"  tabIndex={0}
                                                            onClick={() => copyToClipboard(branding?.brand_welcome_message_line2 ? branding?.brand_welcome_message_line2 : " ", setCopyWelcomeMsgStatus)} onKeyDown={(e)=>{if (e.key === "Enter" || e.key === " ") copyToClipboard(branding?.brand_welcome_message_line2 ? branding?.brand_welcome_message_line2 : " ", setCopyWelcomeMsgStatus)}}>
                                                             <CopyRegular role="button" className={styles.errorIcon} style={{ color: isDarkMode ? 'white' : 'black', height: '22px', width: '22px', outline: 'none' }} aria-label="Copy" title="Copy"  />
                                                        </Stack>
                                                </Stack>
                                                <ReactMarkdown linkTarget="_blank" remarkPlugins={[remarkGfm, supersub]} className={styles.answerText}
                                                      children={branding?.brand_welcome_message_line2? branding?.brand_welcome_message_line2 : " "} />
                                            </Stack.Item>
                                        </Stack>
                                    </Stack>
                                </Stack> </>)}

                                            {branding?.brand_welcome_message_count !== undefined && branding?.brand_welcome_message_count >= 3 && (<>
                                                <div style={{ height: '10px' }}></div>
                                                <Stack className={isDarkMode ? styles.answerContainerDM : styles.answerContainer} tabIndex={0}>
                                                    <Stack horizontal horizontalAlign="start" className={styles.ansCont}>
                                                        <Stack horizontal horizontalAlign="start">
                                                            <img src={isDarkMode ? branding?.msg_icon_darkmode : branding?.msg_icon} className={styles.msgIcon} aria-hidden="true" alt="Message Icon" />
                                                        </Stack>
                                                        <Stack horizontal grow >
                                                            <Stack.Item grow>
                                                                <Stack horizontal horizontalAlign="space-between">
                                                                    <Stack horizontalAlign="start" className={styles.msgTimeA}>{isNewConv ? dt1 : dt2}</Stack>
                                                                    <Stack horizontalAlign="end" style={{ cursor: "pointer" }} aria-label="Copy" title="Copy" role="button"  tabIndex={0}
                                                                        onClick={() => copyToClipboard(branding?.brand_welcome_message_line3 ? branding?.brand_welcome_message_line3 : " ", setCopyWelcomeMsgStatus)} onKeyDown={(e)=>{if (e.key === "Enter" || e.key === " ") copyToClipboard(branding?.brand_welcome_message_line3 ? branding?.brand_welcome_message_line3 : " ", setCopyWelcomeMsgStatus)}}>
                                                                        <CopyRegular role="button" className={styles.errorIcon} style={{ color: isDarkMode ? 'white' : 'black', height: '22px', width: '22px', outline: 'none' }} aria-label="Copy" title="Copy" />
                                                                    </Stack>
                                                                </Stack>
                                                                <ReactMarkdown linkTarget="_blank" remarkPlugins={[remarkGfm, supersub]} className={styles.answerText}
                                                                    children={branding?.brand_welcome_message_line3 ? branding?.brand_welcome_message_line3 : " "} />
                                                            </Stack.Item>
                                                        </Stack>
                                                    </Stack>
                                                </Stack> </>)}

                                            {branding?.brand_welcome_message_count !== undefined && branding?.brand_welcome_message_count >=4 && (<>
                                                <div style={{ height: '10px' }}></div>
                                                <Stack className={isDarkMode ? styles.answerContainerDM : styles.answerContainer} tabIndex={0}>
                                                    <Stack horizontal horizontalAlign="start" className={styles.ansCont}>
                                                        <Stack horizontal horizontalAlign="start">
                                                            <img src={isDarkMode ? branding?.msg_icon_darkmode : branding?.msg_icon} className={styles.msgIcon} aria-hidden="true" alt="Message Icon" />
                                                        </Stack>
                                                        <Stack horizontal grow >
                                                            <Stack.Item grow>
                                                                <Stack horizontal horizontalAlign="space-between">
                                                                    <Stack horizontalAlign="start" className={styles.msgTimeA}>{isNewConv ? dt1 : dt2}</Stack>
                                                                    <Stack horizontalAlign="end" style={{ cursor: "pointer" }} aria-label="Copy" title="Copy" role="button"  tabIndex={0}
                                                                        onClick={() => copyToClipboard(branding?.brand_welcome_message_line4 ? branding?.brand_welcome_message_line4 : " ", setCopyWelcomeMsgStatus)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") copyToClipboard(branding?.brand_welcome_message_line4 ? branding?.brand_welcome_message_line4 : " ", setCopyWelcomeMsgStatus) }}>
                                                                        <CopyRegular role="button" className={styles.errorIcon} style={{ color: isDarkMode ? 'white' : 'black', height: '22px', width: '22px', outline: 'none' }} aria-label="Copy" title="Copy" />
                                                                    </Stack>
                                                                </Stack>
                                                                <ReactMarkdown linkTarget="_blank" remarkPlugins={[remarkGfm, supersub]} className={styles.answerText}
                                                                    children={branding?.brand_welcome_message_line4 ? branding?.brand_welcome_message_line4 : " "} />
                                                            </Stack.Item>
                                                        </Stack>
                                                    </Stack>
                                                </Stack> </>)}

                                            {branding?.brand_welcome_message_count !== undefined && branding?.brand_welcome_message_count >= 5 && (<>
                                                <div style={{ height: '10px' }}></div>
                                                <Stack className={isDarkMode ? styles.answerContainerDM : styles.answerContainer} tabIndex={0}>
                                                    <Stack horizontal horizontalAlign="start" className={styles.ansCont}>
                                                        <Stack horizontal horizontalAlign="start">
                                                            <img src={isDarkMode ? branding?.msg_icon_darkmode : branding?.msg_icon} className={styles.msgIcon} aria-hidden="true" alt="Message Icon" />
                                                        </Stack>
                                                        <Stack horizontal grow >
                                                            <Stack.Item grow>
                                                                <Stack horizontal horizontalAlign="space-between">
                                                                    <Stack horizontalAlign="start" className={styles.msgTimeA}>{isNewConv ? dt1 : dt2}</Stack>
                                                                    <Stack horizontalAlign="end" style={{ cursor: "pointer" }} aria-label="Copy" title="Copy" role="button"  tabIndex={0}
                                                                        onClick={() => copyToClipboard(branding?.brand_welcome_message_line5 ? branding?.brand_welcome_message_line5 : " ", setCopyWelcomeMsgStatus)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") copyToClipboard(branding?.brand_welcome_message_line5 ? branding?.brand_welcome_message_line5 : " ", setCopyWelcomeMsgStatus) }}>
                                                                        <CopyRegular role="button" className={styles.errorIcon} style={{ color: isDarkMode ? 'white' : 'black', height: '22px', width: '22px', outline: 'none' }} aria-label="Copy" title="Copy" />
                                                                    </Stack>
                                                                </Stack>
                                                                <ReactMarkdown linkTarget="_blank" remarkPlugins={[remarkGfm, supersub]} className={styles.answerText}
                                                                    children={branding?.brand_welcome_message_line5 ? branding?.brand_welcome_message_line5 : " "} />
                                                            </Stack.Item>
                                                        </Stack>
                                                    </Stack>
                                                </Stack> </>)}

                                    {copyWelcomeMsgStatus && <p style={{color: isDarkMode? "#FFFFFF" : "#000000"}}>Text copied to clipboard!</p>}

                                    {/* < div ref={pdfRef}> */}
                                    <div>
                                      {messages.map((answer, index) => (
                                          <>
                                              {answer.role === "user" ? (
                                                  <div className={styles.chatMessageUser}>
                                                     
                                                      <div className={styles.chatMessageUserMessage} tabIndex={0}>
                                                          <div> 
                                                              <Stack horizontalAlign="start" className={styles.msgTime}>{new Date(answer.date).toLocaleTimeString([], {hour: 'numeric', minute: '2-digit', hour12: true})}</Stack>
                                                              <Stack horizontalAlign="start">{answer.content}</Stack>
                                                          </div>
                                                      </div>    
                                                  </div>
                                                  
                                              ) : (
                                                  answer.role === "assistant" ? <div className={styles.chatMessageGpt}>
                                                     
                                                      <Answer
                                                          answer={{
                                                              answer: answer.content,
                                                              followup_q: answer.context,
                                                              citations: appStateContext?.state.frontendSettings?.branding?.citation_disabled === "true"?[]:parseCitationFromMessage(messages[index - 1]),
                                                              message_id: answer.id,
                                                              feedbackOnMsg: answer.feedbackOnMsg, 
                                                              msgStatus: processMessages,
                                                              date: answer.date,
                                                              plotly_data: parsePlotFromMessage(messages[index - 1]),
                                                              exec_results: execResults,
                                                              isCopilotResponse: answer.copilot_convId? "Y": "N",
                                                              
                                                          }}
                                                          onCitationClicked={c => onShowCitation(c)}
                                                          onOpenCitationDocument={c => onOpenCitationDocument(c)}
                                                          isLoading={isLoading}
                                                          isDone={isDone}
                                                          msgIndex={index}
                                                          isMsgRenderComplete={isMsgRenderComplete}
                                                          setIsMsgRenderComplete={setIsMsgRenderComplete}
                                                          darkmode={isDarkMode}
                                                          pgm={selectPgmCode}
                                                          onExecResultClicked={() => onShowExecResult()} 
                                                          speechUrl={speechUrls[index]}
                                                          isMsgPlaying={isMsgPlaying}
                                                          setIsMsgPlaying={setIsMsgPlaying}
                                                          answers={answers}
                                                          fList={fList}
                                                          setPopUpBlocker={setPopUpBlocker}
                                                          popUpBlocker={popUpBlocker}
                                                            //   msgCurrentTime={msgCurrentTime}
                                                            //   setMsgCurrentTime={setMsgCurrentTime}
                                                            //   isMsgPlayPaused={isMsgPlayPaused}./start

                                                            //   setIsMsgPlayPaused={setIsMsgPlayPaused}
                                                            isNewConv={isNewConv}
                                                            stopMsgPlaying = {stopMsgPlaying}
                                                            onFollowupQuestionClicked={onFollowupQuestionClicked}
                                                            showFollowupQuestions={showFollowupQuestions}
                                                            onFeedbackGiven={onFeedbackGiven}
                                                            isCancelled={isCancelled}
                                                            setIsCancelled={setIsCancelled}
                                                            isAudio={isAudio}
                                                            setIsAudio={setIsAudio}
                                                            isStopped={isStopped}
                                                            stopGenerating={stopGenerating}
                                                            hasStoppedGenerating={hasStoppedGenerating}
                                                            setPartiallyRenderedText={setPartiallyRenderedText}
                                                            b2cAuthResponse={b2cAuthResponse}
                                                            getTranslatedText={getTranslatedText}
                                                            copyToClipboard={copyToClipboard}
                                                      />
                                                  </div> : answer.role === ERROR ? 
                                                      <div className={styles.chatMessageError}>
                                                      <Stack horizontal className={styles.chatMessageErrorTitle}>
                                                          <ErrorCircleRegular className={styles.errorIcon} style={{color: "#FFFFFF", height:'22px', width:'22px'}} />
                                                          <span>Error</span>
                                                    {/* <Stack horizontalAlign="end" verticalAlign="center"
                                                        onClick={() => handleErrorDialogClose()} className={styles.closeModalErr}>{'OK'}</Stack>*/}
                                                      </Stack> 
                                                                  <span className={styles.chatMessageErrorContent}><div style={{paddingLeft:'33px'}}>{answer.content}</div></span>
                                                  </div> : null
                                              )}
                                          </>
                                      ))}
                                      </div>
                                         
                                        {showLoadingMessage  && ( 
                                          <>
                                              <div className= {styles.chatMessageGpt}>
                                                  <Answer
                                                      answer={{
                                                          answer: getTranslatedText("generating-answer") || "Generating answer...",
                                                          followup_q: assistantContextO,
                                                          citations: [] ,
                                                          msgStatus: processMessages,
                                                          date: new Date().toISOString(),
                                                          plotly_data: null,
                                                          isCopilotResponse:  "N",
                                                      }}
                                                      onCitationClicked={() => null}
                                                      onOpenCitationDocument={() => null}
                                                      isLoading={isLoading}
                                                      isDone={isDone}
                                                      isMsgRenderComplete={isMsgRenderComplete}
                                                      setIsMsgRenderComplete={setIsMsgRenderComplete}
                                                      darkmode={isDarkMode}
                                                      pgm={selectPgmCode}
                                                      onExecResultClicked={() => onShowExecResult()} 
                                                      speechUrl={null}
                                                      isMsgPlaying={isMsgPlaying}
                                                      setIsMsgPlaying={setIsMsgPlaying}
                                                      onFeedbackGiven={onFeedbackGiven}
                                                      isCancelled={isCancelled}
                                                      isAudio={isAudio}
                                                      setIsAudio={setIsAudio}
                                                      setIsCancelled={setIsCancelled}
                                                      answers={answers}
                                                      setPopUpBlocker={setPopUpBlocker}
                                                      popUpBlocker={popUpBlocker}
                                                      fList={fList}
                                                      // msgCurrentTime={msgCurrentTime}
                                                      // setMsgCurrentTime={setMsgCurrentTime}
                                                      // isMsgPlayPaused={isMsgPlayPaused}
                                                      // setIsMsgPlayPaused={setIsMsgPlayPaused}
                                                      isNewConv={isNewConv}
                                                      stopMsgPlaying={stopMsgPlaying}
                                                      isStopped={isStopped}
                                                      stopGenerating={stopGenerating}
                                                      hasStoppedGenerating={hasStoppedGenerating}
                                                      setPartiallyRenderedText={setPartiallyRenderedText}
                                                      b2cAuthResponse={b2cAuthResponse}
                                                      getTranslatedText={getTranslatedText}
                                                      copyToClipboard={copyToClipboard}
                                                  />
                                              </div>
                                          </>
                                       )}
                                      {messages && messages.length > 0 && isMsgRenderComplete &&<div className={styles.aiGenContent}>AI-generated content</div>}
                                      {messages && messages.length > 0 && !isMsgRenderComplete && isStopped && !hasStoppedGenerating.current && <div className={styles.aiGenContent}>Stopping answer generation...</div>}
                                      <div  className={styles.chatMessageStreamEndNew} />
                                      <div ref={chatMessageStreamEnd}  className={styles.chatMessageStreamEnd} />
                                      {/* <div ref={chatMessageStreamEnd} /> */}
                                    
                                      </div>
                                        
                                      </Stack>
                           
                                              {/* Citation Panel */}
                                            
                                    {messages && messages.length > 0 && isCitationPanelOpen && activeCitation && window.innerWidth < 992 && ( 
                                      <FocusTrap
                                        active={isCitationPanelOpen && !isFocusTrapPaused} 
                                        focusTrapOptions={{ 
                                          clickOutsideDeactivates: true, 
                                          escapeDeactivates: true,
                                          returnFocusOnDeactivate: true,
                                          initialFocus: () => document.getElementById("citation-panel-close"),
                                          onActivate: () => setIsOtherFocusTrapOpen(true),
                                          onDeactivate: () => setIsOtherFocusTrapOpen(false),
                                          }}
                                        >
                                               <SlidingPane className={styles.spCustomCitations} isOpen={isCitationPanelOpen} from= {"bottom"} width={"100%"} hideHeader onRequestClose={() => { setIsCitationPanelOpen(false);}}>
                                            <Stack horizontal horizontalAlign="start" style={{ maxWidth: '100%' }}>
                                            
                                                <div ref={citationsContainerRef} className={styles.spContainerCitation}>
                                                    <Stack horizontal verticalAlign="center" horizontalAlign="start" className={styles.spTitleContainerCitation}>
                                                        <StackItem tabIndex={0} className={styles.spTitleCitation}>{"Citations"}</StackItem>
                                                        {branding?.hide_citations_kb_button !== "true" && activeCitation?.url && (
                                                        <StackItem
                                                          onClick={() => {!popUpBlocker && onOpenCitationDocument(activeCitation);}}
                                                          onKeyDown={(e) =>{
                                                              if (e.key === "Enter" || e.key === " ") {
                                                                  if (!popUpBlocker) onOpenCitationDocument(activeCitation);
                                                              }
                                                          }}
                                                          className={styles.citationPanelKbButton} style={{ cursor: popUpBlocker ? 'not-allowed' : 'pointer' }} role="button" tabIndex={0} aria-label="Open Document"
                                                          title="Open Document"> {OpenDocIcon}</StackItem>
                                                        )}
                                                        <StackItem
                                                          id="citation-panel-close"
                                                          onClick={() => {!popUpBlocker && setIsCitationPanelOpen(false);}}
                                                          onKeyDown={(e) =>{
                                                              if (e.key === "Enter" || e.key === " ") {
                                                                  if (!popUpBlocker) setIsCitationPanelOpen(false);
                                                              }
                                                          }}
                                                          className={closeXCitation} style={{ cursor: popUpBlocker ? 'not-allowed' : 'pointer' }} role="button" tabIndex={0} aria-label="Close Citations Panel"
                                                          title="Close Citations Panel"> {closeIconCitation}</StackItem>
                                                    </Stack>
                                                     
                                                    {/* <div tabIndex={0} className={styles.spTitleCitation}>{activeCitation.filepath ? activeCitation.filepath : ""}</div> */}
                                                    <div tabIndex={0}>
                                                      {/* Search bar for citations */}
                                                      <div className={styles.searchBarContainer} style={{ padding: '8px 16px', marginBottom: '8px' }}>
                                                          <div 
                                                            className={styles.searchBarWrapper}
                                                            onMouseEnter={(e) => {
                                                              const input = e.currentTarget.querySelector('input');
                                                              const icon = e.currentTarget.querySelector('span');
                                                              if (input && document.activeElement !== input) {
                                                                input.classList.add(styles.searchInputHover);
                                                              }
                                                              if (icon) icon.classList.add(styles.searchIconActive);
                                                            }}
                                                            onMouseLeave={(e) => {
                                                              const input = e.currentTarget.querySelector('input');
                                                              const icon = e.currentTarget.querySelector('span');
                                                              if (input && document.activeElement !== input) {
                                                                input.classList.remove(styles.searchInputHover);
                                                              }
                                                              if (icon) icon.classList.remove(styles.searchIconActive);
                                                            }}
                                                            >
                                                              <input
                                                                type="text"
                                                                placeholder="Search"
                                                                value={searchTextCitation}
                                                                maxLength={citation_inputfield_character_limit}
                                                                onChange={(e) => {
                                                                  setSearchTextCitation(e.target.value);
                                                                  setCurrentMatchIndex(0);
                                                                }}
                                                                className={styles.searchInput}
                                                                onFocus={(e) => {
                                                                  e.target.classList.add(styles.searchInputFocus);
                                                                  e.target.classList.remove(styles.searchInputHover);
                                                                  const icon = e.target.parentElement?.querySelector('span');
                                                                  if (icon) icon.classList.remove(styles.searchIconActive);
                                                                }}
                                                                onBlur={(e) => {
                                                                  e.target.classList.remove(styles.searchInputFocus);
                                                                  const icon = e.target.parentElement?.querySelector('span');
                                                                  if (icon) icon.classList.remove(styles.searchIconActive);
                                                                }}
                                                                aria-label="Search in citations"
                                                              />
                                                              <span className={styles.searchIcon}>
                                                                {Search}
                                                              </span>
                                                              {/* Match counter and navigation buttons */}
                                                              {searchTextCitation && (
                                                                  <div className={styles.matchCounterContainer}>
                                                                      {/* Match counter */}
                                                                      <span className={styles.matchCounter} tabIndex={0} aria-live="polite" aria-atomic="true">
                                                                          {totalMatches > 0 ? `${currentMatchIndex + 1}/${totalMatches}` : '0/0'}
                                                                      </span>
                                                                      
                                                                      {/* Separator */}
                                                                      <span className={styles.matchSeparator}>|</span>
                                                                      
                                                                      {/* Navigation buttons container */}
                                                                      <div className={styles.matchNavButtons}>
                                                                        {/* Up arrow - previous match */}
                                                                        <button
                                                                          className={`${styles.matchNavButton} ${totalMatches === 0 ? styles.matchNavButtonDisabled : ''}`}
                                                                            onClick={() => navigateToPreviousMatch()}
                                                                            onKeyDown={(e) => {
                                                                              if (e.key === 'Enter' || e.key === ' ') {
                                                                                e.preventDefault();
                                                                                navigateToPreviousMatch();
                                                                            }}}
                                                                            disabled={totalMatches === 0}
                                                                            tabIndex={0}
                                                                            aria-label="Previous match"
                                                                            title="Previous match"
                                                                        >
                                                                          {upArrowIcon}
                                                                        </button>
                                                                        
                                                                        {/* Down arrow - next match */}
                                                                        <button
                                                                          className={`${styles.matchNavButton} ${totalMatches === 0 ? styles.matchNavButtonDisabled : ''}`}
                                                                          onClick={() => navigateToNextMatch()}
                                                                          onKeyDown={(e) => {
                                                                          if (e.key === 'Enter' || e.key === ' ') {
                                                                            e.preventDefault();
                                                                            navigateToNextMatch();
                                                                          }}}
                                                                          tabIndex={0}
                                                                          disabled={totalMatches === 0}
                                                                          aria-label="Next match"
                                                                          title="Next match"
                                                                        >
                                                                          {downArrowIcon}
                                                                        </button>
                                                                      </div>
                                                                  </div>
                                                              )}
                                                              {/* Clear search button */}
                                                              {searchTextCitation && (
                                                                <button 
                                                                  className={styles.clearSearchButton}
                                                                  onClick={() => {
                                                                      setSearchTextCitation('');
                                                                      setCurrentMatchIndex(0);
                                                                      setTotalMatches(0);
                                                                      setMatchPositions([]);
                                                                      setText5Error('');
                                                                  }}
                                                                  onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                        setSearchTextCitation('');
                                                                        setCurrentMatchIndex(0);
                                                                        setTotalMatches(0);
                                                                        setMatchPositions([]);
                                                                        setText5Error('');
                                                                    }
                                                                  }}
                                                                  tabIndex={0}
                                                                  aria-label="Clear search"
                                                                >
                                                                  {closeIconCitation}
                                                                </button>
                                                              )}
                                                          </div>
                                                      </div>
                                                      <label
                                                        aria-live="polite"
                                                        aria-atomic="true"
                                                        id="text5Error"
                                                        className={styles.searchBarError}
                                                        style={{
                                                            display: text5Error ? 'block' : 'none',
                                                            marginTop: '0px',
                                                        }}
                                                      >
                                                        {text5Error}
                                                      </label>
                                                      <div 
                                                        ref={citationContentRef}
                                                        translate={searchTextCitation ? "no" : "yes"}
                                                        className={styles.spTextCitation}
                                                        key={`${activeCitation?.id ?? ''}|${searchTextCitation}|${currentMatchIndex}`}>
                                                        <ReactMarkdown
                                                            linkTarget="_blank"
                                                            children={highlightSearchMatches(DOMPurify.sanitize(activeCitation.content, { ALLOWED_TAGS: XSSAllowTags }), searchTextCitation)}
                                                            remarkPlugins={[remarkGfm]}
                                                            rehypePlugins={[rehypeRaw]}
                                                        />
                                                      </div>
                                                    </div>

                                                </div>

                                              
                                            </Stack>
                                          </SlidingPane>
                                          </FocusTrap>
                                        )}
                                    </Stack>
                          
                            </div>
                              
                             
                            {/* )
                        } */}
                            <MediaQuery query="(min-width: 992px)">
                                {messages && messages.length > 0 && isCitationPanelOpen && activeCitation && window.innerWidth >= 992 && (
                                  
                                    <Stack horizontal horizontalAlign="start" style={{ maxWidth: '25%', position: 'fixed', right: '25%' }}>
                                      <FocusTrap
                                        active={isCitationPanelOpen && !isFocusTrapPaused} 
                                        focusTrapOptions={{ 
                                          clickOutsideDeactivates: true, 
                                          escapeDeactivates: true,
                                          returnFocusOnDeactivate: true,
                                          initialFocus: () => document.getElementById("citation-panel-close"),
                                          onActivate: () => setIsOtherFocusTrapOpen(true),
                                          onDeactivate: () => setIsOtherFocusTrapOpen(false),
                                          }}
                                        >
                                        <div ref={citationsContainerRef} className={styles.spContainerCitation}>
                                            <Stack horizontal verticalAlign="center" horizontalAlign="start" className={styles.spTitleContainerCitation}>
                                                <StackItem tabIndex={0} className={styles.spTitleCitation}>{"Citations"}</StackItem>
                                                {branding?.hide_citations_kb_button !== "true" && activeCitation?.url && (
                                                <StackItem title="Open Document" aria-label="Open Document" onClick={() => {!popUpBlocker && onOpenCitationDocument(activeCitation)}} onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        if (!popUpBlocker) onOpenCitationDocument(activeCitation);
                                                    }
                                                }}className={styles.citationPanelKbButton} style={{ cursor: popUpBlocker ? 'not-allowed' : 'pointer' }} role="button" tabIndex={0}> {OpenDocIcon}</StackItem>
                                                )}
                                                <StackItem id="citation-panel-close" title="Close Citations Panel" aria-label="Close Citations Panel" onClick={() => {!popUpBlocker && setIsCitationPanelOpen(false)}} onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        if (!popUpBlocker) setIsCitationPanelOpen(false);
                                                    }
                                                }}className={closeXCitation} style={{ cursor: popUpBlocker ? 'not-allowed' : 'pointer' }} role="button" tabIndex={0}> {closeIconCitation}</StackItem>
                                            </Stack>
                                           {/* <div tabIndex={0} className={styles.spTitleCitation}>{activeCitation.filepath ? activeCitation.filepath : ""}</div> */}
                                            <div tabIndex={0}>
                                            {/* Search bar for citations */}
                                            <div className={styles.searchBarContainer} style={{ padding: '8px 16px', marginBottom: '8px' }}>
                                                <div 
                                                  style={{ position: 'relative', width: '100%' }}
                                                  onMouseEnter={(e) => {
                                                    const input = e.currentTarget.querySelector('input');
                                                    const icon = e.currentTarget.querySelector('span');
                                                    if (input && document.activeElement !== input) {
                                                      input.classList.add(styles.searchInputHover);
                                                    }
                                                    if (icon) icon.classList.add(styles.searchIconActive);
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    const input = e.currentTarget.querySelector('input');
                                                    const icon = e.currentTarget.querySelector('span');
                                                    if (input && document.activeElement !== input) {
                                                      input.classList.remove(styles.searchInputHover);
                                                    }
                                                    if (icon) icon.classList.remove(styles.searchIconActive);
                                                  }}
                                                  >
                                                    <input
                                                      type="text"
                                                      placeholder="Search"
                                                      value={searchTextCitation}
                                                      maxLength={citation_inputfield_character_limit}
                                                      onChange={(e) => {
                                                        setSearchTextCitation(e.target.value);
                                                        setCurrentMatchIndex(0);
                                                      }}
                                                      className={styles.searchInput}
                                                      onFocus={(e) => {
                                                        e.target.classList.add(styles.searchInputFocus);
                                                        e.target.classList.remove(styles.searchInputHover);
                                                        const icon = e.target.parentElement?.querySelector('span');
                                                        if (icon) icon.classList.remove(styles.searchIconActive);
                                                      }}
                                                      onBlur={(e) => {
                                                        e.target.classList.remove(styles.searchInputFocus);
                                                        const icon = e.target.parentElement?.querySelector('span');
                                                        if (icon) icon.classList.remove(styles.searchIconActive);
                                                      }}
                                                      aria-label="Search in citations"
                                                    />
                                                    <span className={styles.searchIcon}>
                                                      {Search}
                                                    </span>
                                                    {/* Match counter and navigation buttons */}
                                                    {searchTextCitation && (
                                                        <div className={styles.matchCounterContainer}>
                                                            {/* Match counter */}
                                                            <span className={styles.matchCounter} tabIndex={0} aria-live="polite" aria-atomic="true">
                                                                {totalMatches > 0 ? `${currentMatchIndex + 1}/${totalMatches}` : '0/0'}
                                                            </span>
                                                            
                                                            {/* Separator */}
                                                            <span className={styles.matchSeparator}>|</span>
                                                            
                                                            {/* Navigation buttons container */}
                                                            <div className={styles.matchNavButtons}>
                                                              {/* Up arrow - previous match */}
                                                              <button
                                                                className={`${styles.matchNavButton} ${totalMatches === 0 ? styles.matchNavButtonDisabled : ''}`}
                                                                onClick={() => navigateToPreviousMatch()}
                                                                onKeyDown={(e) => {
                                                                  if (e.key === 'Enter' || e.key === ' ') {
                                                                    e.preventDefault();
                                                                    navigateToPreviousMatch();
                                                                }}}
                                                                tabIndex={0}
                                                                disabled={totalMatches === 0}
                                                                aria-label="Previous match"
                                                                title="Previous match"
                                                              >
                                                                {upArrowIcon}
                                                              </button>
                                                              {/* Down arrow - next match */}
                                                              <button
                                                                className={`${styles.matchNavButton} ${totalMatches === 0 ? styles.matchNavButtonDisabled : ''}`}
                                                                onClick={() => navigateToNextMatch()}
                                                                onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                  e.preventDefault();
                                                                  navigateToNextMatch();
                                                                }}}
                                                                tabIndex={0}
                                                                disabled={totalMatches === 0}
                                                                aria-label="Next match"
                                                                title="Next match"
                                                              >
                                                                {downArrowIcon}
                                                              </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {/* Clear search button */}
                                                    {searchTextCitation && (
                                                      <button 
                                                        className={styles.clearSearchButton}
                                                        onClick={() => {
                                                            setSearchTextCitation('');
                                                            setCurrentMatchIndex(0);
                                                            setTotalMatches(0);
                                                            setMatchPositions([]);
                                                            setText5Error('');
                                                        }}
                                                        onKeyDown={(e) => {
                                                          if (e.key === 'Enter' || e.key === ' ') {
                                                              setSearchTextCitation('');
                                                              setCurrentMatchIndex(0);
                                                              setTotalMatches(0);
                                                              setMatchPositions([]);
                                                              setText5Error('');
                                                          }
                                                        }}
                                                        aria-label="Clear search"
                                                        tabIndex={0}
                                                      >
                                                        {closeIconCitation}
                                                      </button>
                                                    )}
                                                </div>
                                            </div>
                                            <label
                                              aria-live="polite"
                                              aria-atomic="true"
                                              id="text5Error"
                                              className={styles.searchBarError}
                                              style={{
                                                  display: text5Error ? 'block' : 'none',
                                                  marginTop: '0px',
                                              }}
                                            >
                                              {text5Error}
                                            </label>
                                              <div 
                                                ref={citationContentRef}
                                                translate={searchTextCitation ? "no" : "yes"} 
                                                className={styles.spTextCitation}
                                                key={`${activeCitation?.id ?? ''}|${searchTextCitation}|${currentMatchIndex}`}>
                                                <ReactMarkdown
                                                    linkTarget="_blank"
                                                    children={highlightSearchMatches(DOMPurify.sanitize(activeCitation.content, { ALLOWED_TAGS: XSSAllowTags }), searchTextCitation)}
                                                    remarkPlugins={[remarkGfm]}
                                                    rehypePlugins={[rehypeRaw]}
                                                />
                                              </div>
                                            </div>

                                        </div>

                                      </FocusTrap>
                                    </Stack>
                                    )}
                            </MediaQuery>    
                    {/* <div className={appStateContext?.state.isFeedbackPanelOpen || hideFeedbackButton() ? styles.displayNone : styles.feedback}>
                          
                          <Stack  horizontalAlign="end" className={styles.feedbackStack}>  
                              <CommandBarButton
                                  role="button"
                                  className={styles.feedbackButton}
                                  onClick={handleFeedbackModalClick}
                                  text="FEEDBACK"
                                  aria-label="FEEDBACK"
                                  title="FEEDBACK"
                          /></Stack>                   
                   </div>    */}
                 
                        <Stack id="chat-input-area" horizontal className=
                        {(selectPgmCode?.toLowerCase().includes("selectpgm")) ? styles.visuallyHidden : appStateContext?.state.isFeedbackPanelOpen ||
                                (((isFAQPaneOpen && window.innerWidth < 992)  || isCautionModalPanelOpen || isUserTermsModalPanelOpen || isPrivacyPolicyModalPanelOpen)
                                ) || (isCitationPanelOpen && window.innerWidth < 992) ? styles.visuallyHidden : 
                                isFAQPaneOpen ? (isCitationPanelOpen || (isProfilePaneOpen && window.innerWidth >= 992)) ? styles.chatInputNudgeBoth : styles.chatInputNudge : (isCitationPanelOpen || (isProfilePaneOpen && window.innerWidth >= 992)) ? styles.chatInputNudgeRight : styles.chatInput}>
                             <Stack>
                                    <Dialog data-theme={isDarkMode ? "dark" : ""}    
                                    hidden={hideErrorDialog}
                                    onDismiss={handleErrorDialogClose}
                                    dialogContentProps={errorDialogContentProps}
                                    modalProps={modalProps}
                                    styles={{main: [{ selectors: { ['@media (min-width: 280px)']: {
                                        maxWidth: '90%', background: isDarkMode ? "#1C1B2C" : "#FFFFFF", boxShadow: "0px 14px 28.8px rgba(0, 0, 0, 0.24), 0px 0px 8px rgba(0, 0, 0, 0.2)",  borderRadius: "8px",
                                        color: isDarkMode ? "#FFFFFF" : "#000000", maxHeight: '90%',minHeight: '100px',borderColor: '#155146',  borderStyle: 'solid', borderWidth: '1px',margin: '15px'}}}]}}/>
                            </Stack>
                                    
                              
                                <Stack horizontal horizontal-horizontalAlign="stretch" 
                                    className={isFAQPaneOpen ? (isCitationPanelOpen || (isProfilePaneOpen && window.innerWidth >= 992)) ? styles.questionInputDivNudgeBoth : styles.questionInputDivNudge : (isCitationPanelOpen || (isProfilePaneOpen && window.innerWidth >= 992)) ? styles.questionInputDivNudgeRight: (isContentInsideIframeWindow ? (isFullScreen ? `${styles.questionInputDiv}` : `${styles.questionInputDivWidget}`) : `${styles.questionInputDiv}`)}  >
                            {branding?.show_top_of_page_button == 'Y' && scrollbarVisible && !isAtTop && (
                                <button
                                    className={styles.scrollToTopButton}
                                    onClick={scrollToTop}
                                    title='Scroll to Top of Chat'
                                >
                                    {ScrollToTop}
                                </button>
                            )}
                            <QuestionInput
                                clearOnSend
                                placeholder={Math.max(window.screen.width, window.innerWidth) <630? branding?.placeholder_abbrev_text ? branding?.placeholder_abbrev_text : "": branding?.placeholder_long_text ? branding?.placeholder_long_text : ""}
                                disabled={!isMsgRenderComplete || isSignOnInProgress}
                                onSend={(question, id) => {
                                    appStateContext?.state.isCosmosDBAvailable?.cosmosDB ? makeApiRequest(question,"N", "N",id, activeCaseRef.current) :null
                                }}
                                conversationId={appStateContext?.state.currentChat?.id ? appStateContext?.state.currentChat?.id : undefined}
                                speechEnabled={branding?.speech_enabled}
                                stopMsgPlaying={stopMsgPlaying}
                                setStopMsgPlaying={setStopMsgPlaying}
                                popUpBlocker={popUpBlocker}
                                setPopUpBlocker={setPopUpBlocker}
                                isContentInsideIframeWindow={isContentInsideIframeWindow}
                                isFullScreen={isFullScreen}
                                isMsgRenderComplete={isMsgRenderComplete}
                                setIsStopped={setIsStopped}  
                                characterLimit={characterLimit}
                                addErrorMessageToChat={addErrorMessageToChat}
                                isDarkMode={isDarkMode}
                                
                            />
                       
                        {/* <MediaQuery query="(min-width: 1200px)">     */}
                        <Stack horizontal   horizontalAlign="baseline"  className={appStateContext?.state.isFeedbackPanelOpen  ? styles.displayNone :styles.cautionContainer}>
                        <Stack horizontal verticalAlign="center" horizontalAlign="space-between" className={styles.cautionInterior}>
                         
                                <Stack horizontal verticalAlign="center"  horizontalAlign="start">
                                    <CommandBarButton
                                                id="faq-button"
                                                tabIndex={0}
                                                role="button"
                                                className={styles.faqImgButton}
                                                onClick={handleFAQClick}
                                                text="FAQs"
                                                aria-label="FAQ's"
                                                title="FAQs"
                                                disabled={popUpBlocker}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                      handleFAQClick();
                                                    }
                                                  }}
                                                styles={{
                                                    rootDisabled: {
                                                        cursor: 'not-allowed', // Ensure cursor is not-allowed when disabled
                                                    },
                                                    textContainer: {
                                                        overflow: 'hidden',
                                                    },
                                                    label: {
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis',
                                                    }
                                                }}  
                                        />
                                        
                                                <Stack horizontal horizontalAlign="start" verticalAlign="center" className={copyRight} title={branding?.show_copyright === 'Y' ? branding?.copyright_text : ''}> 
                                                    {branding?.show_copyright === "Y" && (
                                                        <>
                                                            <MediaQuery query="(max-width: 600px)">
                                                                {"©"}
                                                            </MediaQuery>
                                                            <MediaQuery query="(min-width: 601px)">
                                                                {branding?.copyright_text} 
                                                            </MediaQuery>
                                                        </>
                                                    )}
                                                </Stack>
                                  
                                </Stack>
                            
                                
                                         
                                <Stack horizontal   horizontalAlign="end"  style= {{color: '#FFFFFF'}} >
                                    <Stack horizontal verticalAlign="center" horizontalAlign="end" className={styles.userTerms}>
                                        {branding?.show_user_terms == "Y" &&
                                            <CommandBarButton
                                                id="user-terms-button"
                                                tabIndex={0}
                                                role="button"
                                                className={styles.userTermsButton}
                                                onClick={handleUserTermsModalClick}
                                                text={branding?.footer_terms_label ? branding?.footer_terms_label : "Terms"}
                                                aria-label={branding?.footer_terms_label ? branding?.footer_terms_label : "Terms"}
                                                title={branding?.footer_terms_label ? branding?.footer_terms_label : "Terms"}
                                                disabled={popUpBlocker}
                                                styles={{
                                                    rootDisabled: {
                                                        cursor: 'not-allowed', // Ensure cursor is not-allowed when disabled
                                                    },
                                                    textContainer: {
                                                        overflow: 'hidden',
                                                    },
                                                    label: {
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis',
                                                    }
                                                }}  
                                            />
                                        }
                                    </Stack>   
                                    <Stack horizontal verticalAlign="center" className={styles.privacyPolicy} style= {{color: '#FFFFFF'}}  > 
                                        {branding?.show_privacy_policy == "Y"  &&
                                            <CommandBarButton
                                            id="privacy-policy-button"
                                            tabIndex={0}
                                            role="button"
                                            className={styles.privacyPolicyButton}
                                            onClick={handlePrivacyPolicyModalClick}
                                            text={branding?.footer_privacy_label ? branding?.footer_privacy_label : "Privacy"}
                                            aria-label={branding?.footer_privacy_label ? branding?.footer_privacy_label : "Privacy"}
                                            title={branding?.footer_privacy_label ? branding?.footer_privacy_label : "Privacy"}
                                            disabled={popUpBlocker}
                                            styles={{
                                                rootDisabled: {
                                                    cursor: 'not-allowed', // Ensure cursor is not-allowed when disabled
                                                },
                                                textContainer: {
                                                    overflow: 'hidden',
                                                },
                                                label: {
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                }
                                            }} 
                                        />}
                                    </Stack>
                                    <CommandBarButton
                                                id="ai-caution-button"
                                                tabIndex={0}
                                                role="button"
                                                className={styles.cautionImgButton}
                                                onClick={handleCautionModalClick}
                                                text={branding?.footer_aicautions_label ? branding?.footer_aicautions_label : "AI Cautions"}
                                                aria-label={branding?.footer_aicautions_label ? branding?.footer_aicautions_label : "AI Cautions"}
                                                title={branding?.footer_aicautions_label ? branding?.footer_aicautions_label : "AI Cautions"}
                                                disabled={popUpBlocker}
                                                styles={{
                                                    rootDisabled: {
                                                        cursor: 'not-allowed', // Ensure cursor is not-allowed when disabled
                                                    },
                                                    textContainer: {
                                                        overflow: 'hidden',
                                                    },
                                                    label: {
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis',
                                                    }
                                                }}  
                                        />
                                
                                </Stack>
                            </Stack>    
                            </Stack>
                            <FocusTrap
                              active={appStateContext?.state.isFeedbackPanelOpen && !isFocusTrapPaused}
                              focusTrapOptions={{
                                clickOutsideDeactivates: true,
                                escapeDeactivates: true,
                                returnFocusOnDeactivate: true,
                                initialFocus: false,
                                onActivate: () => setIsOtherFocusTrapOpen(true),
                                onDeactivate: () => setIsOtherFocusTrapOpen(false),
                              }}
                            > 
                                <SlidingPane
                                    className={isFAQPaneOpen ? styles.spCustom : styles.spCustomFAQClosed}
                                    isOpen={appStateContext?.state.isFeedbackPanelOpen}
                                    from={"bottom"}
                                    width={window.innerWidth >= 992 ? "60%" : "100%"}
                                    hideHeader
                                    onRequestClose={handleFeedbackModalClick}
                                >
                                        <div className={styles.modalMain} data-theme={isDarkMode? "dark" :""}>
                                            <Stack className={styles.modalContainer} data-theme={isDarkMode? "dark" :""}>
                                                
                                                <Stack horizontal verticalAlign="center" className={styles.modalHRNew} data-theme={isDarkMode? "dark" :""}>
                                                <Stack horizontalAlign="start" verticalAlign="center">
                                                <img src={isDarkMode ? branding?.dialog_logo_darkmode : branding?.dialog_logo} aria-hidden="true" alt="Brand Logo" className={styles.modalIcon} /></Stack>
                                                
                                                {/* Conditionally display the feedback header title based on the state of showThankYouMessage */}
                                                <Stack
                                                  aria-live="assertive"
                                                  tabIndex={0}
                                                  horizontalAlign="space-between" 
                                                  verticalAlign="center" 
                                                  className={styles.spSubtitleContainer}
                                                > 
                                                  <b className={styles.modalEmptyStateSubtitle}>
                                                    {(showThankYouMessage) ? feedbackTitle1 : feedbackTitle2}
                                                  </b>
                                                </Stack>

                                                <Stack id="feedback-panel-close" role="button" horizontalAlign="end" verticalAlign="center" tabIndex={0}
                                                        onClick={handleFeedbackModalClick} aria-label="Close Feedback Panel" title="Close Feedback Panel" onKeyDown={(e)=>{
                                                          if(e.key === "Enter" || e.key === " ") {handleFeedbackModalClick();}
                                                        }} className={closeXOther}><CloseIcon /></Stack>

                                            </Stack>
 
                                            <Feedback
                                                clearOnSend
                                                placeholder="Type here..."
                                                disabled={!isMsgRenderComplete}
                                                darkmode={isDarkMode}
                                                onSend={(rating, feedback, id, messageid, messagefb) => {
                                                    sendFeedback(rating, feedback, id, messageid, messagefb)
                                                }}
                                                conversationId={appStateContext?.state.currentChat?.id ? appStateContext?.state.currentChat?.id : undefined}
                                                thankYouMessagePayload={ThankYouMessagePayload}
                                                setShowThankYouMessage={setShowThankYouMessage}
                                                showThankYouMessage={showThankYouMessage}
                                                setPopUpBlocker={setPopUpBlocker}
                                            />
                                                <input  aria-hidden="true" tabIndex={-1} id="text1" type="text" value={text1} contentEditable={false} className={styles.modalInt} data-theme={isDarkMode? "dark" :""} />
                                        </Stack>
                                </div>
                                </SlidingPane>
                                </FocusTrap>
                                <FocusTrap
                                  active={isCautionModalPanelOpen && !isFocusTrapPaused} 
                                  focusTrapOptions={{ 
                                    clickOutsideDeactivates: true, 
                                    escapeDeactivates: true,
                                    returnFocusOnDeactivate: false,
                                    onActivate: () => setIsOtherFocusTrapOpen(true),
                                    onDeactivate: () => setIsOtherFocusTrapOpen(false),
                                    }}
                                >
                                <SlidingPane 
                                    className={isFAQPaneOpen ? styles.spCustom : styles.spCustomFAQClosed}
                                    isOpen={isCautionModalPanelOpen}
                                    from={"bottom"}
                                    width={window.innerWidth >= 992 ? "60%" : "100%"}
                                    hideHeader
                                    onRequestClose={() => { handleCautionModalPanelDismiss()}}
                                >
                                        <div className={styles.modalMain} data-theme={isDarkMode? "dark" :""}>
                                            <Stack className={styles.modalContainer} data-theme={isDarkMode? "dark" :""}>
                                                <Stack horizontal verticalAlign="center" className={styles.modalHRNew} data-theme={isDarkMode? "dark" :""}>
                                                <Stack horizontalAlign="start" verticalAlign="center">    
                                                        <img src={isDarkMode ? branding?.dialog_logo_darkmode : branding?.dialog_logo} aria-hidden="true" alt="Brand Logo" className={styles.modalIcon}/></Stack>
                                                <Stack horizontalAlign="space-between" verticalAlign="center" className={styles.spSubtitleContainer}> 
                                                  <b tabIndex={0} className={styles.modalEmptyStateSubtitle}>
                                                    {branding?.slideup_aicautions_title ? branding?.slideup_aicautions_title : "AI Cautions"}
                                                  </b>
                                                  </Stack>
                                                <Stack id="cautions-close" horizontalAlign="end" verticalAlign="center" tabIndex={0}
                                                onClick={() => {handleCautionModalPanelDismiss();}} role="button" aria-label="Close AI Cautions" title="Close AI Cautions" className={closeXOther} onKeyDown={(e)=> {
                                                  if(e.key === "Enter" || e.key === " ") {handleCautionModalPanelDismiss();}
                                                }}><CloseIcon /></Stack>
                                              
                                            </Stack>
                                            <div tabIndex={0}>
                                              <ReactMarkdown linkTarget="_blank" remarkPlugins={[remarkGfm, supersub]}
                                                            children={branding?.caution_text? branding?.caution_text:""}
                                                            className={styles.modalContainerInt}  />
                                        
                                                 
                                                  <input aria-hidden="true" tabIndex={-1} id="text1" type="text" value={text1} contentEditable={false} className={styles.modalInt} />
                                            </div>
                                        </Stack>
                                    </div>
                                </SlidingPane>
                                </FocusTrap>
                                <FocusTrap
                                  active={isPrivacyPolicyModalPanelOpen && !isFocusTrapPaused} 
                                  focusTrapOptions={{ 
                                    clickOutsideDeactivates: true, 
                                    escapeDeactivates: true,
                                    returnFocusOnDeactivate: false,
                                    onActivate: () => setIsOtherFocusTrapOpen(true),
                                    onDeactivate: () => setIsOtherFocusTrapOpen(false),
                                    }}
                                >
                                    <SlidingPane 
                                      className={isFAQPaneOpen ? styles.spCustom : styles.spCustomFAQClosed}
                                      isOpen={isPrivacyPolicyModalPanelOpen}
                                      from={"bottom"} width={window.innerWidth >= 992 ? "60%" : "100%"}
                                      hideHeader
                                      onRequestClose={() => {handlePrivacyPolicyModalPanelDismiss();}}>
                                      
                                        <div className={styles.modalMain} data-theme={isDarkMode? "dark" :""}>
                                            <Stack className={styles.modalContainer} data-theme={isDarkMode? "dark" :""}>
                                                <Stack horizontal verticalAlign="center" className={styles.modalHRNew} data-theme={isDarkMode? "dark" :""}>
                                                <Stack horizontalAlign="start" verticalAlign="center">    
                                                        <img src={isDarkMode ? branding?.dialog_logo_darkmode : branding?.dialog_logo} aria-hidden="true" alt="Brand Logo" className={styles.modalIcon} />
                                                </Stack>
                                                <Stack horizontalAlign="space-between" verticalAlign="center" className={styles.spSubtitleContainer}> 
                                                  <b tabIndex={0} ref={subtitleRef} className={styles.modalEmptyStateSubtitle}>
                                                    {branding?.slideup_privacy_title ? branding?.slideup_privacy_title : "Privacy Policy"}
                                                  </b>
                                                </Stack>
                                                <Stack id="privacy-close" horizontalAlign="end" verticalAlign="center" tabIndex={0} role="button" aria-label="Close Privacy Policy" title="Close Privacy Policy"
                                                onClick={() => {handlePrivacyPolicyModalPanelDismiss();}} className={closeXOther} onKeyDown={(e)=>{
                                                  if(e.key === "Enter" || e.key === " ") {handlePrivacyPolicyModalPanelDismiss();}
                                                }}><CloseIcon /></Stack>
                                              
                                            </Stack>
                                          
                                            <br/> 
                                            <div tabIndex={0}>
                                             <ReactMarkdown linkTarget="_blank" remarkPlugins={[remarkGfm, supersub]}
                                                          children=  {branding?.privacy_policy_text ? branding?.privacy_policy_text:""}
                                                          className={styles.modalContainerInt}  />
                                                <input aria-hidden="true" tabIndex={-1} id="text2" type="text" value={text2} contentEditable={false} className={styles.modalInt} data-theme={isDarkMode? "dark" :""} />
                                            </div>
                                        </Stack>
                                    </div>
                                </SlidingPane>
                                </FocusTrap>
                              <FocusTrap
                                active={isUserTermsModalPanelOpen && !isFocusTrapPaused} 
                                focusTrapOptions={{ 
                                  clickOutsideDeactivates: true, 
                                  escapeDeactivates: true,
                                  returnFocusOnDeactivate: false,
                                  onActivate: () => setIsOtherFocusTrapOpen(true),
                                  onDeactivate: () => setIsOtherFocusTrapOpen(false),
                                  }}
                                >
                                <SlidingPane
                                  className={isFAQPaneOpen ? styles.spCustom : styles.spCustomFAQClosed}
                                  isOpen={isUserTermsModalPanelOpen}
                                  from={"bottom"}
                                  width={window.innerWidth >=992 ? "60%": "100%" }
                                  hideHeader
                                  onRequestClose={() => { handleUserTermsModalPanelDismiss()}}>
                                        <div className={styles.modalMain} data-theme={isDarkMode? "dark" :""}>
                                            <Stack className={styles.modalContainer} data-theme={isDarkMode? "dark" :""}>
                                                <Stack horizontal verticalAlign="center" className={styles.modalHRNew} data-theme={isDarkMode? "dark" :""}>
                                                <Stack horizontalAlign="start" verticalAlign="center">    
                                                        <img src={isDarkMode ? branding?.dialog_logo_darkmode : branding?.dialog_logo} aria-hidden="true" alt="Brand Logo" className={styles.modalIcon}/></Stack>
                                                <Stack horizontalAlign="space-between" verticalAlign="center" className={styles.spSubtitleContainer}> 
                                                  <b tabIndex={0} className={styles.modalEmptyStateSubtitle}>
                                                    {branding?.slideup_terms_title ? branding?.slideup_terms_title : "Terms of Use"}
                                                  </b>
                                                </Stack>
                                                <Stack id="user-terms-close" horizontalAlign="end" verticalAlign="center" tabIndex={0} aria-label="Close Terms" role="button" title="Close Terms" onClick={() => {handleUserTermsModalPanelDismiss();}} className={closeXOther} onKeyDown={(e)=> {
                                                  if(e.key === "Enter" || e.key === " ") {
                                                    handleUserTermsModalPanelDismiss();
                                                  }
                                                }}><CloseIcon /></Stack>
                                              
                                            </Stack>
                                          
                                            <br/> 
                                            <div tabIndex={0}>
                                              <ReactMarkdown linkTarget="_blank" remarkPlugins={[remarkGfm, supersub]}
                                                            children= {branding?.user_terms_text?branding?.user_terms_text:""}
                                                            className={styles.modalContainerInt}  />
                                                  <input aria-hidden="true" tabIndex={-1} id="text3" type="text" value={text3} contentEditable={false} className={styles.modalInt} data-theme={isDarkMode? "dark" :""} />
                                            </div>
                                        </Stack>
                                    </div>
                                </SlidingPane>
                                </FocusTrap>
                                
                                <MediaQuery query="(max-width: 991px)">
                                <FocusTrap
                                  active={isFAQPaneOpen && isFAQPanelInteracted && !isFocusTrapPaused && !isOtherFocusTrapOpen}
                                  focusTrapOptions={{ 
                                    initialFocus: () => {
                                        // Respect the current focus if already on an element inside the FAQ panel
                                        const currentFocusedElement = document.activeElement;
                                        if (currentFocusedElement && document.getElementById('faq-panel-close')?.contains(currentFocusedElement)) {
                                          return currentFocusedElement;
                                        }
                                        // Otherwise, focus the close button
                                        return document.getElementById('faq-panel-close');
                                      },
                                    clickOutsideDeactivates: true, 
                                    escapeDeactivates: true,
                                    returnFocusOnDeactivate: true,
                                    }}
                                  >
                                    <SlidingPane
                                        isOpen={isFAQPaneOpen}
                                        from="bottom"
                                        className={styles.spCustomFAQ}
                                        width={"100%"}
                                        hideHeader
                                        onRequestClose={() => {
                                            setIsFAQPaneOpen(false);
                                        }}
                                    >
                                      
                                        <div className={styles.spContainer}>
                                            <Stack
                                                horizontal
                                                verticalAlign="center"
                                                horizontalAlign="start"
                                                className={styles.spTitleContainerFAQ}
                                            >
                                                <StackItem className={styles.spTitle}>Frequently Asked Questions</StackItem>
                                                <StackItem
                                                    id="faq-panel-close"
                                                    onClick={() => {
                                                        setIsFAQPaneOpen(false);
                                                        setPopUpBlocker(false);
                                                        handleFAQPanelInteraction();
                                                    }}
                                                    onFocus={handleFAQPanelInteraction}
                                                    className={closeX}
                                                    tabIndex={0}
                                                    role="button"
                                                    aria-label="Close FAQ Panel"
                                                    title="Close FAQ Panel"
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            setIsFAQPaneOpen(false);
                                                            setPopUpBlocker(false);
                                                            handleFAQPanelInteraction();
                                                        }
                                                    }}
                                                >
                                                    <CloseIcon fill="var(--YW_Panels_Icons_Color)"  role="button" />
                                                </StackItem>
                                            </Stack>
                                            {branding?.hide_faq_subsections === "Y" ? 
                                                // Render the FAQ questions without subsections
                                                (fList                                                
                                                .map((item) => (
                                                    <Stack
                                                        role="button"
                                                        tabIndex={0}
                                                        horizontal
                                                        verticalAlign="center"
                                                        horizontalAlign="start"
                                                        className={
                                                            isMsgRenderComplete
                                                                ? styles.spRegContainer
                                                                : styles.spRegContainerInactive
                                                        }                                                                    
                                                        onClick={() => {
                                                            if (isMsgRenderComplete) {
                                                                setIsFAQPaneOpen(false);
                                                                makeApiRequestAuth(
                                                                    item.question,
                                                                    'Y',
                                                                    item.answer,
                                                                    item.requiresAuth,
                                                                    item.authType,
                                                                    item.authFields
                                                                );
                                                            } else void(0);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                if (isMsgRenderComplete) {
                                                                    setIsFAQPaneOpen(false);
                                                                    makeApiRequestAuth(
                                                                        item.question,
                                                                        'Y',
                                                                        item.answer,
                                                                        item.requiresAuth,
                                                                        item.authType,
                                                                        item.authFields
                                                                    );
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <StackItem className={styles.spReg}>
                                                            {item.question}
                                                        </StackItem>
                                                        <StackItem className={styles.spAction}    title="Select FAQ Question"
                                                                 aria-label="Select FAQ Question">
                                                            {chevronRightIcon}
                                                        </StackItem>
                                                    </Stack>
                                                ))
                                             ) :    
                                            // Render the FAQ questions with subsections                                                                           
                                            (sList                                                   
                                                .filter((section) =>
                                                    fList.some((item) => String(item.subSectionId) === String(section.id))
                                                )
                                                .map((section) => (
                                                    <Stack
                                                        className={styles.spSubsectionContainer}
                                                        key={section.id}
                                                    >
                                                        <Stack
                                                            horizontal
                                                            horizontalAlign="space-between"
                                                            verticalAlign="center"
                                                            onClick={() => {
                                                                if (popUpBlocker) return;
                                                                toggleSection(section.id);
                                                            }}
                                                            tabIndex={0}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                    if (popUpBlocker) return;
                                                                    toggleSection(section.id);
                                                                }
                                                            }
                                                            }
                                                            style={{ cursor: popUpBlocker ? 'not-allowed' : 'pointer' }}
                                                        >
                                                            <StackItem
                                                                className={styles.spSubsectionTitle}                                                            
                                                            >
                                                                {section.subSection}
                                                            </StackItem>
                                                            <StackItem                                                            
                                                                className={styles.spExpand}
                                                                role="button"
                                                                aria-label="Expand/Collapse section"
                                                                title="Expand/Collapse section"
                                                                style={{
                                                                    cursor: popUpBlocker ? 'not-allowed' : 'pointer',
                                                                }}
                                                            >
                                                                {expandedSections[section.id] ? MinimizeIcon : ExpandIcon}
                                                            </StackItem>
                                                        </Stack>
                                                        {expandedSections[section.id] && (
                                                            fList
                                                                .filter((item) => String(item.subSectionId) === String(section.id))
                                                                .map((item) => (
                                                                    <Stack
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        horizontal
                                                                        verticalAlign="center"
                                                                        horizontalAlign="start"
                                                                        className={
                                                                            isMsgRenderComplete
                                                                                ? styles.spRegContainer
                                                                                : styles.spRegContainerInactive
                                                                        }                                                                    
                                                                        onClick={() => {
                                                                            if (isMsgRenderComplete) {
                                                                                setIsFAQPaneOpen(false);
                                                                                makeApiRequestAuth(
                                                                                    item.question,
                                                                                    'Y',
                                                                                    item.answer,
                                                                                    item.requiresAuth,
                                                                                    item.authType,
                                                                                    item.authFields
                                                                                );
                                                                            } else void(0);
                                                                        }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                                if (isMsgRenderComplete) {
                                                                                    setIsFAQPaneOpen(false);
                                                                                    makeApiRequestAuth(
                                                                                        item.question,
                                                                                        'Y',
                                                                                        item.answer,
                                                                                        item.requiresAuth,
                                                                                        item.authType,
                                                                                        item.authFields
                                                                                    );
                                                                                }
                                                                            }
                                                                        }
                                                                        }
                                                                    >
                                                                        <StackItem className={styles.spReg}>
                                                                            {item.question}
                                                                        </StackItem>
                                                                        <StackItem className={styles.spAction}    title="Select FAQ Question"
                                                                 aria-label="Select FAQ Question">
                                                                            {chevronRightIcon}
                                                                        </StackItem>
                                                                    </Stack>
                                                                ))
                                                        )}
                                                    </Stack>
                                                ))
                                            )}
                                        </div>
                                    </SlidingPane>
                                  </FocusTrap>
                                </MediaQuery>

                        </Stack>
                            </Stack>
                          
                            <Dialog data-theme={isDarkMode ? "dark" : ""}
                                hidden={!showPgmMessage}
                                onDismiss={handlePgmDialogClose}
                                // dialogContentProps={pgmDialogContentProps}
                                dialogContentProps={{
                                    title: "",
                                    showCloseButton: true
                                }}
                                modalProps={pgmModalProps}
                              
                                styles={{
                                   
                                    main: [{
                                        selectors: {
                                            ['@media (min-width: 280px)']: {
                                                maxWidth: '90%', background: isDarkMode ? "#1C1B2C" : "#FFFFFF", boxShadow: "0px 14px 28.8px rgba(0, 0, 0, 0.24), 0px 0px 8px rgba(0, 0, 0, 0.2)", borderRadius: "8px",
                                               maxHeight: '90%', minHeight: '100px', borderColor: '#155146', borderStyle: 'solid', borderWidth: '1px', margin: '15px'
                                            }
                                        }
                                    }] 
                                }}>
                                    <Stack horizontal verticalAlign="center" horizontalAlign="baseline" data-theme={isDarkMode ? "dark" : ""}>
                                    <div className={styles.dialogTitle}data-theme={isDarkMode ? "dark" : ""}>{selectPgm + " Program "}</div>
                                    </Stack>
                                    <Stack horizontal verticalAlign="center" horizontalAlign="baseline" data-theme={isDarkMode ? "dark" : ""}>
                                    <div className={styles.dialogContent} data-theme={isDarkMode ? "dark" : ""}>{"Coming soon! Currently in development."}</div>
                                    <input aria-hidden="true" id="text4" type="text" value={text4} contentEditable={false} className={styles.modalInt} data-theme={isDarkMode ? "dark" : ""} />
                                    </Stack>
                                </Dialog>
                            <ProfileRemoveConfirmDialogs
                                removeProgramConfirm={removeProgramConfirm}
                                removeCaseConfirm={removeCaseConfirm}
                                isDarkMode={isDarkMode}
                                branding={branding}
                                modalProps={pgmModalProps}
                                onCancelProgramRemove={() => setRemoveProgramConfirm(null)}
                                onConfirmProgramRemove={(programCode) => {
                                    setRemoveProgramConfirm(null);
                                    onExternalProgramRemove(programCode);
                                }}
                                onCancelCaseRemove={() => setRemoveCaseConfirm(null)}
                                onConfirmCaseRemove={(caseNumber) => {
                                    setRemoveCaseConfirm(null);
                                    onCaseRemove(caseNumber);
                                }}
                            />
                            {authTypeV && !authTypeV.includes("profile") && (
                            <SlidingPane
                                className={`${styles.spCustomProfile} auth-slide-pane`}
                                isOpen={showAuthDialogMessage}
                                from={"bottom"}
                                width={window.innerWidth >= 992 ? "30%" : "100%"} 
                                hideHeader
                                aria-label="Information Required Panel"
                                onRequestClose={() => {
                                  if (!isSignOnInProgress) {
                                    updateAuthFieldsVal({});
                                    handleAuthDialogClose();
                                  }
                              }}
                            >
                                <div className={styles.profileModalMain} data-theme={isDarkMode ? "dark" : ""}>
                                    <Stack className={styles.modalContainer} data-theme={isDarkMode ? "dark" : ""}>
                                    {isSignOnInProgress && !isVerified && <Loading/>}
                                    {isVerified && <Verified/>}
                                        <Stack horizontal verticalAlign="center" className={styles.modalProfileHeader} data-theme={isDarkMode ? "dark" : ""}>
                                            <Stack horizontalAlign="center" verticalAlign="center" style={{ display: 'block', margin: '0 auto' }}>
                                                <img src={isDarkMode ? branding?.dialog_logo_darkmode : branding?.dialog_logo} aria-hidden="true" alt="Brand Logo" 
                                                className={styles.modalProfileIcon}  />
                                            </Stack>
                                            <Stack horizontalAlign="end" verticalAlign="center" tabIndex={0} role="button" aria-label="Close" title="Close"
                                                onClick={() => {updateAuthFieldsVal({}); handleAuthDialogClose()}} className={closeXModalProfile} onKeyDown={(e)=>{
                                                  if(e.key === "Enter" || e.key === " ") {updateAuthFieldsVal({}); handleAuthDialogClose()}
                                                }}><CloseIcon fill="var(--YW_SignIn_Modal_Close_Icon_Color)"/></Stack> 

                                        </Stack>
                                        {branding?.sign_in_modal_message_show === "Y" && (
                                        <Stack horizontalAlign="start" verticalAlign="center" className={styles.modalProfileSubHeader}>{branding?.sign_in_modal_message}</Stack>
                                        )}
                                          {authFields.split(',').map((field, index) => (
                                            <Stack horizontal horizontalAlign="start" data-theme={isDarkMode ? "dark" : ""} className={styles.modalProfilePlacement} >
                                                <Stack horizontalAlign="start" verticalAlign="center">
                                                    <div className={styles.modalProfileTextContainer}>
                                                        <label htmlFor={field.trim().toLowerCase().replace(/\s+/g, '')} id={`${field.trim().toLowerCase().replace(/\s+/g, '')}` + 'Label'}>{field.includes("Date of Birth") ? `${field} YYYY-MM-DD` : field.includes("Social Security Number") ? `${field} XXXXXXXXX` : `${field}`}</label>
                                                        <span id={`${field.trim().toLowerCase().replace(/\s+/g, '')}FieldName`} style={{ display: 'none' }}>{field.trim()}</span>
                                                         <input 
                                                          id={field.trim().toLowerCase().replace(/\s+/g, '')} 
                                                          type={field.includes("Social Security Number") ? (isSSNVisible ? "number" : "password"): field.includes("Date of Birth") ? (isDOBVisible ? "text" : "password") : "text"} 
                                                          style={{
                                                              color: "var(--YW_SignIn_Modal_UserID_Text_Font_Color)",
                                                              fontFamily: "var(--YW_Theme_Font_Type)",
                                                              fontSize: `calc(var(--YW_SignIn_Modal_UserID_Text_Font_Size) + 2px)`,
                                                              backgroundColor: "var(--YW_SignIn_Modal_UserID_TextBox_Color)",
                                                              fontStyle: "var(--YW_Theme_Font_Style)",
                                                              }}
                                                          onChange={onAuthFieldValChange}
                                                          value={authFieldsVal[field.trim().toLowerCase().replace(/\s+/g, '')] || ''}
                                                          onKeyDown={e => {
                                                            if ((e.key === "Enter" || e.key === " ") && !isSignOnInProgress) {
                                                                e.preventDefault();
                                                               makeApiRequestAuthValidate();
                                                          }
                                                          }}></input>
                                                          {field.includes("Social Security Number") && authFieldsVal.socialsecuritynumber && branding?.password_visibility_icon_enabled === "Y" && (
                                                          <Stack
                                                            role="button"
                                                            tabIndex={0}
                                                            aria-label={
                                                              isSSNVisible
                                                              ? "Hide"
                                                              : "Show"
                                                            }
                                                            onClick={() => setIsSSNVisible(!isSSNVisible)}
                                                            onKeyDown={(e) => {
                                                              if (e.key === "Enter" || e.key === " ") {
                                                                setIsSSNVisible(!isSSNVisible);
                                                              }
                                                            }}
                                                            styles={{
                                                              root: {
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                cursor: "pointer",
                                                              },
                                                            }}
                                                          >
                                                            {isSSNVisible ? Visibility : VisibilityOff}
                                                          </Stack>
                                                        )}
                                                         {field.includes("Date of Birth") && authFieldsVal.dateofbirth && branding?.password_visibility_icon_enabled === "Y" && (
                                                          <Stack
                                                            role="button"
                                                            tabIndex={0}
                                                            aria-label={
                                                              isDOBVisible
                                                              ? "Hide"
                                                              : "Show"
                                                            }
                                                            onClick={() => setIsDOBVisible(!isDOBVisible)}
                                                            onKeyDown={(e) => {
                                                              if (e.key === "Enter" || e.key === " ") {
                                                                setIsDOBVisible(!isDOBVisible);
                                                              }
                                                            }}
                                                            styles={{
                                                              root: {
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                cursor: "pointer",
                                                              },
                                                            }}
                                                          >
                                                            {isDOBVisible ? Visibility : VisibilityOff}
                                                          </Stack>
                                                        )}
                                                    </div>
                                                </Stack>
                                            </Stack>
                                         ))}
                                        <input tabIndex={-1} aria-hidden="true" id="text5" type="text" value={text5} contentEditable={false} className={styles.profileModalInt} />
                                        <label id="text5Error" className={styles.modalProfileError} style={{ display: text5Error === "" ? 'none' : 'block' }}>{text5Error}</label>
                                       
                                        <Stack horizontal horizontalAlign="center" style={{alignItems:'flex-start', flexFlow: 'column'}}>
                                         
                                            <CommandBarButton
                                                role="button"
                                                className={styles.submitLoginButtonAuth}
                                                onClick={e => {
                                                    makeApiRequestAuthValidate();
                                                  }
                                                }
                                                text={authTypeV.includes("ivr") ? "SIGN IN" : "SUBMIT"}
                                                aria-label={authTypeV.includes("ivr") ? "SIGN IN" : "SUBMIT"}
                                                title={authTypeV.includes("ivr") ? "SIGN IN" : "SUBMIT"}
                                                onKeyDown= {e =>
                                                  (e.key  === "Enter" || e.key === " ") && !isSignOnInProgress ? makeApiRequestAuthValidate(): null
                                                }
                                                disabled={isSignOnInProgress}
                                            />
                                        </Stack>
                                        {branding?.sign_in_modal_copyright_show === "Y" && (
                                         <Stack horizontal horizontalAlign="start" verticalAlign="center" className={modalProfileCopyright} title={branding?.copyright_text}> 
                                            {branding?.copyright_text} 
                                         </Stack>   )}
                                    </Stack>
                                </div>   </SlidingPane>)}

                                {knowledgeBaseOpen && (
                                <SlidingPane
                                      className={`${styles.spCustomProfile} auth-slide-pane`}
                                      isOpen={knowledgeBaseOpen}
                                      from={"bottom"}
                                      width={window.innerWidth >= 992 ? "30%" : "100%"}
                                      hideHeader
                                      onRequestClose={() => { handleCaseSelectDialogClose(); }}
                                  >
                                    <FocusTrap
                                        active={knowledgeBaseOpen && isFocusTrapActive && !isFocusTrapPaused} // Deactivate FocusTrap if dropdown is being interacted with
                                      focusTrapOptions={{
                                          clickOutsideDeactivates: true,
                                          escapeDeactivates: true,
                                          returnFocusOnDeactivate: false,
                                          initialFocus: false,
                                          fallbackFocus: () => document.getElementById("knowledgeSelect-close") || document.body,
                                          onActivate: () => setIsOtherFocusTrapOpen(true),
                                          onDeactivate: () => {
                                            setIsOtherFocusTrapOpen(false)
                                            document.getElementById("knowledge-base-download")?.focus();
                                          }
                                        }}
                                    >
                                      <div className={styles.profileModalMain}data-theme={isDarkMode ? "dark" : ""}>
                                          <Stack className={styles.modalContainer} data-theme={isDarkMode ? "dark" : ""}>
                                           {/* Status announcements for screen readers */}
                                            <div
                                              aria-live="assertive"
                                              aria-atomic="true"
                                              className={styles.visuallyHidden}
                                            >
                                              {isLoading ? "Loading" : 
                                              isVerified ? "Loading complete. Closing dialog" 
                                              : " "}
                                            </div>
                                              <Stack horizontal verticalAlign="center" className={styles.modalProfileHeader} data-theme={isDarkMode ? "dark" : ""}>
                                                  <Stack horizontalAlign="center" verticalAlign="center" style={{ display: 'block', margin: '0 auto' }}>
                                                      <img src={isDarkMode? branding?.header_right_image_darkmode : branding?.dialog_logo} aria-hidden="true" tabIndex={-1} alt="Brand Logo" 
                                                      className={styles.headerIconRight}  />
                                                  </Stack>
                                                  <div id="knowledgeSelect-close" role="button" tabIndex={0} aria-label="Close Knowledge Base" title="Close Knowledge Base"
                                                      onClick={() => {closeKnowledgeBase()}} onKeyDown={(e)=>{if(e.key === 'Enter' || e.key === ' ') {closeKnowledgeBase()}}} className={closeXModalProfileTranslatable}><CloseIcon fill="var(--YW_SignIn_Modal_Close_Icon_Color)"/></div> 

                                              </Stack>
                                              <Stack horizontal horizontalAlign="center" style={{alignItems:'flex-start', flexFlow: 'column'}}>


                                                {/* Knowledge Base Dropdown */}
                                                <Stack tokens={{ childrenGap: 10 }} style={{ width: '100%' }}>
                                                  <Stack tabIndex={0} aria-label="Select a document from the knowledge base" horizontalAlign="start" verticalAlign="center" className={styles.modalProfileSubHeader}>Knowledge Base</Stack>
                                                    <KnowledgeDropdown
                                                      ref={knowledgeDropdownRef}
                                                      selectedDocument={selectedDocument}
                                                      onDocumentChange={handleDocumentSelection}
                                                      placeholder="Select a document..."
                                                      clearButtonLabel="Clear input"
                                                      onEscapeKeyPressed={handleKnowledgeBaseEscape}
                                                      modalContainerSelector={`.${styles.modalContainer}`}
                                                      pgm={configCode}
                                                    />
                                                    <Stack horizontalAlign="start" verticalAlign="center"> 
                                                        <CommandBarButton
                                                            role="button"
                                                            className={styles.submitLoginButtonAuth}
                                                            onClick={handleKnowledgeSubmit}
                                                            text="VIEW DOCUMENT"
                                                            aria-label="View Selected Document"
                                                            title="View Selected Document"
                                                            disabled={!selectedDocument}
                                                        />
                                                    </Stack>
                                                  </Stack>
                                                </Stack>
                                            </Stack>
                                        </div>
                                    </FocusTrap>
                                  </SlidingPane>
                                )}

                                {caseSelectDialogOpen && (
                                  <SlidingPane
                                      className={`${styles.spCustomProfile} auth-slide-pane`}
                                      isOpen={caseSelectDialogOpen}
                                      from={"bottom"}
                                      width={window.innerWidth >= 992 ? "30%" : "100%"}
                                      hideHeader
                                      onRequestClose={() => { handleCaseSelectDialogClose(); }}
                                  >
                                    <FocusTrap
                                        active={caseSelectDialogOpen && isFocusTrapActive && !isFocusTrapPaused} // Deactivate FocusTrap if dropdown is being interacted with
                                      focusTrapOptions={{
                                          clickOutsideDeactivates: true,
                                          escapeDeactivates: true,
                                          returnFocusOnDeactivate: false,
                                          initialFocus: false,
                                          fallbackFocus: () => document.getElementById("caseSelect-close") || document.body,
                                          onActivate: () => setIsOtherFocusTrapOpen(true),
                                          onDeactivate: () => {
                                            setIsOtherFocusTrapOpen(false)
                                            if (isProfilePaneOpen){
                                              document.getElementById("profile-close")?.focus();
                                            } else {
                                              document.getElementById("sign-in-out-icon")?.focus() || document.getElementById("additional-chat-options")?.focus();
                                            }
                                          }
                                        }}
                                    >
                                      <div className={styles.profileModalMain}data-theme={isDarkMode ? "dark" : ""}>
                                          <Stack className={styles.modalContainer} data-theme={isDarkMode ? "dark" : ""}>
                                           {/* Status announcements for screen readers */}
                                            <div
                                              aria-live="assertive"
                                              aria-atomic="true"
                                              className={styles.visuallyHidden}
                                            >
                                              {isLoading ? "Loading" : 
                                              isVerified ? "Loading complete. Closing dialog" 
                                              : " "}
                                            </div>
                                            {isLoading && <Loading/>}
                                            {isVerified && <Verified/>}
                                              <Stack horizontal verticalAlign="center" className={styles.modalProfileHeader} data-theme={isDarkMode ? "dark" : ""}>
                                                  <Stack horizontalAlign="center" verticalAlign="center" style={{ display: 'block', margin: '0 auto' }}>
                                                      <img src={isDarkMode ? branding?.dialog_logo_darkmode : branding?.dialog_logo} aria-hidden="true" tabIndex={-1} alt="Brand Logo" 
                                                      className={styles.modalProfileIcon}  />
                                                  </Stack>
                                                  <div id="caseSelect-close" role="button" tabIndex={0} aria-label="Close Case Selection" title="Close Case Selection"
                                                      onClick={() => {handleCaseSelectDialogClose()}} onKeyDown={(e)=>{if(e.key === 'Enter' || e.key === ' ') {handleCaseSelectDialogClose()}}} className={closeXModalProfile}><CloseIcon fill="var(--YW_SignIn_Modal_Close_Icon_Color)"/></div> 

                                              </Stack>
                                              <Stack horizontal horizontalAlign="center" style={{alignItems:'flex-start', flexFlow: 'column'}}>
                                                {/* Case Selection Dropdown */}
                                                <Stack tokens={{ childrenGap: 10 }} style={{ width: '100%' }}>
                                                  <Stack tabIndex={0} aria-label={branding?.multiple_case_message} horizontalAlign="start" verticalAlign="center" className={styles.modalProfileSubHeader}>{branding?.multiple_case_message}</Stack>
                                                    <CaseDropdown
                                                      selectedCase={selectedDropdownCase}
                                                      casesString={casesVal}
                                                      caseNumbersAndNamesVal={caseNumbersAndNamesVal}
                                                      onCaseChange={setSelectedDropdownCase}
                                                      memberFirstNames={memberFirstNames}
                                                    />
                                                    <Stack horizontalAlign="start" verticalAlign="center"> 
                                                        <CommandBarButton
                                                            role="button"
                                                            className={styles.submitLoginButtonAuth}
                                                            onClick={handleSubmit}
                                                            text="SUBMIT"
                                                            aria-label="SUBMIT"
                                                            title="SUBMIT"
                                                            disabled={!selectedDropdownCase || selectedDropdownCase === activeCase}
                                                        />
                                                    </Stack>
                                                  </Stack>
                                                </Stack>
                                            </Stack>
                                        </div>
                                    </FocusTrap>
                                  </SlidingPane>
                                )}
                                {addCaseDialogOpen && (
                                  <SlidingPane
                                    className={`${styles.spCustomProfile} auth-slide-pane`}
                                    isOpen={addCaseDialogOpen}
                                    from={"bottom"}
                                    width={window.innerWidth >= 992 ? "30%" : "100%"}
                                    hideHeader
                                    onRequestClose={() => { handleAddCaseDialogClose(); }}
                                  >
                                    <FocusTrap
                                      active={addCaseDialogOpen && isFocusTrapActive && !isFocusTrapPaused} // Deactivate FocusTrap if dropdown is being interacted with
                                      focusTrapOptions={{
                                        clickOutsideDeactivates: true,
                                        escapeDeactivates: true,
                                        returnFocusOnDeactivate: false,
                                        initialFocus: false,
                                        fallbackFocus: () => document.getElementById("addCase-close") || document.body,
                                        onActivate: () => setIsOtherFocusTrapOpen(true),
                                        onDeactivate: () => {
                                          setIsOtherFocusTrapOpen(false)
                                          if (isProfilePaneOpen){
                                            document.getElementById("profile-close")?.focus();
                                          } else {
                                            document.getElementById("sign-in-out-icon")?.focus() || document.getElementById("additional-chat-options")?.focus();
                                          }
                                        }
                                      }}
                                    >
                                      <div className={styles.profileModalMain}data-theme={isDarkMode ? "dark" : ""}>
                                          <Stack className={styles.modalContainer} data-theme={isDarkMode ? "dark" : ""}>
                                           {/* Status announcements for screen readers */}
                                            <div
                                              aria-live="assertive"
                                              aria-atomic="true"
                                              className={styles.visuallyHidden}
                                            >
                                              {isLoading ? "Loading" : 
                                              isVerified ? "Loading complete." 
                                              : " "}
                                            </div>
                                            {isLoading && <Loading/>}
                                            {isVerified && <Verified/>}
                                              <Stack horizontal verticalAlign="center" className={styles.modalProfileHeader} data-theme={isDarkMode ? "dark" : ""}>
                                                  <Stack horizontalAlign="center" verticalAlign="center" style={{ display: 'block', margin: '0 auto' }}>
                                                      <img src={isDarkMode ? branding?.dialog_logo_darkmode : branding?.dialog_logo} aria-hidden="true" tabIndex={-1} alt="Brand Logo" 
                                                      className={styles.modalProfileIcon}  />
                                                  </Stack>
                                                  <div id="addCase-close" role="button" tabIndex={0} aria-label="Close Add Case Dialog" title="Close Add Case Dialog"
                                                      onClick={() => {handleAddCaseDialogClose()}} onKeyDown={(e)=>{if(e.key === 'Enter' || e.key === ' ') {handleAddCaseDialogClose()}}} className={closeXModalProfile}><CloseIcon fill="var(--YW_SignIn_Modal_Close_Icon_Color)"/></div> 

                                              </Stack>
                                              <Stack horizontal horizontalAlign="center" style={{alignItems:'flex-start', flexFlow: 'column'}}>
                                                {/* 'Add a new case' Input Field */}
                                                <Stack tokens={{ childrenGap: 10 }} style={{ width: '100%' }}>
                                                  <Stack tabIndex={0} aria-label="Add a new case" horizontalAlign="start" verticalAlign="center" className={styles.modalProfileSubHeader}>Add a new case</Stack>
                                                  <Stack horizontal horizontalAlign="start" data-theme={isDarkMode ? "dark" : ""} className={styles.modalProfilePlacement} >
                                                    <Stack horizontalAlign="start" verticalAlign="center">
                                                        <div className={styles.modalProfileTextContainer}>
                                                            <label htmlFor="caseNumber">Case Number</label>
                                                            <input 
                                                              id="caseNumber" 
                                                              type="text"
                                                              disabled={isLoading}
                                                              style={{
                                                                  color: "var(--YW_SignIn_Modal_UserID_Text_Font_Color)",
                                                                  fontFamily: "var(--YW_Theme_Font_Type)",
                                                                  fontSize: `calc(var(--YW_SignIn_Modal_UserID_Text_Font_Size) + 2px)`,
                                                                  backgroundColor: "var(--YW_SignIn_Modal_UserID_TextBox_Color)",
                                                                  fontStyle: "var(--YW_Theme_Font_Style)",
                                                                  }}
                                                              onChange={onCaseFieldValChange}
                                                              value={caseInputFieldsVal}
                                                              onKeyDown={e => {
                                                                if ((e.key === "Enter" || e.key === " ") && !isLoading) {
                                                                  e.preventDefault();
                                                                  handleSubmitCase();
                                                                }
                                                              }}></input>
                                                        </div>
                                                    </Stack>
                                                </Stack>
                                                    <label aria-live="polite" aria-atomic="true" id="text5Error" className={styles.modalCaseError} style={{ display: text5Error === "" ? 'none' : 'block', marginTop: '0px' }}>{text5Error}</label>
                                                    <Stack horizontalAlign="start" verticalAlign="center"> 
                                                        <CommandBarButton
                                                            role="button"
                                                            className={styles.submitLoginButtonAuth}
                                                            onClick={handleSubmitCase}
                                                            text="SUBMIT"
                                                            aria-label="SUBMIT"
                                                            title="SUBMIT"
                                                            disabled={isLoading || caseInputFieldsVal.trim() === ""}
                                                        />
                                                    </Stack>
                                                  </Stack>
                                                </Stack>
                                            </Stack>
                                        </div>
                                    </FocusTrap>
                                  </SlidingPane>
                                )}

                                {releaseNotesOpen && (
                                  <SlidingPane
                                    className={`${styles.spCustomProfile} ${styles.spReleaseNotesModal} auth-slide-pane`}
                                    isOpen={releaseNotesOpen}
                                    from={"bottom"}
                                    width={window.innerWidth >= 992 ? "30%" : "100%"}
                                    hideHeader
                                    onRequestClose={() => { closeReleaseNotes(); }}
                                  >
                                    <FocusTrap
                                      active={releaseNotesOpen && isFocusTrapActive && !isFocusTrapPaused} // Deactivate FocusTrap if dropdown is being interacted with
                                      focusTrapOptions={{
                                        clickOutsideDeactivates: true,
                                        escapeDeactivates: true,
                                        returnFocusOnDeactivate: false,
                                        initialFocus: false,
                                        fallbackFocus: () => document.getElementById("releaseNotes-close") || document.body,
                                        onActivate: () => setIsOtherFocusTrapOpen(true),
                                        onDeactivate: () => {
                                          setIsOtherFocusTrapOpen(false);
                                          document.getElementById("release-notes")?.focus();
                                        }
                                      }}
                                    >
                                      <div className={styles.profileModalMain} data-theme={isDarkMode ? "dark" : ""}>
                                          <Stack className={styles.modalContainer} data-theme={isDarkMode ? "dark" : ""}>
                                              <Stack horizontal verticalAlign="center" className={styles.modalProfileHeader} data-theme={isDarkMode ? "dark" : ""}>
                                                  <Stack horizontalAlign="center" verticalAlign="center" style={{ display: 'block', margin: '0 auto' }}>
                                                      <img src={isDarkMode ? branding?.dialog_logo_darkmode : branding?.dialog_logo} aria-hidden="true" tabIndex={-1} alt="Brand Logo" 
                                                      className={styles.modalProfileIcon}/>
                                                  </Stack>
                                                  <div id="releaseNotes-close" role="button" tabIndex={0} aria-label="Close Release Notes Dialog" title="Close Release Notes Dialog"
                                                      onClick={() => {closeReleaseNotes()}} onKeyDown={(e)=>{if(e.key === 'Enter' || e.key === ' ') {closeReleaseNotes()}}} className={closeXModalProfile}><CloseIcon fill="var(--YW_SignIn_Modal_Close_Icon_Color)"/></div> 

                                              </Stack>
                                              <Stack horizontal horizontalAlign="center" style={{alignItems:'flex-start', flexFlow: 'column'}}>
                                                {/* Release Notes Modal Body */}
                                                <Stack tokens={{ childrenGap: 10 }} style={{ width: '100%' }}>
                                                  <Stack tabIndex={0} aria-label="Release Notes" horizontalAlign="start" verticalAlign="center" style={{ fontWeight: 'bold' }} className={styles.modalProfileSubHeader}>Release Notes</Stack>
                                                  <div className={styles.releaseNotesContent} style={{ whiteSpace: 'pre-line'}} tabIndex={0}>
                                                      {releaseNotesModalMessage} {releaseDate}
                                                  </div>
                                                  <div className={styles.releaseNotesButtonContainer}>
                                                      <CommandBarButton
                                                        type="button"
                                                        className={styles.releaseNotesButton}
                                                        onClick={handleViewReleaseNotes}
                                                        aria-label="VIEW NOTES"
                                                        title="VIEW NOTES"
                                                      >
                                                        VIEW NOTES
                                                      </CommandBarButton>
                                                  </div>
                                                </Stack>
                                              </Stack>
                                            </Stack>
                                        </div>
                                    </FocusTrap>
                                  </SlidingPane>
                                )}
                            
                          
                            {branding?.telephony_api !== "" &&
                            <FocusTrap
                                active={showTelephonyWidget && !isFocusTrapPaused}
                                focusTrapOptions={{
                                    clickOutsideDeactivates: true,
                                    escapeDeactivates: true,
                                    returnFocusOnDeactivate: false,
                                    onActivate: () => setIsOtherFocusTrapOpen(true),
                                    onDeactivate: () => {document.getElementById("question-input-textarea")?.focus(); setIsOtherFocusTrapOpen(false)},
                                    initialFocus: false,
                                    fallbackFocus: () => document.getElementById("telephonyIframe") || document.body,
                                }}
                            >
                                <div id="telephony-iframe-div" tabIndex={0} style={{
                                    display: showTelephonyWidget ? "block" : "none", overflow: "visible", position: "fixed", right: window === window.parent ? "10px" : "0px", zIndex: '99', borderRadius: '10px',
                                    width: showTelephonyWidget ? windowSize.width > 600 ? "390px" : "100vw" : '0px',
                                    height: showTelephonyWidget
                                        ? (windowSize.width > 600
                                            ? Math.min(620, windowSize.height - 150) + "px"
                                            : "90vh")
                                        : '0px',
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                }}>
                            
                            <iframe id="telephonyIframe" role="application" aria-label="Widget" title="Widget" allow="clipboard-read; clipboard-write"
                                tabIndex={0}
                                src={branding?.telephony_api}
                                width={"100%"}
                                height={"100%"}
                                style={{
                                    borderRadius: '10px',
                                    display: 'block',
                                    margin: '0 auto',
                                }}
                            ></iframe></div></FocusTrap>}
                             {branding?.copilot_flowdisplay_inwidget === "Y" &&
                             <FocusTrap
                                active={showCopilotWidget && !isFocusTrapPaused}
                                focusTrapOptions={{
                                    clickOutsideDeactivates: true,
                                    escapeDeactivates: true,
                                    returnFocusOnDeactivate: true,
                                    initialFocus: () => {
                                      setTimeout(() => {
                                        const copilotIframe = document.getElementById("copilotIframe");
                                          if (copilotIframe) {
                                            copilotIframe.focus();
                                          }
                                      }, 200);}, 
                                    fallbackFocus: () => document.getElementById("copilotIframe") || document.body,
                                    onActivate: () => setIsOtherFocusTrapOpen(true),
                                    onDeactivate: () => {
                                        setIsOtherFocusTrapOpen(false)
                                      if (branding?.telephony_api) {
                                        setTimeout(() => {
                                          const telephonyIframe = document.getElementById("telephonyIframe");
                                          if (telephonyIframe) {
                                            telephonyIframe.focus();
                                          }
                                        }, 600);
                                      }
                                    }
                                }}
                             >
                                <div id="copilot-iframe-div" style={{
                                    display: showCopilotWidget ? "block" : "none", overflow: "visible", position: "fixed", right: window === window.parent ? "10px" : "0px", zIndex: '99', borderRadius: '10px',
                                    width: showCopilotWidget ? windowSize.width > 600 ? "390px" : "100vw" : '0px',
                                    height: showCopilotWidget
                                        ? (windowSize.width > 600
                                            ? Math.min(620, windowSize.height - 150) + "px"
                                            : "90vh")
                                        : '0px',
                                    top: "50%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)"
                                }}>
                            
                            <iframe id="copilotIframe" role="application" aria-label="Widget" title="Widget" 
                                allow="clipboard-read; clipboard-write; fullscreen; geolocation"
                                allowFullScreen
                                tabIndex={0}
                                //src={"http://127.0.0.1:50505"} //for local testing
                                src={branding?.copilot_flowdisplay_api}
                                width={"100%"}
                                height={"100%"}
                                style={{
                                    borderRadius: '10px',
                                    display: 'block',
                                    margin: '0 auto',
                                }}
                            ></iframe></div></FocusTrap>}
                            {branding?.show_widget === "Y" && (window  === window.parent) &&
                            <div onClick={() => { if (!popUpBlocker) toggleWidget(true); }} 
                            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { if (!popUpBlocker) toggleWidget(true); }}}>
                                {!showWidget && 
                                <Stack horizontalAlign="end" style={{cursor: popUpBlocker ? 'not-allowed' : 'pointer'}} onClick={() => { if (!popUpBlocker) toggleWidget(true); }}> 
                                            <img tabIndex={0} src={WidgetIcon} aria-label="Widget" alt="Widget" title="Widget" 
                                                style={{ 
                                                    width: "50px", 
                                                    position: "fixed", 
                                                    right: isFAQPaneOpen ? "0px" : isCitationPanelOpen ? "25%" : "12%", 
                                                    bottom: "150px", 
                                                    cursor: popUpBlocker ? 'not-allowed' : 'pointer' // Inherit cursor style from parent
                                                }}                                        
                                            />
                                </Stack>
                               }
                                  
                                    <div style={{
                                        display: showWidget ? "block" : "none", overflow: "visible", position: "fixed", right: "0px",  zIndex: '99', borderRadius: '10px',
                                        width: showWidget ? windowSize.width > 600 ? "390px" : "100vw" : '0px', 
                                        height: showWidget 
                                        ? (windowSize.width > 600 
                                            ? Math.min(620, windowSize.height - 150) + "px" 
                                            : "90vh") 
                                        : '0px', 
                                        top: windowSize.width > 600 ? "100px" : "0px",
                                    }}>                                      
                                        <iframe id="widgetIframe" aria-label="Widget" title="Widget" allow="clipboard-read; clipboard-write; microphone"
                                            src={branding?.widget_url}
                                            // src={"http://127.0.0.1:50505/"} // For local testing                   
                                            width={"100%"} height={"100%"}
                                            style={iframeStyles}                                            
                                            onMouseEnter={() => {
                                                setIsInIframe(true);
                                            }}
                                            onMouseLeave={() => {
                                                setIsInIframe(false);
                                            }}
                                        ></iframe>
                                        </div> 
                                        
                                    {/* <div style={{ display: "block", overflow: "hidden", width: showWidget ? "390px" : '0px', height: showWidget ? "568px" : '0px', position: "absolute", right: "0px", top: "200px", zIndex: '99', borderRadius: '10px' }}>
                                        <iframe src="https://copilotstudio.microsoft.com/environments/Default-a9da7604-1c69-4ade-87ae-5b5089bec8b8/bots/cr59f_vaTest/webchat?__version__=2" style={{width:'100%', height:'100%'}}></iframe>
                                    </div> */}
                            </div>
                            }
                              <FocusTrap
                                  active={showTranslate && !isFocusTrapPaused}
                                  focusTrapOptions={
                                    {
                                      clickOutsideDeactivates: true,
                                      escapeDeactivates: true,
                                      returnFocusOnDeactivate: true,
                                      initialFocus: () => document.getElementById("google-translate"),
                                      onActivate: () => setIsOtherFocusTrapOpen(true),
                                      onDeactivate: () => setIsOtherFocusTrapOpen(false),
                                    }
                                  }
                              >
                            <div className={styles.langOverlay} style={{ visibility: showTranslate ? 'visible' : 'hidden' }}>
                            <div data-theme={isDarkMode ? "dark" : ""} className={styles.langModal}
                            style={{ visibility: showTranslate? 'visible': 'hidden'}}>
                             
                                <Stack className={styles.modalContainer} data-theme={isDarkMode ? "dark" : ""}>
                                    <Stack horizontal verticalAlign="center" horizontalAlign="baseline" data-theme={isDarkMode ? "dark" : ""}>
                                        <div className={styles.dialogTitle} data-theme={isDarkMode ? "dark" : ""}>{"Select a language"}</div>
                                    </Stack>
                                    <Stack id="google-translate" horizontalAlign="end" verticalAlign="center" tabIndex={0} role="button" aria-label="Close Language Selection" title="Close Language Selection"
                                        onClick={handleTranslateDialogClose} className={closeXLangModal} onKeyDown={(e)=>{
                                            if(e.key === "Enter" || e.key === " ") {handleTranslateDialogClose();}
                                        }}><CloseIcon />
                                    </Stack>
                                </Stack>
                                    <Stack horizontal verticalAlign="center" horizontalAlign="baseline" data-theme={isDarkMode ? "dark" : ""}>
                                        <Stack horizontal horizontalAlign="start" data-theme={isDarkMode ? "dark" : ""}>
                                            <div data-theme={isDarkMode ? "dark" : ""} style={{ padding: '10px' }}>
                                                <GoogleTranslate darkmode={isDarkMode} branding={branding} configLanguages={configLanguages}/>

                                            </div>
                                        </Stack>
                                    </Stack>
                            </div>
                          </div>
                          </FocusTrap>
                    </div>
                        {messages && messages.length > 0 && isIntentsPanelOpen && (
                            <Stack.Item className={styles.citationPanel} tabIndex={0} role="tabpanel" aria-label="Intents Panel">
                                <Stack
                                    aria-label="Intents Panel Header Container"
                                    horizontal
                                    className={styles.citationPanelHeaderContainer}
                                    horizontalAlign="space-between"
                                    verticalAlign="center">
                                    <span aria-label="Intents" className={styles.citationPanelHeader}>
                                        Intents
                                    </span>
                                    <IconButton
                                        iconProps={{ iconName: 'Cancel' }}
                                        aria-label="Close intents panel"
                                        onClick={() => setIsIntentsPanelOpen(false)}
                                    />
                                </Stack>
                                <Stack horizontalAlign="space-between">
                                    {execResults.map((execResult) => {
                                        return (
                                            <Stack className={styles.exectResultList} verticalAlign="space-between">
                                                <><span>Intent:</span> <p>{execResult.intent}</p></>
                                                {execResult.search_query && <><span>Search Query:</span>
                                                    <SyntaxHighlighter
                                                        style={nord}
                                                        wrapLines={true}
                                                        lineProps={{ style: { wordBreak: 'break-all', whiteSpace: 'pre-wrap' } }}
                                                        language="sql"
                                                        PreTag="p">
                                                        {execResult.search_query}
                                                    </SyntaxHighlighter></>}
                                                {execResult.search_result && <><span>Search Result:</span> <p>{execResult.search_result}</p></>}
                                                {execResult.code_generated && <><span>Code Generated:</span>
                                                    <SyntaxHighlighter
                                                        style={nord}
                                                        wrapLines={true}
                                                        lineProps={{ style: { wordBreak: 'break-all', whiteSpace: 'pre-wrap' } }}
                                                        language="python"
                                                        PreTag="p">
                                                        {execResult.code_generated}
                                                    </SyntaxHighlighter>
                                                </>}
                                            </Stack>
                                        )
                                    })}
                                </Stack>
                            </Stack.Item>
                        )}
                     {(appStateContext?.state.isChatHistoryOpen && appStateContext?.state.isCosmosDBAvailable?.status !== CosmosDBStatus.NotConfigured) && <ChatHistoryPanel/>}
                </Stack>
                </B2CAuthGate>
            )}
        {hasOpenedAdmin && adminAppUrl && (
            <div
                className={`${styles.adminOverlay} ${!isAdminOverlayOpen ? styles.adminOverlayHidden : ""}`}
                role="dialog"
                aria-modal={isAdminOverlayOpen}
                aria-label="Admin App"
                aria-hidden={!isAdminOverlayOpen}
            >
                <div
                    className={`${styles.adminOverlayLoading} ${adminIframeLoaded ? styles.adminOverlayLoadingDone : ""}`}
                    aria-hidden={adminIframeLoaded}
                >
                    <Spinner size={SpinnerSize.large} label="Loading..." />
                </div>
                <iframe
                    src={adminIframeSrc}
                    className={styles.adminOverlayIframe}
                    title="Admin App"
                />
            </div>
        )}
        {powerBI.hasOpenedPowerBI && (
            <PowerBIOverlay
                isOpen={powerBI.isPowerBIOverlayOpen}
                iframeLoaded={powerBI.powerBIIframeLoaded}
                error={powerBI.powerBIError}
                embedConfig={powerBI.powerBIEmbedConfig}
                onClose={powerBI.closePowerBIOverlay}
                onEmbedLoaded={powerBI.handlePowerBIEmbedLoaded}
                onEmbedError={powerBI.handlePowerBIEmbedError}
                onGetEmbeddedComponent={powerBI.setPowerBIReport}
                onFocusTrapChange={setIsFocusTrapPaused}
            />
        )}
        </div>
    );
};
// #endregion


export default Chat;
